
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire554f"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire554f"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("avKtN", function(module, exports) {
"use strict";

});

parcelRegister("9oYre", function(module, exports) {

$parcel$export(module.exports, "memoize", () => $25e36c1a2919c554$export$fc10aeed3a532e2a);
$parcel$export(module.exports, "findMax", () => $25e36c1a2919c554$export$35f577b3da447d17);
$parcel$export(module.exports, "isNil", () => $25e36c1a2919c554$export$984f70f9382f5d27);
$parcel$export(module.exports, "tryReject", () => $25e36c1a2919c554$export$2b1d356120d119e3);
$parcel$export(module.exports, "moveItemToTop", () => $25e36c1a2919c554$export$25473e0315776b8e);
$parcel$export(module.exports, "tryCatch", () => $25e36c1a2919c554$export$d234c058d1d4e435);
$parcel$export(module.exports, "isNotEmpty", () => $25e36c1a2919c554$export$a079a83b07f794bf);
const $25e36c1a2919c554$export$fc10aeed3a532e2a = (fn)=>{
    const cache = {};
    return (value, ...rest)=>{
        if (value in cache) return cache[value];
        return cache[value] = fn(value, ...rest);
    };
};
const $25e36c1a2919c554$export$35f577b3da447d17 = (valueFn, array)=>array.reduce((current, item)=>valueFn(item) > valueFn(current) ? item : current);
const $25e36c1a2919c554$export$5fd5031fecdacec3 = (a)=>a.length ? [
        a[0]
    ] : [];
const $25e36c1a2919c554$export$c58417706a208278 = ([, ...b])=>b;
const $25e36c1a2919c554$export$8793edee2d425525 = ()=>{};
const $25e36c1a2919c554$export$984f70f9382f5d27 = (x)=>x == null;
const $25e36c1a2919c554$export$2b1d356120d119e3 = (fn)=>{
    try {
        fn();
    } catch (error) {
        Promise.reject(error);
    }
};
const $25e36c1a2919c554$export$25473e0315776b8e = (arr, n)=>{
    if (n < 0 || n >= arr.length) throw new Error("Index out of bounds");
    const item = arr.splice(n, 1)[0]; // Remove the item at index n and get it
    arr.unshift(item); // Add the item to the beginning of the array
    return arr;
};
const $25e36c1a2919c554$export$d234c058d1d4e435 = (doFn, catchFn)=>{
    try {
        return doFn();
    } catch (error) {
        return catchFn(error);
    }
};
const $25e36c1a2919c554$export$f0954fd7d5368655 = (x)=>x;
const $25e36c1a2919c554$export$a079a83b07f794bf = (x)=>x ? x.length !== 0 : true;

});

parcelRegister("fhlbu", function(module, exports) {

var $fFLF8 = parcelRequire("fFLF8");
module.exports = $fFLF8("jzgy2").then(()=>parcelRequire("hCNrh"));

});
parcelRegister("fFLF8", function(module, exports) {
"use strict";

function $b68fa81b3a6ebff4$var$load(id) {
    // eslint-disable-next-line no-undef
    return import((parcelRequire("fCemW")).resolve(id));
}
module.exports = $b68fa81b3a6ebff4$var$load;

});


parcelRegister("6xxtQ", function(module, exports) {

var $fFLF8 = parcelRequire("fFLF8");
module.exports = $fFLF8("9iOxk").then(()=>parcelRequire("1LWBC"));

});

/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $e5ed8027d647799b$var$t = globalThis, $e5ed8027d647799b$var$i = $e5ed8027d647799b$var$t.trustedTypes, $e5ed8027d647799b$var$s = $e5ed8027d647799b$var$i ? $e5ed8027d647799b$var$i.createPolicy("lit-html", {
    createHTML: (t)=>t
}) : void 0, $e5ed8027d647799b$var$e = "$lit$", $e5ed8027d647799b$var$h = `lit$${Math.random().toFixed(9).slice(2)}$`, $e5ed8027d647799b$var$o = "?" + $e5ed8027d647799b$var$h, $e5ed8027d647799b$var$n = `<${$e5ed8027d647799b$var$o}>`, $e5ed8027d647799b$var$r = document, $e5ed8027d647799b$var$l = ()=>$e5ed8027d647799b$var$r.createComment(""), $e5ed8027d647799b$var$c = (t)=>null === t || "object" != typeof t && "function" != typeof t, $e5ed8027d647799b$var$a = Array.isArray, $e5ed8027d647799b$var$u = (t)=>$e5ed8027d647799b$var$a(t) || "function" == typeof t?.[Symbol.iterator], $e5ed8027d647799b$var$d = "[ 	\n\f\r]", $e5ed8027d647799b$var$f = /<(?:(!--|\/[^a-zA-Z])|(\/?[a-zA-Z][^>\s]*)|(\/?$))/g, $e5ed8027d647799b$var$v = /-->/g, $e5ed8027d647799b$var$_ = />/g, $e5ed8027d647799b$var$m = RegExp(`>|${$e5ed8027d647799b$var$d}(?:([^\\s"'>=/]+)(${$e5ed8027d647799b$var$d}*=${$e5ed8027d647799b$var$d}*(?:[^ \t\n\f\r"'\`<>=]|("|')|))|$)`, "g"), $e5ed8027d647799b$var$p = /'/g, $e5ed8027d647799b$var$g = /"/g, $e5ed8027d647799b$var$$ = /^(?:script|style|textarea|title)$/i, $e5ed8027d647799b$var$y = (t)=>(i, ...s)=>({
            _$litType$: t,
            strings: i,
            values: s
        }), $e5ed8027d647799b$export$c0bb0b647f701bb5 = $e5ed8027d647799b$var$y(1), $e5ed8027d647799b$export$7ed1367e7fa1ad68 = $e5ed8027d647799b$var$y(2), $e5ed8027d647799b$export$9c068ae9cc5db4e8 = Symbol.for("lit-noChange"), $e5ed8027d647799b$export$45b790e32b2810ee = Symbol.for("lit-nothing"), $e5ed8027d647799b$var$A = new WeakMap, $e5ed8027d647799b$var$E = $e5ed8027d647799b$var$r.createTreeWalker($e5ed8027d647799b$var$r, 129);
function $e5ed8027d647799b$var$C(t, i) {
    if (!Array.isArray(t) || !t.hasOwnProperty("raw")) throw Error("invalid template strings array");
    return void 0 !== $e5ed8027d647799b$var$s ? $e5ed8027d647799b$var$s.createHTML(i) : i;
}
const $e5ed8027d647799b$var$P = (t, i)=>{
    const s = t.length - 1, o = [];
    let r, l = 2 === i ? "<svg>" : "", c = $e5ed8027d647799b$var$f;
    for(let i = 0; i < s; i++){
        const s = t[i];
        let a, u, d = -1, y = 0;
        for(; y < s.length && (c.lastIndex = y, u = c.exec(s), null !== u);)y = c.lastIndex, c === $e5ed8027d647799b$var$f ? "!--" === u[1] ? c = $e5ed8027d647799b$var$v : void 0 !== u[1] ? c = $e5ed8027d647799b$var$_ : void 0 !== u[2] ? ($e5ed8027d647799b$var$$.test(u[2]) && (r = RegExp("</" + u[2], "g")), c = $e5ed8027d647799b$var$m) : void 0 !== u[3] && (c = $e5ed8027d647799b$var$m) : c === $e5ed8027d647799b$var$m ? ">" === u[0] ? (c = r ?? $e5ed8027d647799b$var$f, d = -1) : void 0 === u[1] ? d = -2 : (d = c.lastIndex - u[2].length, a = u[1], c = void 0 === u[3] ? $e5ed8027d647799b$var$m : '"' === u[3] ? $e5ed8027d647799b$var$g : $e5ed8027d647799b$var$p) : c === $e5ed8027d647799b$var$g || c === $e5ed8027d647799b$var$p ? c = $e5ed8027d647799b$var$m : c === $e5ed8027d647799b$var$v || c === $e5ed8027d647799b$var$_ ? c = $e5ed8027d647799b$var$f : (c = $e5ed8027d647799b$var$m, r = void 0);
        const x = c === $e5ed8027d647799b$var$m && t[i + 1].startsWith("/>") ? " " : "";
        l += c === $e5ed8027d647799b$var$f ? s + $e5ed8027d647799b$var$n : d >= 0 ? (o.push(a), s.slice(0, d) + $e5ed8027d647799b$var$e + s.slice(d) + $e5ed8027d647799b$var$h + x) : s + $e5ed8027d647799b$var$h + (-2 === d ? i : x);
    }
    return [
        $e5ed8027d647799b$var$C(t, l + (t[s] || "<?>") + (2 === i ? "</svg>" : "")),
        o
    ];
};
class $e5ed8027d647799b$var$V {
    constructor({ strings: t, _$litType$: s }, n){
        let r;
        this.parts = [];
        let c = 0, a = 0;
        const u = t.length - 1, d = this.parts, [f, v] = $e5ed8027d647799b$var$P(t, s);
        if (this.el = $e5ed8027d647799b$var$V.createElement(f, n), $e5ed8027d647799b$var$E.currentNode = this.el.content, 2 === s) {
            const t = this.el.content.firstChild;
            t.replaceWith(...t.childNodes);
        }
        for(; null !== (r = $e5ed8027d647799b$var$E.nextNode()) && d.length < u;){
            if (1 === r.nodeType) {
                if (r.hasAttributes()) for (const t of r.getAttributeNames())if (t.endsWith($e5ed8027d647799b$var$e)) {
                    const i = v[a++], s = r.getAttribute(t).split($e5ed8027d647799b$var$h), e = /([.?@])?(.*)/.exec(i);
                    d.push({
                        type: 1,
                        index: c,
                        name: e[2],
                        strings: s,
                        ctor: "." === e[1] ? $e5ed8027d647799b$var$k : "?" === e[1] ? $e5ed8027d647799b$var$H : "@" === e[1] ? $e5ed8027d647799b$var$I : $e5ed8027d647799b$var$R
                    }), r.removeAttribute(t);
                } else t.startsWith($e5ed8027d647799b$var$h) && (d.push({
                    type: 6,
                    index: c
                }), r.removeAttribute(t));
                if ($e5ed8027d647799b$var$$.test(r.tagName)) {
                    const t = r.textContent.split($e5ed8027d647799b$var$h), s = t.length - 1;
                    if (s > 0) {
                        r.textContent = $e5ed8027d647799b$var$i ? $e5ed8027d647799b$var$i.emptyScript : "";
                        for(let i = 0; i < s; i++)r.append(t[i], $e5ed8027d647799b$var$l()), $e5ed8027d647799b$var$E.nextNode(), d.push({
                            type: 2,
                            index: ++c
                        });
                        r.append(t[s], $e5ed8027d647799b$var$l());
                    }
                }
            } else if (8 === r.nodeType) {
                if (r.data === $e5ed8027d647799b$var$o) d.push({
                    type: 2,
                    index: c
                });
                else {
                    let t = -1;
                    for(; -1 !== (t = r.data.indexOf($e5ed8027d647799b$var$h, t + 1));)d.push({
                        type: 7,
                        index: c
                    }), t += $e5ed8027d647799b$var$h.length - 1;
                }
            }
            c++;
        }
    }
    static createElement(t, i) {
        const s = $e5ed8027d647799b$var$r.createElement("template");
        return s.innerHTML = t, s;
    }
}
function $e5ed8027d647799b$var$N(t, i, s = t, e) {
    if (i === $e5ed8027d647799b$export$9c068ae9cc5db4e8) return i;
    let h = void 0 !== e ? s._$Co?.[e] : s._$Cl;
    const o = $e5ed8027d647799b$var$c(i) ? void 0 : i._$litDirective$;
    return h?.constructor !== o && (h?._$AO?.(!1), void 0 === o ? h = void 0 : (h = new o(t), h._$AT(t, s, e)), void 0 !== e ? (s._$Co ??= [])[e] = h : s._$Cl = h), void 0 !== h && (i = $e5ed8027d647799b$var$N(t, h._$AS(t, i.values), h, e)), i;
}
class $e5ed8027d647799b$var$S {
    constructor(t, i){
        this._$AV = [], this._$AN = void 0, this._$AD = t, this._$AM = i;
    }
    get parentNode() {
        return this._$AM.parentNode;
    }
    get _$AU() {
        return this._$AM._$AU;
    }
    u(t) {
        const { el: { content: i }, parts: s } = this._$AD, e = (t?.creationScope ?? $e5ed8027d647799b$var$r).importNode(i, !0);
        $e5ed8027d647799b$var$E.currentNode = e;
        let h = $e5ed8027d647799b$var$E.nextNode(), o = 0, n = 0, l = s[0];
        for(; void 0 !== l;){
            if (o === l.index) {
                let i;
                2 === l.type ? i = new $e5ed8027d647799b$var$M(h, h.nextSibling, this, t) : 1 === l.type ? i = new l.ctor(h, l.name, l.strings, this, t) : 6 === l.type && (i = new $e5ed8027d647799b$var$L(h, this, t)), this._$AV.push(i), l = s[++n];
            }
            o !== l?.index && (h = $e5ed8027d647799b$var$E.nextNode(), o++);
        }
        return $e5ed8027d647799b$var$E.currentNode = $e5ed8027d647799b$var$r, e;
    }
    p(t) {
        let i = 0;
        for (const s of this._$AV)void 0 !== s && (void 0 !== s.strings ? (s._$AI(t, s, i), i += s.strings.length - 2) : s._$AI(t[i])), i++;
    }
}
class $e5ed8027d647799b$var$M {
    get _$AU() {
        return this._$AM?._$AU ?? this._$Cv;
    }
    constructor(t, i, s, e){
        this.type = 2, this._$AH = $e5ed8027d647799b$export$45b790e32b2810ee, this._$AN = void 0, this._$AA = t, this._$AB = i, this._$AM = s, this.options = e, this._$Cv = e?.isConnected ?? !0;
    }
    get parentNode() {
        let t = this._$AA.parentNode;
        const i = this._$AM;
        return void 0 !== i && 11 === t?.nodeType && (t = i.parentNode), t;
    }
    get startNode() {
        return this._$AA;
    }
    get endNode() {
        return this._$AB;
    }
    _$AI(t, i = this) {
        t = $e5ed8027d647799b$var$N(this, t, i), $e5ed8027d647799b$var$c(t) ? t === $e5ed8027d647799b$export$45b790e32b2810ee || null == t || "" === t ? (this._$AH !== $e5ed8027d647799b$export$45b790e32b2810ee && this._$AR(), this._$AH = $e5ed8027d647799b$export$45b790e32b2810ee) : t !== this._$AH && t !== $e5ed8027d647799b$export$9c068ae9cc5db4e8 && this._(t) : void 0 !== t._$litType$ ? this.$(t) : void 0 !== t.nodeType ? this.T(t) : $e5ed8027d647799b$var$u(t) ? this.k(t) : this._(t);
    }
    S(t) {
        return this._$AA.parentNode.insertBefore(t, this._$AB);
    }
    T(t) {
        this._$AH !== t && (this._$AR(), this._$AH = this.S(t));
    }
    _(t) {
        this._$AH !== $e5ed8027d647799b$export$45b790e32b2810ee && $e5ed8027d647799b$var$c(this._$AH) ? this._$AA.nextSibling.data = t : this.T($e5ed8027d647799b$var$r.createTextNode(t)), this._$AH = t;
    }
    $(t) {
        const { values: i, _$litType$: s } = t, e = "number" == typeof s ? this._$AC(t) : (void 0 === s.el && (s.el = $e5ed8027d647799b$var$V.createElement($e5ed8027d647799b$var$C(s.h, s.h[0]), this.options)), s);
        if (this._$AH?._$AD === e) this._$AH.p(i);
        else {
            const t = new $e5ed8027d647799b$var$S(e, this), s = t.u(this.options);
            t.p(i), this.T(s), this._$AH = t;
        }
    }
    _$AC(t) {
        let i = $e5ed8027d647799b$var$A.get(t.strings);
        return void 0 === i && $e5ed8027d647799b$var$A.set(t.strings, i = new $e5ed8027d647799b$var$V(t)), i;
    }
    k(t) {
        $e5ed8027d647799b$var$a(this._$AH) || (this._$AH = [], this._$AR());
        const i = this._$AH;
        let s, e = 0;
        for (const h of t)e === i.length ? i.push(s = new $e5ed8027d647799b$var$M(this.S($e5ed8027d647799b$var$l()), this.S($e5ed8027d647799b$var$l()), this, this.options)) : s = i[e], s._$AI(h), e++;
        e < i.length && (this._$AR(s && s._$AB.nextSibling, e), i.length = e);
    }
    _$AR(t = this._$AA.nextSibling, i) {
        for(this._$AP?.(!1, !0, i); t && t !== this._$AB;){
            const i = t.nextSibling;
            t.remove(), t = i;
        }
    }
    setConnected(t) {
        void 0 === this._$AM && (this._$Cv = t, this._$AP?.(t));
    }
}
class $e5ed8027d647799b$var$R {
    get tagName() {
        return this.element.tagName;
    }
    get _$AU() {
        return this._$AM._$AU;
    }
    constructor(t, i, s, e, h){
        this.type = 1, this._$AH = $e5ed8027d647799b$export$45b790e32b2810ee, this._$AN = void 0, this.element = t, this.name = i, this._$AM = e, this.options = h, s.length > 2 || "" !== s[0] || "" !== s[1] ? (this._$AH = Array(s.length - 1).fill(new String), this.strings = s) : this._$AH = $e5ed8027d647799b$export$45b790e32b2810ee;
    }
    _$AI(t, i = this, s, e) {
        const h = this.strings;
        let o = !1;
        if (void 0 === h) t = $e5ed8027d647799b$var$N(this, t, i, 0), o = !$e5ed8027d647799b$var$c(t) || t !== this._$AH && t !== $e5ed8027d647799b$export$9c068ae9cc5db4e8, o && (this._$AH = t);
        else {
            const e = t;
            let n, r;
            for(t = h[0], n = 0; n < h.length - 1; n++)r = $e5ed8027d647799b$var$N(this, e[s + n], i, n), r === $e5ed8027d647799b$export$9c068ae9cc5db4e8 && (r = this._$AH[n]), o ||= !$e5ed8027d647799b$var$c(r) || r !== this._$AH[n], r === $e5ed8027d647799b$export$45b790e32b2810ee ? t = $e5ed8027d647799b$export$45b790e32b2810ee : t !== $e5ed8027d647799b$export$45b790e32b2810ee && (t += (r ?? "") + h[n + 1]), this._$AH[n] = r;
        }
        o && !e && this.j(t);
    }
    j(t) {
        t === $e5ed8027d647799b$export$45b790e32b2810ee ? this.element.removeAttribute(this.name) : this.element.setAttribute(this.name, t ?? "");
    }
}
class $e5ed8027d647799b$var$k extends $e5ed8027d647799b$var$R {
    constructor(){
        super(...arguments), this.type = 3;
    }
    j(t) {
        this.element[this.name] = t === $e5ed8027d647799b$export$45b790e32b2810ee ? void 0 : t;
    }
}
class $e5ed8027d647799b$var$H extends $e5ed8027d647799b$var$R {
    constructor(){
        super(...arguments), this.type = 4;
    }
    j(t) {
        this.element.toggleAttribute(this.name, !!t && t !== $e5ed8027d647799b$export$45b790e32b2810ee);
    }
}
class $e5ed8027d647799b$var$I extends $e5ed8027d647799b$var$R {
    constructor(t, i, s, e, h){
        super(t, i, s, e, h), this.type = 5;
    }
    _$AI(t, i = this) {
        if ((t = $e5ed8027d647799b$var$N(this, t, i, 0) ?? $e5ed8027d647799b$export$45b790e32b2810ee) === $e5ed8027d647799b$export$9c068ae9cc5db4e8) return;
        const s = this._$AH, e = t === $e5ed8027d647799b$export$45b790e32b2810ee && s !== $e5ed8027d647799b$export$45b790e32b2810ee || t.capture !== s.capture || t.once !== s.once || t.passive !== s.passive, h = t !== $e5ed8027d647799b$export$45b790e32b2810ee && (s === $e5ed8027d647799b$export$45b790e32b2810ee || e);
        e && this.element.removeEventListener(this.name, this, s), h && this.element.addEventListener(this.name, this, t), this._$AH = t;
    }
    handleEvent(t) {
        "function" == typeof this._$AH ? this._$AH.call(this.options?.host ?? this.element, t) : this._$AH.handleEvent(t);
    }
}
class $e5ed8027d647799b$var$L {
    constructor(t, i, s){
        this.element = t, this.type = 6, this._$AN = void 0, this._$AM = i, this.options = s;
    }
    get _$AU() {
        return this._$AM._$AU;
    }
    _$AI(t) {
        $e5ed8027d647799b$var$N(this, t);
    }
}
const $e5ed8027d647799b$export$8613d1ca9052b22e = {
    P: $e5ed8027d647799b$var$e,
    A: $e5ed8027d647799b$var$h,
    C: $e5ed8027d647799b$var$o,
    M: 1,
    L: $e5ed8027d647799b$var$P,
    R: $e5ed8027d647799b$var$S,
    D: $e5ed8027d647799b$var$u,
    V: $e5ed8027d647799b$var$N,
    I: $e5ed8027d647799b$var$M,
    H: $e5ed8027d647799b$var$R,
    N: $e5ed8027d647799b$var$H,
    U: $e5ed8027d647799b$var$I,
    B: $e5ed8027d647799b$var$k,
    F: $e5ed8027d647799b$var$L
}, $e5ed8027d647799b$var$Z = $e5ed8027d647799b$var$t.litHtmlPolyfillSupport;
$e5ed8027d647799b$var$Z?.($e5ed8027d647799b$var$V, $e5ed8027d647799b$var$M), ($e5ed8027d647799b$var$t.litHtmlVersions ??= []).push("3.1.4");
const $e5ed8027d647799b$export$b3890eb0ae9dca99 = (t, i, s)=>{
    const e = s?.renderBefore ?? i;
    let h = e._$litPart$;
    if (void 0 === h) {
        const t = s?.renderBefore ?? null;
        e._$litPart$ = h = new $e5ed8027d647799b$var$M(i.insertBefore($e5ed8027d647799b$var$l(), t), t, void 0, s ?? {});
    }
    return h._$AI(t), h;
};


// THIS FILE IS AUTOMATICALLY GENERATED DO NOT EDIT DIRECTLY
// See update-tlds.js for encoding/decoding format
// https://data.iana.org/TLD/tlds-alpha-by-domain.txt
const $c0c895385715e166$var$encodedTlds = "aaa1rp3bb0ott3vie4c1le2ogado5udhabi7c0ademy5centure6ountant0s9o1tor4d0s1ult4e0g1ro2tna4f0l1rica5g0akhan5ency5i0g1rbus3force5tel5kdn3l0ibaba4pay4lfinanz6state5y2sace3tom5m0azon4ericanexpress7family11x2fam3ica3sterdam8nalytics7droid5quan4z2o0l2partments8p0le4q0uarelle8r0ab1mco4chi3my2pa2t0e3s0da2ia2sociates9t0hleta5torney7u0ction5di0ble3o3spost5thor3o0s4vianca6w0s2x0a2z0ure5ba0by2idu3namex3narepublic11d1k2r0celona5laycard4s5efoot5gains6seball5ketball8uhaus5yern5b0c1t1va3cg1n2d1e0ats2uty4er2ntley5rlin4st0buy5t2f1g1h0arti5i0ble3d1ke2ng0o3o1z2j1lack0friday9ockbuster8g1omberg7ue3m0s1w2n0pparibas9o0ats3ehringer8fa2m1nd2o0k0ing5sch2tik2on4t1utique6x2r0adesco6idgestone9oadway5ker3ther5ussels7s1t1uild0ers6siness6y1zz3v1w1y1z0h3ca0b1fe2l0l1vinklein9m0era3p2non3petown5ital0one8r0avan4ds2e0er0s4s2sa1e1h1ino4t0ering5holic7ba1n1re3c1d1enter4o1rn3f0a1d2g1h0anel2nel4rity4se2t2eap3intai5ristmas6ome4urch5i0priani6rcle4sco3tadel4i0c2y3k1l0aims4eaning6ick2nic1que6othing5ud3ub0med6m1n1o0ach3des3ffee4llege4ogne5m0cast4mbank4unity6pany2re3uter5sec4ndos3struction8ulting7tact3ractors9oking4l1p2rsica5untry4pon0s4rses6pa2r0edit0card4union9icket5own3s1uise0s6u0isinella9v1w1x1y0mru3ou3z2dabur3d1nce3ta1e1ing3sun4y2clk3ds2e0al0er2s3gree4livery5l1oitte5ta3mocrat6ntal2ist5si0gn4v2hl2iamonds6et2gital5rect0ory7scount3ver5h2y2j1k1m1np2o0cs1tor4g1mains5t1wnload7rive4tv2ubai3nlop4pont4rban5vag2r2z2earth3t2c0o2deka3u0cation8e1g1mail3erck5nergy4gineer0ing9terprises10pson4quipment8r0icsson6ni3s0q1tate5t1u0rovision8s2vents5xchange6pert3osed4ress5traspace10fage2il1rwinds6th3mily4n0s2rm0ers5shion4t3edex3edback6rrari3ero6i0delity5o2lm2nal1nce1ial7re0stone6mdale6sh0ing5t0ness6j1k1lickr3ghts4r2orist4wers5y2m1o0o0d1tball6rd1ex2sale4um3undation8x2r0ee1senius7l1ogans4ntier7tr2ujitsu5n0d2rniture7tbol5yi3ga0l0lery3o1up4me0s3p1rden4y2b0iz3d0n2e0a1nt0ing5orge5f1g0ee3h1i0ft0s3ves2ing5l0ass3e1obal2o4m0ail3bh2o1x2n1odaddy5ld0point6f2o0dyear5g0le4p1t1v2p1q1r0ainger5phics5tis4een3ipe3ocery4up4s1t1u0ardian6cci3ge2ide2tars5ru3w1y2hair2mburg5ngout5us3bo2dfc0bank7ealth0care8lp1sinki6re1mes5iphop4samitsu7tachi5v2k0t2m1n1ockey4ldings5iday5medepot5goods5s0ense7nda3rse3spital5t0ing5t0els3mail5use3w2r1sbc3t1u0ghes5yatt3undai7ibm2cbc2e1u2d1e0ee3fm2kano4l1m0amat4db2mo0bilien9n0c1dustries8finiti5o2g1k1stitute6urance4e4t0ernational10uit4vestments10o1piranga7q1r0ish4s0maili5t0anbul7t0au2v3jaguar4va3cb2e0ep2tzt3welry6io2ll2m0p2nj2o0bs1urg4t1y2p0morgan6rs3uegos4niper7kaufen5ddi3e0rryhotels6logistics9properties14fh2g1h1i0a1ds2m1ndle4tchen5wi3m1n1oeln3matsu5sher5p0mg2n2r0d1ed3uokgroup8w1y0oto4z2la0caixa5mborghini8er3ncaster6d0rover6xess5salle5t0ino3robe5w0yer5b1c1ds2ease3clerc5frak4gal2o2xus4gbt3i0dl2fe0insurance9style7ghting6ke2lly3mited4o2ncoln4k2psy3ve1ing5k1lc1p2oan0s3cker3us3l1ndon4tte1o3ve3pl0financial11r1s1t0d0a3u0ndbeck6xe1ury5v1y2ma0drid4if1son4keup4n0agement7go3p1rket0ing3s4riott5shalls7ttel5ba2c0kinsey7d1e0d0ia3et2lbourne7me1orial6n0u2rckmsd7g1h1iami3crosoft7l1ni1t2t0subishi9k1l0b1s2m0a2n1o0bi0le4da2e1i1m1nash3ey2ster5rmon3tgage6scow4to0rcycles9v0ie4p1q1r1s0d2t0n1r2u0seum3ic4v1w1x1y1z2na0b1goya4me2tura4vy3ba2c1e0c1t0bank4flix4work5ustar5w0s2xt0direct7us4f0l2g0o2hk2i0co2ke1on3nja3ssan1y5l1o0kia3rton4w0ruz3tv4p1r0a1w2tt2u1yc2z2obi1server7ffice5kinawa6layan0group9dnavy5lo3m0ega4ne1g1l0ine5oo2pen3racle3nge4g0anic5igins6saka4tsuka4t2vh3pa0ge2nasonic7ris2s1tners4s1y3y2ccw3e0t2f0izer5g1h0armacy6d1ilips5one2to0graphy6s4ysio5ics1tet2ures6d1n0g1k2oneer5zza4k1l0ace2y0station9umbing5s3m1n0c2ohl2ker3litie5rn2st3r0america6xi3ess3ime3o0d0uctions8f1gressive8mo2perties3y5tection8u0dential9s1t1ub2w0c2y2qa1pon3uebec3st5racing4dio4e0ad1lestate6tor2y4cipes5d0stone5umbrella9hab3ise0n3t2liance6n0t0als5pair3ort3ublican8st0aurant8view0s5xroth6ich0ardli6oh3l1o1p2o0cks3deo3gers4om3s0vp3u0gby3hr2n2w0e2yukyu6sa0arland6fe0ty4kura4le1on3msclub4ung5ndvik0coromant12ofi4p1rl2s1ve2xo3b0i1s2c0a1b1haeffler7midt4olarships8ol3ule3warz5ience5ot3d1e0arch3t2cure1ity6ek2lect4ner3rvices6ven3w1x0y3fr2g1h0angrila6rp2w2ell3ia1ksha5oes2p0ping5uji3w3i0lk2na1gles5te3j1k0i0n2y0pe4l0ing4m0art3ile4n0cf3o0ccer3ial4ftbank4ware6hu2lar2utions7ng1y2y2pa0ce3ort2t3r0l2s1t0ada2ples4r1tebank4farm7c0group6ockholm6rage3e3ream4udio2y3yle4u0cks3pplies3y2ort5rf1gery5zuki5v1watch4iss4x1y0dney4stems6z2tab1ipei4lk2obao4rget4tamotors6r2too4x0i3c0i2d0k2eam2ch0nology8l1masek5nnis4va3f1g1h0d1eater2re6iaa2ckets5enda4ps2res2ol4j0maxx4x2k0maxx5l1m0all4n1o0day3kyo3ols3p1ray3shiba5tal3urs3wn2yota3s3r0ade1ing4ining5vel0ers0insurance16ust3v2t1ube2i1nes3shu4v0s2w1z2ua1bank3s2g1k1nicom3versity8o2ol2ps2s1y1z2va0cations7na1guard7c1e0gas3ntures6risign5m\xf6gensberater2ung14sicherung10t2g1i0ajes4deo3g1king4llas4n1p1rgin4sa1ion4va1o3laanderen9n1odka3lvo3te1ing3o2yage5u2wales2mart4ter4ng0gou5tch0es6eather0channel12bcam3er2site5d0ding5ibo2r3f1hoswho6ien2ki2lliamhill9n0dows4e1ners6me2olterskluwer11odside6rk0s2ld3w2s1tc1f3xbox3erox4finity6ihuan4n2xx2yz3yachts4hoo3maxun5ndex5e1odobashi7ga2kohama6u0tube6t1un3za0ppos4ra3ero3ip2m1one3uerich6w2";
// Internationalized domain names containing non-ASCII
const $c0c895385715e166$var$encodedUtlds = "\u03B5\u03BB1\u03C52\u0431\u04331\u0435\u043B3\u0434\u0435\u0442\u04384\u0435\u044E2\u043A\u0430\u0442\u043E\u043B\u0438\u043A6\u043E\u043C3\u043C\u043A\u04342\u043E\u043D1\u0441\u043A\u0432\u04306\u043E\u043D\u043B\u0430\u0439\u043D5\u0440\u04333\u0440\u0443\u04412\u04442\u0441\u0430\u0439\u04423\u0440\u04313\u0443\u043A\u04403\u049B\u0430\u04373\u0570\u0561\u05753\u05D9\u05E9\u05E8\u05D0\u05DC5\u05E7\u05D5\u05DD3\u0627\u0628\u0648\u0638\u0628\u064A5\u0631\u0627\u0645\u0643\u06485\u0644\u0627\u0631\u062F\u06464\u0628\u062D\u0631\u064A\u06465\u062C\u0632\u0627\u0626\u06315\u0633\u0639\u0648\u062F\u064A\u06296\u0639\u0644\u064A\u0627\u06465\u0645\u063A\u0631\u06285\u0645\u0627\u0631\u0627\u062A5\u06CC\u0631\u0627\u06465\u0628\u0627\u0631\u062A2\u0632\u0627\u06314\u064A\u062A\u06433\u06BE\u0627\u0631\u062A5\u062A\u0648\u0646\u06334\u0633\u0648\u062F\u0627\u06463\u0631\u064A\u06295\u0634\u0628\u0643\u06294\u0639\u0631\u0627\u06422\u06282\u0645\u0627\u06464\u0641\u0644\u0633\u0637\u064A\u06466\u0642\u0637\u06313\u0643\u0627\u062B\u0648\u0644\u064A\u06436\u0648\u06453\u0645\u0635\u06312\u0644\u064A\u0633\u064A\u06275\u0648\u0631\u064A\u062A\u0627\u0646\u064A\u06277\u0642\u06394\u0647\u0645\u0631\u0627\u06475\u067E\u0627\u06A9\u0633\u062A\u0627\u06467\u0680\u0627\u0631\u062A4\u0915\u0949\u092E3\u0928\u0947\u091F3\u092D\u093E\u0930\u09240\u092E\u094D3\u094B\u09245\u0938\u0902\u0917\u0920\u09285\u09AC\u09BE\u0982\u09B2\u09BE5\u09AD\u09BE\u09B0\u09A42\u09F0\u09A44\u0A2D\u0A3E\u0A30\u0A244\u0AAD\u0ABE\u0AB0\u0AA44\u0B2D\u0B3E\u0B30\u0B244\u0B87\u0BA8\u0BCD\u0BA4\u0BBF\u0BAF\u0BBE6\u0BB2\u0B99\u0BCD\u0B95\u0BC86\u0B9A\u0BBF\u0B99\u0BCD\u0B95\u0BAA\u0BCD\u0BAA\u0BC2\u0BB0\u0BCD11\u0C2D\u0C3E\u0C30\u0C24\u0C4D5\u0CAD\u0CBE\u0CB0\u0CA44\u0D2D\u0D3E\u0D30\u0D24\u0D025\u0DBD\u0D82\u0D9A\u0DCF4\u0E04\u0E2D\u0E213\u0E44\u0E17\u0E223\u0EA5\u0EB2\u0EA73\u10D2\u10D42\u307F\u3093\u306A3\u30A2\u30DE\u30BE\u30F34\u30AF\u30E9\u30A6\u30C94\u30B0\u30FC\u30B0\u30EB4\u30B3\u30E02\u30B9\u30C8\u30A23\u30BB\u30FC\u30EB3\u30D5\u30A1\u30C3\u30B7\u30E7\u30F36\u30DD\u30A4\u30F3\u30C84\u4E16\u754C2\u4E2D\u4FE11\u56FD1\u570B1\u6587\u7F513\u4E9A\u9A6C\u900A3\u4F01\u4E1A2\u4F5B\u5C712\u4FE1\u606F2\u5065\u5EB72\u516B\u53662\u516C\u53F81\u76CA2\u53F0\u6E7E1\u70632\u5546\u57CE1\u5E971\u68072\u5609\u91CC0\u5927\u9152\u5E975\u5728\u7EBF2\u5927\u62FF2\u5929\u4E3B\u65593\u5A31\u4E502\u5BB6\u96FB2\u5E7F\u4E1C2\u5FAE\u535A2\u6148\u55842\u6211\u7231\u4F603\u624B\u673A2\u62DB\u80582\u653F\u52A11\u5E9C2\u65B0\u52A0\u57612\u95FB2\u65F6\u5C1A2\u66F8\u7C4D2\u673A\u67842\u6DE1\u9A6C\u95213\u6E38\u620F2\u6FB3\u95802\u70B9\u770B2\u79FB\u52A82\u7EC4\u7EC7\u673A\u67844\u7F51\u57401\u5E971\u7AD91\u7EDC2\u8054\u901A2\u8C37\u6B4C2\u8D2D\u72692\u901A\u8CA92\u96C6\u56E22\u96FB\u8A0A\u76C8\u79D14\u98DE\u5229\u6D663\u98DF\u54C12\u9910\u53852\u9999\u683C\u91CC\u62C93\u6E2F2\uB2F7\uB1371\uCEF42\uC0BC\uC1312\uD55C\uAD6D2";
/**
 * @template A
 * @template B
 * @param {A} target
 * @param {B} properties
 * @return {A & B}
 */ const $c0c895385715e166$var$assign = (target, properties)=>{
    for(const key in properties)target[key] = properties[key];
    return target;
};
/**
 * Finite State Machine generation utilities
 */ /**
 * @template T
 * @typedef {{ [group: string]: T[] }} Collections
 */ /**
 * @typedef {{ [group: string]: true }} Flags
 */ // Keys in scanner Collections instances
const $c0c895385715e166$var$numeric = "numeric";
const $c0c895385715e166$var$ascii = "ascii";
const $c0c895385715e166$var$alpha = "alpha";
const $c0c895385715e166$var$asciinumeric = "asciinumeric";
const $c0c895385715e166$var$alphanumeric = "alphanumeric";
const $c0c895385715e166$var$domain = "domain";
const $c0c895385715e166$var$emoji = "emoji";
const $c0c895385715e166$var$scheme = "scheme";
const $c0c895385715e166$var$slashscheme = "slashscheme";
const $c0c895385715e166$var$whitespace = "whitespace";
/**
 * @template T
 * @param {string} name
 * @param {Collections<T>} groups to register in
 * @returns {T[]} Current list of tokens in the given collection
 */ function $c0c895385715e166$var$registerGroup(name, groups) {
    if (!(name in groups)) groups[name] = [];
    return groups[name];
}
/**
 * @template T
 * @param {T} t token to add
 * @param {Collections<T>} groups
 * @param {Flags} flags
 */ function $c0c895385715e166$var$addToGroups(t, flags, groups) {
    if (flags[$c0c895385715e166$var$numeric]) {
        flags[$c0c895385715e166$var$asciinumeric] = true;
        flags[$c0c895385715e166$var$alphanumeric] = true;
    }
    if (flags[$c0c895385715e166$var$ascii]) {
        flags[$c0c895385715e166$var$asciinumeric] = true;
        flags[$c0c895385715e166$var$alpha] = true;
    }
    if (flags[$c0c895385715e166$var$asciinumeric]) flags[$c0c895385715e166$var$alphanumeric] = true;
    if (flags[$c0c895385715e166$var$alpha]) flags[$c0c895385715e166$var$alphanumeric] = true;
    if (flags[$c0c895385715e166$var$alphanumeric]) flags[$c0c895385715e166$var$domain] = true;
    if (flags[$c0c895385715e166$var$emoji]) flags[$c0c895385715e166$var$domain] = true;
    for(const k in flags){
        const group = $c0c895385715e166$var$registerGroup(k, groups);
        if (group.indexOf(t) < 0) group.push(t);
    }
}
/**
 * @template T
 * @param {T} t token to check
 * @param {Collections<T>} groups
 * @returns {Flags} group flags that contain this token
 */ function $c0c895385715e166$var$flagsForToken(t, groups) {
    const result = {};
    for(const c in groups)if (groups[c].indexOf(t) >= 0) result[c] = true;
    return result;
}
/**
 * @template T
 * @typedef {null | T } Transition
 */ /**
 * Define a basic state machine state. j is the list of character transitions,
 * jr is the list of regex-match transitions, jd is the default state to
 * transition to t is the accepting token type, if any. If this is the terminal
 * state, then it does not emit a token.
 *
 * The template type T represents the type of the token this state accepts. This
 * should be a string (such as of the token exports in `text.js`) or a
 * MultiToken subclass (from `multi.js`)
 *
 * @template T
 * @param {T} [token] Token that this state emits
 */ function $c0c895385715e166$export$7254cc27399e90bd(token) {
    if (token === void 0) token = null;
    // this.n = null; // DEBUG: State name
    /** @type {{ [input: string]: State<T> }} j */ this.j = {}; // IMPLEMENTATION 1
    // this.j = []; // IMPLEMENTATION 2
    /** @type {[RegExp, State<T>][]} jr */ this.jr = [];
    /** @type {?State<T>} jd */ this.jd = null;
    /** @type {?T} t */ this.t = token;
}
/**
 * Scanner token groups
 * @type Collections<string>
 */ $c0c895385715e166$export$7254cc27399e90bd.groups = {};
$c0c895385715e166$export$7254cc27399e90bd.prototype = {
    accepts () {
        return !!this.t;
    },
    /**
   * Follow an existing transition from the given input to the next state.
   * Does not mutate.
   * @param {string} input character or token type to transition on
   * @returns {?State<T>} the next state, if any
   */ go (input) {
        const state = this;
        const nextState = state.j[input];
        if (nextState) return nextState;
        for(let i = 0; i < state.jr.length; i++){
            const regex = state.jr[i][0];
            const nextState = state.jr[i][1]; // note: might be empty to prevent default jump
            if (nextState && regex.test(input)) return nextState;
        }
        // Nowhere left to jump! Return default, if any
        return state.jd;
    },
    /**
   * Whether the state has a transition for the given input. Set the second
   * argument to true to only look for an exact match (and not a default or
   * regular-expression-based transition)
   * @param {string} input
   * @param {boolean} exactOnly
   */ has (input, exactOnly) {
        if (exactOnly === void 0) exactOnly = false;
        return exactOnly ? input in this.j : !!this.go(input);
    },
    /**
   * Short for "transition all"; create a transition from the array of items
   * in the given list to the same final resulting state.
   * @param {string | string[]} inputs Group of inputs to transition on
   * @param {Transition<T> | State<T>} [next] Transition options
   * @param {Flags} [flags] Collections flags to add token to
   * @param {Collections<T>} [groups] Master list of token groups
   */ ta (inputs, next, flags, groups) {
        for(let i = 0; i < inputs.length; i++)this.tt(inputs[i], next, flags, groups);
    },
    /**
   * Short for "take regexp transition"; defines a transition for this state
   * when it encounters a token which matches the given regular expression
   * @param {RegExp} regexp Regular expression transition (populate first)
   * @param {T | State<T>} [next] Transition options
   * @param {Flags} [flags] Collections flags to add token to
   * @param {Collections<T>} [groups] Master list of token groups
   * @returns {State<T>} taken after the given input
   */ tr (regexp, next, flags, groups) {
        groups = groups || $c0c895385715e166$export$7254cc27399e90bd.groups;
        let nextState;
        if (next && next.j) nextState = next;
        else {
            // Token with maybe token groups
            nextState = new $c0c895385715e166$export$7254cc27399e90bd(next);
            if (flags && groups) $c0c895385715e166$var$addToGroups(next, flags, groups);
        }
        this.jr.push([
            regexp,
            nextState
        ]);
        return nextState;
    },
    /**
   * Short for "take transitions", will take as many sequential transitions as
   * the length of the given input and returns the
   * resulting final state.
   * @param {string | string[]} input
   * @param {T | State<T>} [next] Transition options
   * @param {Flags} [flags] Collections flags to add token to
   * @param {Collections<T>} [groups] Master list of token groups
   * @returns {State<T>} taken after the given input
   */ ts (input, next, flags, groups) {
        let state = this;
        const len = input.length;
        if (!len) return state;
        for(let i = 0; i < len - 1; i++)state = state.tt(input[i]);
        return state.tt(input[len - 1], next, flags, groups);
    },
    /**
   * Short for "take transition", this is a method for building/working with
   * state machines.
   *
   * If a state already exists for the given input, returns it.
   *
   * If a token is specified, that state will emit that token when reached by
   * the linkify engine.
   *
   * If no state exists, it will be initialized with some default transitions
   * that resemble existing default transitions.
   *
   * If a state is given for the second argument, that state will be
   * transitioned to on the given input regardless of what that input
   * previously did.
   *
   * Specify a token group flags to define groups that this token belongs to.
   * The token will be added to corresponding entires in the given groups
   * object.
   *
   * @param {string} input character, token type to transition on
   * @param {T | State<T>} [next] Transition options
   * @param {Flags} [flags] Collections flags to add token to
   * @param {Collections<T>} [groups] Master list of groups
   * @returns {State<T>} taken after the given input
   */ tt (input, next, flags, groups) {
        groups = groups || $c0c895385715e166$export$7254cc27399e90bd.groups;
        const state = this;
        // Check if existing state given, just a basic transition
        if (next && next.j) {
            state.j[input] = next;
            return next;
        }
        const t = next;
        // Take the transition with the usual default mechanisms and use that as
        // a template for creating the next state
        let nextState, templateState = state.go(input);
        if (templateState) {
            nextState = new $c0c895385715e166$export$7254cc27399e90bd();
            $c0c895385715e166$var$assign(nextState.j, templateState.j);
            nextState.jr.push.apply(nextState.jr, templateState.jr);
            nextState.jd = templateState.jd;
            nextState.t = templateState.t;
        } else nextState = new $c0c895385715e166$export$7254cc27399e90bd();
        if (t) {
            // Ensure newly token is in the same groups as the old token
            if (groups) {
                if (nextState.t && typeof nextState.t === "string") {
                    const allFlags = $c0c895385715e166$var$assign($c0c895385715e166$var$flagsForToken(nextState.t, groups), flags);
                    $c0c895385715e166$var$addToGroups(t, allFlags, groups);
                } else if (flags) $c0c895385715e166$var$addToGroups(t, flags, groups);
            }
            nextState.t = t; // overwrite anything that was previously there
        }
        state.j[input] = nextState;
        return nextState;
    }
};
// Helper functions to improve minification (not exported outside linkifyjs module)
/**
 * @template T
 * @param {State<T>} state
 * @param {string | string[]} input
 * @param {Flags} [flags]
 * @param {Collections<T>} [groups]
 */ const $c0c895385715e166$var$ta = (state, input, next, flags, groups)=>state.ta(input, next, flags, groups);
/**
 * @template T
 * @param {State<T>} state
 * @param {RegExp} regexp
 * @param {T | State<T>} [next]
 * @param {Flags} [flags]
 * @param {Collections<T>} [groups]
 */ const $c0c895385715e166$var$tr = (state, regexp, next, flags, groups)=>state.tr(regexp, next, flags, groups);
/**
 * @template T
 * @param {State<T>} state
 * @param {string | string[]} input
 * @param {T | State<T>} [next]
 * @param {Flags} [flags]
 * @param {Collections<T>} [groups]
 */ const $c0c895385715e166$var$ts = (state, input, next, flags, groups)=>state.ts(input, next, flags, groups);
/**
 * @template T
 * @param {State<T>} state
 * @param {string} input
 * @param {T | State<T>} [next]
 * @param {Collections<T>} [groups]
 * @param {Flags} [flags]
 */ const $c0c895385715e166$var$tt = (state, input, next, flags, groups)=>state.tt(input, next, flags, groups);
/******************************************************************************
Text Tokens
Identifiers for token outputs from the regexp scanner
******************************************************************************/ // A valid web domain token
const $c0c895385715e166$var$WORD = "WORD"; // only contains a-z
const $c0c895385715e166$var$UWORD = "UWORD"; // contains letters other than a-z, used for IDN
// Special case of word
const $c0c895385715e166$var$LOCALHOST = "LOCALHOST";
// Valid top-level domain, special case of WORD (see tlds.js)
const $c0c895385715e166$var$TLD = "TLD";
// Valid IDN TLD, special case of UWORD (see tlds.js)
const $c0c895385715e166$var$UTLD = "UTLD";
// The scheme portion of a web URI protocol. Supported types include: `mailto`,
// `file`, and user-defined custom protocols. Limited to schemes that contain
// only letters
const $c0c895385715e166$var$SCHEME = "SCHEME";
// Similar to SCHEME, except makes distinction for schemes that must always be
// followed by `://`, not just `:`. Supported types include `http`, `https`,
// `ftp`, `ftps`
const $c0c895385715e166$var$SLASH_SCHEME = "SLASH_SCHEME";
// Any sequence of digits 0-9
const $c0c895385715e166$var$NUM = "NUM";
// Any number of consecutive whitespace characters that are not newline
const $c0c895385715e166$var$WS = "WS";
// New line (unix style)
const $c0c895385715e166$var$NL$1 = "NL"; // \n
// Opening/closing bracket classes
// TODO: Rename OPEN -> LEFT and CLOSE -> RIGHT in v5 to fit with Unicode names
// Also rename angle brackes to LESSTHAN and GREATER THAN
const $c0c895385715e166$var$OPENBRACE = "OPENBRACE"; // {
const $c0c895385715e166$var$CLOSEBRACE = "CLOSEBRACE"; // }
const $c0c895385715e166$var$OPENBRACKET = "OPENBRACKET"; // [
const $c0c895385715e166$var$CLOSEBRACKET = "CLOSEBRACKET"; // ]
const $c0c895385715e166$var$OPENPAREN = "OPENPAREN"; // (
const $c0c895385715e166$var$CLOSEPAREN = "CLOSEPAREN"; // )
const $c0c895385715e166$var$OPENANGLEBRACKET = "OPENANGLEBRACKET"; // <
const $c0c895385715e166$var$CLOSEANGLEBRACKET = "CLOSEANGLEBRACKET"; // >
const $c0c895385715e166$var$FULLWIDTHLEFTPAREN = "FULLWIDTHLEFTPAREN"; // （
const $c0c895385715e166$var$FULLWIDTHRIGHTPAREN = "FULLWIDTHRIGHTPAREN"; // ）
const $c0c895385715e166$var$LEFTCORNERBRACKET = "LEFTCORNERBRACKET"; // 「
const $c0c895385715e166$var$RIGHTCORNERBRACKET = "RIGHTCORNERBRACKET"; // 」
const $c0c895385715e166$var$LEFTWHITECORNERBRACKET = "LEFTWHITECORNERBRACKET"; // 『
const $c0c895385715e166$var$RIGHTWHITECORNERBRACKET = "RIGHTWHITECORNERBRACKET"; // 』
const $c0c895385715e166$var$FULLWIDTHLESSTHAN = "FULLWIDTHLESSTHAN"; // ＜
const $c0c895385715e166$var$FULLWIDTHGREATERTHAN = "FULLWIDTHGREATERTHAN"; // ＞
// Various symbols
const $c0c895385715e166$var$AMPERSAND = "AMPERSAND"; // &
const $c0c895385715e166$var$APOSTROPHE = "APOSTROPHE"; // '
const $c0c895385715e166$var$ASTERISK = "ASTERISK"; // *
const $c0c895385715e166$var$AT = "AT"; // @
const $c0c895385715e166$var$BACKSLASH = "BACKSLASH"; // \
const $c0c895385715e166$var$BACKTICK = "BACKTICK"; // `
const $c0c895385715e166$var$CARET = "CARET"; // ^
const $c0c895385715e166$var$COLON = "COLON"; // :
const $c0c895385715e166$var$COMMA = "COMMA"; // ,
const $c0c895385715e166$var$DOLLAR = "DOLLAR"; // $
const $c0c895385715e166$var$DOT = "DOT"; // .
const $c0c895385715e166$var$EQUALS = "EQUALS"; // =
const $c0c895385715e166$var$EXCLAMATION = "EXCLAMATION"; // !
const $c0c895385715e166$var$HYPHEN = "HYPHEN"; // -
const $c0c895385715e166$var$PERCENT = "PERCENT"; // %
const $c0c895385715e166$var$PIPE = "PIPE"; // |
const $c0c895385715e166$var$PLUS = "PLUS"; // +
const $c0c895385715e166$var$POUND = "POUND"; // #
const $c0c895385715e166$var$QUERY = "QUERY"; // ?
const $c0c895385715e166$var$QUOTE = "QUOTE"; // "
const $c0c895385715e166$var$SEMI = "SEMI"; // ;
const $c0c895385715e166$var$SLASH = "SLASH"; // /
const $c0c895385715e166$var$TILDE = "TILDE"; // ~
const $c0c895385715e166$var$UNDERSCORE = "UNDERSCORE"; // _
// Emoji symbol
const $c0c895385715e166$var$EMOJI$1 = "EMOJI";
// Default token - anything that is not one of the above
const $c0c895385715e166$var$SYM = "SYM";
var $c0c895385715e166$var$tk = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    WORD: $c0c895385715e166$var$WORD,
    UWORD: $c0c895385715e166$var$UWORD,
    LOCALHOST: $c0c895385715e166$var$LOCALHOST,
    TLD: $c0c895385715e166$var$TLD,
    UTLD: $c0c895385715e166$var$UTLD,
    SCHEME: $c0c895385715e166$var$SCHEME,
    SLASH_SCHEME: $c0c895385715e166$var$SLASH_SCHEME,
    NUM: $c0c895385715e166$var$NUM,
    WS: $c0c895385715e166$var$WS,
    NL: $c0c895385715e166$var$NL$1,
    OPENBRACE: $c0c895385715e166$var$OPENBRACE,
    CLOSEBRACE: $c0c895385715e166$var$CLOSEBRACE,
    OPENBRACKET: $c0c895385715e166$var$OPENBRACKET,
    CLOSEBRACKET: $c0c895385715e166$var$CLOSEBRACKET,
    OPENPAREN: $c0c895385715e166$var$OPENPAREN,
    CLOSEPAREN: $c0c895385715e166$var$CLOSEPAREN,
    OPENANGLEBRACKET: $c0c895385715e166$var$OPENANGLEBRACKET,
    CLOSEANGLEBRACKET: $c0c895385715e166$var$CLOSEANGLEBRACKET,
    FULLWIDTHLEFTPAREN: $c0c895385715e166$var$FULLWIDTHLEFTPAREN,
    FULLWIDTHRIGHTPAREN: $c0c895385715e166$var$FULLWIDTHRIGHTPAREN,
    LEFTCORNERBRACKET: $c0c895385715e166$var$LEFTCORNERBRACKET,
    RIGHTCORNERBRACKET: $c0c895385715e166$var$RIGHTCORNERBRACKET,
    LEFTWHITECORNERBRACKET: $c0c895385715e166$var$LEFTWHITECORNERBRACKET,
    RIGHTWHITECORNERBRACKET: $c0c895385715e166$var$RIGHTWHITECORNERBRACKET,
    FULLWIDTHLESSTHAN: $c0c895385715e166$var$FULLWIDTHLESSTHAN,
    FULLWIDTHGREATERTHAN: $c0c895385715e166$var$FULLWIDTHGREATERTHAN,
    AMPERSAND: $c0c895385715e166$var$AMPERSAND,
    APOSTROPHE: $c0c895385715e166$var$APOSTROPHE,
    ASTERISK: $c0c895385715e166$var$ASTERISK,
    AT: $c0c895385715e166$var$AT,
    BACKSLASH: $c0c895385715e166$var$BACKSLASH,
    BACKTICK: $c0c895385715e166$var$BACKTICK,
    CARET: $c0c895385715e166$var$CARET,
    COLON: $c0c895385715e166$var$COLON,
    COMMA: $c0c895385715e166$var$COMMA,
    DOLLAR: $c0c895385715e166$var$DOLLAR,
    DOT: $c0c895385715e166$var$DOT,
    EQUALS: $c0c895385715e166$var$EQUALS,
    EXCLAMATION: $c0c895385715e166$var$EXCLAMATION,
    HYPHEN: $c0c895385715e166$var$HYPHEN,
    PERCENT: $c0c895385715e166$var$PERCENT,
    PIPE: $c0c895385715e166$var$PIPE,
    PLUS: $c0c895385715e166$var$PLUS,
    POUND: $c0c895385715e166$var$POUND,
    QUERY: $c0c895385715e166$var$QUERY,
    QUOTE: $c0c895385715e166$var$QUOTE,
    SEMI: $c0c895385715e166$var$SEMI,
    SLASH: $c0c895385715e166$var$SLASH,
    TILDE: $c0c895385715e166$var$TILDE,
    UNDERSCORE: $c0c895385715e166$var$UNDERSCORE,
    EMOJI: $c0c895385715e166$var$EMOJI$1,
    SYM: $c0c895385715e166$var$SYM
});
// Note that these two Unicode ones expand into a really big one with Babel
const $c0c895385715e166$var$ASCII_LETTER = /[a-z]/;
const $c0c895385715e166$var$LETTER = /\p{L}/u; // Any Unicode character with letter data type
const $c0c895385715e166$var$EMOJI = /\p{Emoji}/u; // Any Unicode emoji character
const $c0c895385715e166$var$EMOJI_VARIATION$1 = /\ufe0f/;
const $c0c895385715e166$var$DIGIT = /\d/;
const $c0c895385715e166$var$SPACE = /\s/;
var $c0c895385715e166$export$efdc1e5bdb609bb = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    ASCII_LETTER: $c0c895385715e166$var$ASCII_LETTER,
    LETTER: $c0c895385715e166$var$LETTER,
    EMOJI: $c0c895385715e166$var$EMOJI,
    EMOJI_VARIATION: $c0c895385715e166$var$EMOJI_VARIATION$1,
    DIGIT: $c0c895385715e166$var$DIGIT,
    SPACE: $c0c895385715e166$var$SPACE
});
/**
	The scanner provides an interface that takes a string of text as input, and
	outputs an array of tokens instances that can be used for easy URL parsing.
*/ const $c0c895385715e166$var$NL = "\n"; // New line character
const $c0c895385715e166$var$EMOJI_VARIATION = "\uFE0F"; // Variation selector, follows heart and others
const $c0c895385715e166$var$EMOJI_JOINER = "\u200D"; // zero-width joiner
let $c0c895385715e166$var$tlds = null, $c0c895385715e166$var$utlds = null; // don't change so only have to be computed once
/**
 * Scanner output token:
 * - `t` is the token name (e.g., 'NUM', 'EMOJI', 'TLD')
 * - `v` is the value of the token (e.g., '123', '❤️', 'com')
 * - `s` is the start index of the token in the original string
 * - `e` is the end index of the token in the original string
 * @typedef {{t: string, v: string, s: number, e: number}} Token
 */ /**
 * @template T
 * @typedef {{ [collection: string]: T[] }} Collections
 */ /**
 * Initialize the scanner character-based state machine for the given start
 * state
 * @param {[string, boolean][]} customSchemes List of custom schemes, where each
 * item is a length-2 tuple with the first element set to the string scheme, and
 * the second element set to `true` if the `://` after the scheme is optional
 */ function $c0c895385715e166$var$init$2(customSchemes) {
    if (customSchemes === void 0) customSchemes = [];
    // Frequently used states (name argument removed during minification)
    /** @type Collections<string> */ const groups = {}; // of tokens
    $c0c895385715e166$export$7254cc27399e90bd.groups = groups;
    /** @type State<string> */ const Start = new $c0c895385715e166$export$7254cc27399e90bd();
    if ($c0c895385715e166$var$tlds == null) $c0c895385715e166$var$tlds = $c0c895385715e166$var$decodeTlds($c0c895385715e166$var$encodedTlds);
    if ($c0c895385715e166$var$utlds == null) $c0c895385715e166$var$utlds = $c0c895385715e166$var$decodeTlds($c0c895385715e166$var$encodedUtlds);
    // States for special URL symbols that accept immediately after start
    $c0c895385715e166$var$tt(Start, "'", $c0c895385715e166$var$APOSTROPHE);
    $c0c895385715e166$var$tt(Start, "{", $c0c895385715e166$var$OPENBRACE);
    $c0c895385715e166$var$tt(Start, "}", $c0c895385715e166$var$CLOSEBRACE);
    $c0c895385715e166$var$tt(Start, "[", $c0c895385715e166$var$OPENBRACKET);
    $c0c895385715e166$var$tt(Start, "]", $c0c895385715e166$var$CLOSEBRACKET);
    $c0c895385715e166$var$tt(Start, "(", $c0c895385715e166$var$OPENPAREN);
    $c0c895385715e166$var$tt(Start, ")", $c0c895385715e166$var$CLOSEPAREN);
    $c0c895385715e166$var$tt(Start, "<", $c0c895385715e166$var$OPENANGLEBRACKET);
    $c0c895385715e166$var$tt(Start, ">", $c0c895385715e166$var$CLOSEANGLEBRACKET);
    $c0c895385715e166$var$tt(Start, "\uFF08", $c0c895385715e166$var$FULLWIDTHLEFTPAREN);
    $c0c895385715e166$var$tt(Start, "\uFF09", $c0c895385715e166$var$FULLWIDTHRIGHTPAREN);
    $c0c895385715e166$var$tt(Start, "\u300C", $c0c895385715e166$var$LEFTCORNERBRACKET);
    $c0c895385715e166$var$tt(Start, "\u300D", $c0c895385715e166$var$RIGHTCORNERBRACKET);
    $c0c895385715e166$var$tt(Start, "\u300E", $c0c895385715e166$var$LEFTWHITECORNERBRACKET);
    $c0c895385715e166$var$tt(Start, "\u300F", $c0c895385715e166$var$RIGHTWHITECORNERBRACKET);
    $c0c895385715e166$var$tt(Start, "\uFF1C", $c0c895385715e166$var$FULLWIDTHLESSTHAN);
    $c0c895385715e166$var$tt(Start, "\uFF1E", $c0c895385715e166$var$FULLWIDTHGREATERTHAN);
    $c0c895385715e166$var$tt(Start, "&", $c0c895385715e166$var$AMPERSAND);
    $c0c895385715e166$var$tt(Start, "*", $c0c895385715e166$var$ASTERISK);
    $c0c895385715e166$var$tt(Start, "@", $c0c895385715e166$var$AT);
    $c0c895385715e166$var$tt(Start, "`", $c0c895385715e166$var$BACKTICK);
    $c0c895385715e166$var$tt(Start, "^", $c0c895385715e166$var$CARET);
    $c0c895385715e166$var$tt(Start, ":", $c0c895385715e166$var$COLON);
    $c0c895385715e166$var$tt(Start, ",", $c0c895385715e166$var$COMMA);
    $c0c895385715e166$var$tt(Start, "$", $c0c895385715e166$var$DOLLAR);
    $c0c895385715e166$var$tt(Start, ".", $c0c895385715e166$var$DOT);
    $c0c895385715e166$var$tt(Start, "=", $c0c895385715e166$var$EQUALS);
    $c0c895385715e166$var$tt(Start, "!", $c0c895385715e166$var$EXCLAMATION);
    $c0c895385715e166$var$tt(Start, "-", $c0c895385715e166$var$HYPHEN);
    $c0c895385715e166$var$tt(Start, "%", $c0c895385715e166$var$PERCENT);
    $c0c895385715e166$var$tt(Start, "|", $c0c895385715e166$var$PIPE);
    $c0c895385715e166$var$tt(Start, "+", $c0c895385715e166$var$PLUS);
    $c0c895385715e166$var$tt(Start, "#", $c0c895385715e166$var$POUND);
    $c0c895385715e166$var$tt(Start, "?", $c0c895385715e166$var$QUERY);
    $c0c895385715e166$var$tt(Start, '"', $c0c895385715e166$var$QUOTE);
    $c0c895385715e166$var$tt(Start, "/", $c0c895385715e166$var$SLASH);
    $c0c895385715e166$var$tt(Start, ";", $c0c895385715e166$var$SEMI);
    $c0c895385715e166$var$tt(Start, "~", $c0c895385715e166$var$TILDE);
    $c0c895385715e166$var$tt(Start, "_", $c0c895385715e166$var$UNDERSCORE);
    $c0c895385715e166$var$tt(Start, "\\", $c0c895385715e166$var$BACKSLASH);
    const Num = $c0c895385715e166$var$tr(Start, $c0c895385715e166$var$DIGIT, $c0c895385715e166$var$NUM, {
        [$c0c895385715e166$var$numeric]: true
    });
    $c0c895385715e166$var$tr(Num, $c0c895385715e166$var$DIGIT, Num);
    // State which emits a word token
    const Word = $c0c895385715e166$var$tr(Start, $c0c895385715e166$var$ASCII_LETTER, $c0c895385715e166$var$WORD, {
        [$c0c895385715e166$var$ascii]: true
    });
    $c0c895385715e166$var$tr(Word, $c0c895385715e166$var$ASCII_LETTER, Word);
    // Same as previous, but specific to non-fsm.ascii alphabet words
    const UWord = $c0c895385715e166$var$tr(Start, $c0c895385715e166$var$LETTER, $c0c895385715e166$var$UWORD, {
        [$c0c895385715e166$var$alpha]: true
    });
    $c0c895385715e166$var$tr(UWord, $c0c895385715e166$var$ASCII_LETTER); // Non-accepting
    $c0c895385715e166$var$tr(UWord, $c0c895385715e166$var$LETTER, UWord);
    // Whitespace jumps
    // Tokens of only non-newline whitespace are arbitrarily long
    // If any whitespace except newline, more whitespace!
    const Ws = $c0c895385715e166$var$tr(Start, $c0c895385715e166$var$SPACE, $c0c895385715e166$var$WS, {
        [$c0c895385715e166$var$whitespace]: true
    });
    $c0c895385715e166$var$tt(Start, $c0c895385715e166$var$NL, $c0c895385715e166$var$NL$1, {
        [$c0c895385715e166$var$whitespace]: true
    });
    $c0c895385715e166$var$tt(Ws, $c0c895385715e166$var$NL); // non-accepting state to avoid mixing whitespaces
    $c0c895385715e166$var$tr(Ws, $c0c895385715e166$var$SPACE, Ws);
    // Emoji tokens. They are not grouped by the scanner except in cases where a
    // zero-width joiner is present
    const Emoji = $c0c895385715e166$var$tr(Start, $c0c895385715e166$var$EMOJI, $c0c895385715e166$var$EMOJI$1, {
        [$c0c895385715e166$var$emoji]: true
    });
    $c0c895385715e166$var$tr(Emoji, $c0c895385715e166$var$EMOJI, Emoji);
    $c0c895385715e166$var$tt(Emoji, $c0c895385715e166$var$EMOJI_VARIATION, Emoji);
    // tt(Start, EMOJI_VARIATION, Emoji); // This one is sketchy
    const EmojiJoiner = $c0c895385715e166$var$tt(Emoji, $c0c895385715e166$var$EMOJI_JOINER);
    $c0c895385715e166$var$tr(EmojiJoiner, $c0c895385715e166$var$EMOJI, Emoji);
    // tt(EmojiJoiner, EMOJI_VARIATION, Emoji); // also sketchy
    // Generates states for top-level domains
    // Note that this is most accurate when tlds are in alphabetical order
    const wordjr = [
        [
            $c0c895385715e166$var$ASCII_LETTER,
            Word
        ]
    ];
    const uwordjr = [
        [
            $c0c895385715e166$var$ASCII_LETTER,
            null
        ],
        [
            $c0c895385715e166$var$LETTER,
            UWord
        ]
    ];
    for(let i = 0; i < $c0c895385715e166$var$tlds.length; i++)$c0c895385715e166$var$fastts(Start, $c0c895385715e166$var$tlds[i], $c0c895385715e166$var$TLD, $c0c895385715e166$var$WORD, wordjr);
    for(let i = 0; i < $c0c895385715e166$var$utlds.length; i++)$c0c895385715e166$var$fastts(Start, $c0c895385715e166$var$utlds[i], $c0c895385715e166$var$UTLD, $c0c895385715e166$var$UWORD, uwordjr);
    $c0c895385715e166$var$addToGroups($c0c895385715e166$var$TLD, {
        tld: true,
        ascii: true
    }, groups);
    $c0c895385715e166$var$addToGroups($c0c895385715e166$var$UTLD, {
        utld: true,
        alpha: true
    }, groups);
    // Collect the states generated by different protocols. NOTE: If any new TLDs
    // get added that are also protocols, set the token to be the same as the
    // protocol to ensure parsing works as expected.
    $c0c895385715e166$var$fastts(Start, "file", $c0c895385715e166$var$SCHEME, $c0c895385715e166$var$WORD, wordjr);
    $c0c895385715e166$var$fastts(Start, "mailto", $c0c895385715e166$var$SCHEME, $c0c895385715e166$var$WORD, wordjr);
    $c0c895385715e166$var$fastts(Start, "http", $c0c895385715e166$var$SLASH_SCHEME, $c0c895385715e166$var$WORD, wordjr);
    $c0c895385715e166$var$fastts(Start, "https", $c0c895385715e166$var$SLASH_SCHEME, $c0c895385715e166$var$WORD, wordjr);
    $c0c895385715e166$var$fastts(Start, "ftp", $c0c895385715e166$var$SLASH_SCHEME, $c0c895385715e166$var$WORD, wordjr);
    $c0c895385715e166$var$fastts(Start, "ftps", $c0c895385715e166$var$SLASH_SCHEME, $c0c895385715e166$var$WORD, wordjr);
    $c0c895385715e166$var$addToGroups($c0c895385715e166$var$SCHEME, {
        scheme: true,
        ascii: true
    }, groups);
    $c0c895385715e166$var$addToGroups($c0c895385715e166$var$SLASH_SCHEME, {
        slashscheme: true,
        ascii: true
    }, groups);
    // Register custom schemes. Assumes each scheme is asciinumeric with hyphens
    customSchemes = customSchemes.sort((a, b)=>a[0] > b[0] ? 1 : -1);
    for(let i = 0; i < customSchemes.length; i++){
        const sch = customSchemes[i][0];
        const optionalSlashSlash = customSchemes[i][1];
        const flags = optionalSlashSlash ? {
            [$c0c895385715e166$var$scheme]: true
        } : {
            [$c0c895385715e166$var$slashscheme]: true
        };
        if (sch.indexOf("-") >= 0) flags[$c0c895385715e166$var$domain] = true;
        else if (!$c0c895385715e166$var$ASCII_LETTER.test(sch)) flags[$c0c895385715e166$var$numeric] = true; // numbers only
        else if ($c0c895385715e166$var$DIGIT.test(sch)) flags[$c0c895385715e166$var$asciinumeric] = true;
        else flags[$c0c895385715e166$var$ascii] = true;
        $c0c895385715e166$var$ts(Start, sch, sch, flags);
    }
    // Localhost token
    $c0c895385715e166$var$ts(Start, "localhost", $c0c895385715e166$var$LOCALHOST, {
        ascii: true
    });
    // Set default transition for start state (some symbol)
    Start.jd = new $c0c895385715e166$export$7254cc27399e90bd($c0c895385715e166$var$SYM);
    return {
        start: Start,
        tokens: $c0c895385715e166$var$assign({
            groups: groups
        }, $c0c895385715e166$var$tk)
    };
}
/**
	Given a string, returns an array of TOKEN instances representing the
	composition of that string.

	@method run
	@param {State<string>} start scanner starting state
	@param {string} str input string to scan
	@return {Token[]} list of tokens, each with a type and value
*/ function $c0c895385715e166$var$run$1(start, str) {
    // State machine is not case sensitive, so input is tokenized in lowercased
    // form (still returns regular case). Uses selective `toLowerCase` because
    // lowercasing the entire string causes the length and character position to
    // vary in some non-English strings with V8-based runtimes.
    const iterable = $c0c895385715e166$export$b9ca061da17f2d30(str.replace(/[A-Z]/g, (c)=>c.toLowerCase()));
    const charCount = iterable.length; // <= len if there are emojis, etc
    const tokens = []; // return value
    // cursor through the string itself, accounting for characters that have
    // width with length 2 such as emojis
    let cursor = 0;
    // Cursor through the array-representation of the string
    let charCursor = 0;
    // Tokenize the string
    while(charCursor < charCount){
        let state = start;
        let nextState = null;
        let tokenLength = 0;
        let latestAccepting = null;
        let sinceAccepts = -1;
        let charsSinceAccepts = -1;
        while(charCursor < charCount && (nextState = state.go(iterable[charCursor]))){
            state = nextState;
            // Keep track of the latest accepting state
            if (state.accepts()) {
                sinceAccepts = 0;
                charsSinceAccepts = 0;
                latestAccepting = state;
            } else if (sinceAccepts >= 0) {
                sinceAccepts += iterable[charCursor].length;
                charsSinceAccepts++;
            }
            tokenLength += iterable[charCursor].length;
            cursor += iterable[charCursor].length;
            charCursor++;
        }
        // Roll back to the latest accepting state
        cursor -= sinceAccepts;
        charCursor -= charsSinceAccepts;
        tokenLength -= sinceAccepts;
        // No more jumps, just make a new token from the last accepting one
        tokens.push({
            t: latestAccepting.t,
            // token type/name
            v: str.slice(cursor - tokenLength, cursor),
            // string value
            s: cursor - tokenLength,
            // start index
            e: cursor // end index (excluding)
        });
    }
    return tokens;
}
/**
 * Convert a String to an Array of characters, taking into account that some
 * characters like emojis take up two string indexes.
 *
 * Adapted from core-js (MIT license)
 * https://github.com/zloirock/core-js/blob/2d69cf5f99ab3ea3463c395df81e5a15b68f49d9/packages/core-js/internals/string-multibyte.js
 *
 * @function stringToArray
 * @param {string} str
 * @returns {string[]}
 */ function $c0c895385715e166$export$b9ca061da17f2d30(str) {
    const result = [];
    const len = str.length;
    let index = 0;
    while(index < len){
        let first = str.charCodeAt(index);
        let second;
        let char = first < 0xd800 || first > 0xdbff || index + 1 === len || (second = str.charCodeAt(index + 1)) < 0xdc00 || second > 0xdfff ? str[index] // single character
         : str.slice(index, index + 2); // two-index characters
        result.push(char);
        index += char.length;
    }
    return result;
}
/**
 * Fast version of ts function for when transition defaults are well known
 * @param {State<string>} state
 * @param {string} input
 * @param {string} t
 * @param {string} defaultt
 * @param {[RegExp, State<string>][]} jr
 * @returns {State<string>}
 */ function $c0c895385715e166$var$fastts(state, input, t, defaultt, jr) {
    let next;
    const len = input.length;
    for(let i = 0; i < len - 1; i++){
        const char = input[i];
        if (state.j[char]) next = state.j[char];
        else {
            next = new $c0c895385715e166$export$7254cc27399e90bd(defaultt);
            next.jr = jr.slice();
            state.j[char] = next;
        }
        state = next;
    }
    next = new $c0c895385715e166$export$7254cc27399e90bd(t);
    next.jr = jr.slice();
    state.j[input[len - 1]] = next;
    return next;
}
/**
 * Converts a string of Top-Level Domain names encoded in update-tlds.js back
 * into a list of strings.
 * @param {str} encoded encoded TLDs string
 * @returns {str[]} original TLDs list
 */ function $c0c895385715e166$var$decodeTlds(encoded) {
    const words = [];
    const stack = [];
    let i = 0;
    let digits = "0123456789";
    while(i < encoded.length){
        let popDigitCount = 0;
        while(digits.indexOf(encoded[i + popDigitCount]) >= 0)popDigitCount++; // encountered some digits, have to pop to go one level up trie
        if (popDigitCount > 0) {
            words.push(stack.join("")); // whatever preceded the pop digits must be a word
            for(let popCount = parseInt(encoded.substring(i, i + popDigitCount), 10); popCount > 0; popCount--)stack.pop();
            i += popDigitCount;
        } else {
            stack.push(encoded[i]); // drop down a level into the trie
            i++;
        }
    }
    return words;
}
/**
 * An object where each key is a valid DOM Event Name such as `click` or `focus`
 * and each value is an event handler function.
 *
 * https://developer.mozilla.org/en-US/docs/Web/API/Element#events
 * @typedef {?{ [event: string]: Function }} EventListeners
 */ /**
 * All formatted properties required to render a link, including `tagName`,
 * `attributes`, `content` and `eventListeners`.
 * @typedef {{ tagName: any, attributes: {[attr: string]: any}, content: string,
 * eventListeners: EventListeners }} IntermediateRepresentation
 */ /**
 * Specify either an object described by the template type `O` or a function.
 *
 * The function takes a string value (usually the link's href attribute), the
 * link type (`'url'`, `'hashtag`', etc.) and an internal token representation
 * of the link. It should return an object of the template type `O`
 * @template O
 * @typedef {O | ((value: string, type: string, token: MultiToken) => O)} OptObj
 */ /**
 * Specify either a function described by template type `F` or an object.
 *
 * Each key in the object should be a link type (`'url'`, `'hashtag`', etc.). Each
 * value should be a function with template type `F` that is called when the
 * corresponding link type is encountered.
 * @template F
 * @typedef {F | { [type: string]: F}} OptFn
 */ /**
 * Specify either a value with template type `V`, a function that returns `V` or
 * an object where each value resolves to `V`.
 *
 * The function takes a string value (usually the link's href attribute), the
 * link type (`'url'`, `'hashtag`', etc.) and an internal token representation
 * of the link. It should return an object of the template type `V`
 *
 * For the object, each key should be a link type (`'url'`, `'hashtag`', etc.).
 * Each value should either have type `V` or a function that returns V. This
 * function similarly takes a string value and a token.
 *
 * Example valid types for `Opt<string>`:
 *
 * ```js
 * 'hello'
 * (value, type, token) => 'world'
 * { url: 'hello', email: (value, token) => 'world'}
 * ```
 * @template V
 * @typedef {V | ((value: string, type: string, token: MultiToken) => V) | { [type: string]: V | ((value: string, token: MultiToken) => V) }} Opt
 */ /**
 * See available options: https://linkify.js.org/docs/options.html
 * @typedef {{
 * 	defaultProtocol?: string,
 *  events?: OptObj<EventListeners>,
 * 	format?: Opt<string>,
 * 	formatHref?: Opt<string>,
 * 	nl2br?: boolean,
 * 	tagName?: Opt<any>,
 * 	target?: Opt<string>,
 * 	rel?: Opt<string>,
 * 	validate?: Opt<boolean>,
 * 	truncate?: Opt<number>,
 * 	className?: Opt<string>,
 * 	attributes?: OptObj<({ [attr: string]: any })>,
 *  ignoreTags?: string[],
 * 	render?: OptFn<((ir: IntermediateRepresentation) => any)>
 * }} Opts
 */ /**
 * @type Required<Opts>
 */ const $c0c895385715e166$var$defaults = {
    defaultProtocol: "http",
    events: null,
    format: $c0c895385715e166$var$noop,
    formatHref: $c0c895385715e166$var$noop,
    nl2br: false,
    tagName: "a",
    target: null,
    rel: null,
    validate: true,
    truncate: Infinity,
    className: null,
    attributes: null,
    ignoreTags: [],
    render: null
};
/**
 * Utility class for linkify interfaces to apply specified
 * {@link Opts formatting and rendering options}.
 *
 * @param {Opts | Options} [opts] Option value overrides.
 * @param {(ir: IntermediateRepresentation) => any} [defaultRender] (For
 *   internal use) default render function that determines how to generate an
 *   HTML element based on a link token's derived tagName, attributes and HTML.
 *   Similar to render option
 */ function $c0c895385715e166$export$c019608e5b5bb4cb(opts, defaultRender) {
    if (defaultRender === void 0) defaultRender = null;
    let o = $c0c895385715e166$var$assign({}, $c0c895385715e166$var$defaults);
    if (opts) o = $c0c895385715e166$var$assign(o, opts instanceof $c0c895385715e166$export$c019608e5b5bb4cb ? opts.o : opts);
    // Ensure all ignored tags are uppercase
    const ignoredTags = o.ignoreTags;
    const uppercaseIgnoredTags = [];
    for(let i = 0; i < ignoredTags.length; i++)uppercaseIgnoredTags.push(ignoredTags[i].toUpperCase());
    /** @protected */ this.o = o;
    if (defaultRender) this.defaultRender = defaultRender;
    this.ignoreTags = uppercaseIgnoredTags;
}
$c0c895385715e166$export$c019608e5b5bb4cb.prototype = {
    o: $c0c895385715e166$var$defaults,
    /**
   * @type string[]
   */ ignoreTags: [],
    /**
   * @param {IntermediateRepresentation} ir
   * @returns {any}
   */ defaultRender (ir) {
        return ir;
    },
    /**
   * Returns true or false based on whether a token should be displayed as a
   * link based on the user options.
   * @param {MultiToken} token
   * @returns {boolean}
   */ check (token) {
        return this.get("validate", token.toString(), token);
    },
    // Private methods
    /**
   * Resolve an option's value based on the value of the option and the given
   * params. If operator and token are specified and the target option is
   * callable, automatically calls the function with the given argument.
   * @template {keyof Opts} K
   * @param {K} key Name of option to use
   * @param {string} [operator] will be passed to the target option if it's a
   * function. If not specified, RAW function value gets returned
   * @param {MultiToken} [token] The token from linkify.tokenize
   * @returns {Opts[K] | any}
   */ get (key, operator, token) {
        const isCallable = operator != null;
        let option = this.o[key];
        if (!option) return option;
        if (typeof option === "object") {
            option = token.t in option ? option[token.t] : $c0c895385715e166$var$defaults[key];
            if (typeof option === "function" && isCallable) option = option(operator, token);
        } else if (typeof option === "function" && isCallable) option = option(operator, token.t, token);
        return option;
    },
    /**
   * @template {keyof Opts} L
   * @param {L} key Name of options object to use
   * @param {string} [operator]
   * @param {MultiToken} [token]
   * @returns {Opts[L] | any}
   */ getObj (key, operator, token) {
        let obj = this.o[key];
        if (typeof obj === "function" && operator != null) obj = obj(operator, token.t, token);
        return obj;
    },
    /**
   * Convert the given token to a rendered element that may be added to the
   * calling-interface's DOM
   * @param {MultiToken} token Token to render to an HTML element
   * @returns {any} Render result; e.g., HTML string, DOM element, React
   *   Component, etc.
   */ render (token) {
        const ir = token.render(this); // intermediate representation
        const renderFn = this.get("render", null, token) || this.defaultRender;
        return renderFn(ir, token.t, token);
    }
};
function $c0c895385715e166$var$noop(val) {
    return val;
}
var $c0c895385715e166$export$41c562ebe57d11e2 = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    defaults: $c0c895385715e166$var$defaults,
    Options: $c0c895385715e166$export$c019608e5b5bb4cb,
    assign: $c0c895385715e166$var$assign
});
/******************************************************************************
	Multi-Tokens
	Tokens composed of arrays of TextTokens
******************************************************************************/ /**
 * @param {string} value
 * @param {Token[]} tokens
 */ function $c0c895385715e166$export$28075db42e06f164(value, tokens) {
    this.t = "token";
    this.v = value;
    this.tk = tokens;
}
/**
 * Abstract class used for manufacturing tokens of text tokens. That is rather
 * than the value for a token being a small string of text, it's value an array
 * of text tokens.
 *
 * Used for grouping together URLs, emails, hashtags, and other potential
 * creations.
 * @class MultiToken
 * @property {string} t
 * @property {string} v
 * @property {Token[]} tk
 * @abstract
 */ $c0c895385715e166$export$28075db42e06f164.prototype = {
    isLink: false,
    /**
   * Return the string this token represents.
   * @return {string}
   */ toString () {
        return this.v;
    },
    /**
   * What should the value for this token be in the `href` HTML attribute?
   * Returns the `.toString` value by default.
   * @param {string} [scheme]
   * @return {string}
  */ toHref (scheme) {
        return this.toString();
    },
    /**
   * @param {Options} options Formatting options
   * @returns {string}
   */ toFormattedString (options) {
        const val = this.toString();
        const truncate = options.get("truncate", val, this);
        const formatted = options.get("format", val, this);
        return truncate && formatted.length > truncate ? formatted.substring(0, truncate) + "\u2026" : formatted;
    },
    /**
   *
   * @param {Options} options
   * @returns {string}
   */ toFormattedHref (options) {
        return options.get("formatHref", this.toHref(options.get("defaultProtocol")), this);
    },
    /**
   * The start index of this token in the original input string
   * @returns {number}
   */ startIndex () {
        return this.tk[0].s;
    },
    /**
   * The end index of this token in the original input string (up to this
   * index but not including it)
   * @returns {number}
   */ endIndex () {
        return this.tk[this.tk.length - 1].e;
    },
    /**
  	Returns an object  of relevant values for this token, which includes keys
  	* type - Kind of token ('url', 'email', etc.)
  	* value - Original text
  	* href - The value that should be added to the anchor tag's href
  		attribute
  		@method toObject
  	@param {string} [protocol] `'http'` by default
  */ toObject (protocol) {
        if (protocol === void 0) protocol = $c0c895385715e166$var$defaults.defaultProtocol;
        return {
            type: this.t,
            value: this.toString(),
            isLink: this.isLink,
            href: this.toHref(protocol),
            start: this.startIndex(),
            end: this.endIndex()
        };
    },
    /**
   *
   * @param {Options} options Formatting option
   */ toFormattedObject (options) {
        return {
            type: this.t,
            value: this.toFormattedString(options),
            isLink: this.isLink,
            href: this.toFormattedHref(options),
            start: this.startIndex(),
            end: this.endIndex()
        };
    },
    /**
   * Whether this token should be rendered as a link according to the given options
   * @param {Options} options
   * @returns {boolean}
   */ validate (options) {
        return options.get("validate", this.toString(), this);
    },
    /**
   * Return an object that represents how this link should be rendered.
   * @param {Options} options Formattinng options
   */ render (options) {
        const token = this;
        const href = this.toHref(options.get("defaultProtocol"));
        const formattedHref = options.get("formatHref", href, this);
        const tagName = options.get("tagName", href, token);
        const content = this.toFormattedString(options);
        const attributes = {};
        const className = options.get("className", href, token);
        const target = options.get("target", href, token);
        const rel = options.get("rel", href, token);
        const attrs = options.getObj("attributes", href, token);
        const eventListeners = options.getObj("events", href, token);
        attributes.href = formattedHref;
        if (className) attributes.class = className;
        if (target) attributes.target = target;
        if (rel) attributes.rel = rel;
        if (attrs) $c0c895385715e166$var$assign(attributes, attrs);
        return {
            tagName: tagName,
            attributes: attributes,
            content: content,
            eventListeners: eventListeners
        };
    }
};
/**
 * Create a new token that can be emitted by the parser state machine
 * @param {string} type readable type of the token
 * @param {object} props properties to assign or override, including isLink = true or false
 * @returns {new (value: string, tokens: Token[]) => MultiToken} new token class
 */ function $c0c895385715e166$export$21042e7280c1baba(type, props) {
    class Token extends $c0c895385715e166$export$28075db42e06f164 {
        constructor(value, tokens){
            super(value, tokens);
            this.t = type;
        }
    }
    for(const p in props)Token.prototype[p] = props[p];
    Token.t = type;
    return Token;
}
/**
	Represents a list of tokens making up a valid email address
*/ const $c0c895385715e166$var$Email = $c0c895385715e166$export$21042e7280c1baba("email", {
    isLink: true,
    toHref () {
        return "mailto:" + this.toString();
    }
});
/**
	Represents some plain text
*/ const $c0c895385715e166$var$Text = $c0c895385715e166$export$21042e7280c1baba("text");
/**
	Multi-linebreak token - represents a line break
	@class Nl
*/ const $c0c895385715e166$var$Nl = $c0c895385715e166$export$21042e7280c1baba("nl");
/**
	Represents a list of text tokens making up a valid URL
	@class Url
*/ const $c0c895385715e166$var$Url = $c0c895385715e166$export$21042e7280c1baba("url", {
    isLink: true,
    /**
  	Lowercases relevant parts of the domain and adds the protocol if
  	required. Note that this will not escape unsafe HTML characters in the
  	URL.
  		@param {string} [scheme] default scheme (e.g., 'https')
  	@return {string} the full href
  */ toHref (scheme) {
        if (scheme === void 0) scheme = $c0c895385715e166$var$defaults.defaultProtocol;
        // Check if already has a prefix scheme
        return this.hasProtocol() ? this.v : `${scheme}://${this.v}`;
    },
    /**
   * Check whether this URL token has a protocol
   * @return {boolean}
   */ hasProtocol () {
        const tokens = this.tk;
        return tokens.length >= 2 && tokens[0].t !== $c0c895385715e166$var$LOCALHOST && tokens[1].t === $c0c895385715e166$var$COLON;
    }
});
var $c0c895385715e166$export$13e2537ceeaf8a3a = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    MultiToken: $c0c895385715e166$export$28075db42e06f164,
    Base: $c0c895385715e166$export$28075db42e06f164,
    createTokenClass: $c0c895385715e166$export$21042e7280c1baba,
    Email: $c0c895385715e166$var$Email,
    Text: $c0c895385715e166$var$Text,
    Nl: $c0c895385715e166$var$Nl,
    Url: $c0c895385715e166$var$Url
});
/**
	Not exactly parser, more like the second-stage scanner (although we can
	theoretically hotswap the code here with a real parser in the future... but
	for a little URL-finding utility abstract syntax trees may be a little
	overkill).

	URL format: http://en.wikipedia.org/wiki/URI_scheme
	Email format: http://en.wikipedia.org/wiki/EmailAddress (links to RFC in
	reference)

	@module linkify
	@submodule parser
	@main run
*/ const $c0c895385715e166$var$makeState = (arg)=>new $c0c895385715e166$export$7254cc27399e90bd(arg);
/**
 * Generate the parser multi token-based state machine
 * @param {{ groups: Collections<string> }} tokens
 */ function $c0c895385715e166$var$init$1(_ref) {
    let { groups: groups } = _ref;
    // Types of characters the URL can definitely end in
    const qsAccepting = groups.domain.concat([
        $c0c895385715e166$var$AMPERSAND,
        $c0c895385715e166$var$ASTERISK,
        $c0c895385715e166$var$AT,
        $c0c895385715e166$var$BACKSLASH,
        $c0c895385715e166$var$BACKTICK,
        $c0c895385715e166$var$CARET,
        $c0c895385715e166$var$DOLLAR,
        $c0c895385715e166$var$EQUALS,
        $c0c895385715e166$var$HYPHEN,
        $c0c895385715e166$var$NUM,
        $c0c895385715e166$var$PERCENT,
        $c0c895385715e166$var$PIPE,
        $c0c895385715e166$var$PLUS,
        $c0c895385715e166$var$POUND,
        $c0c895385715e166$var$SLASH,
        $c0c895385715e166$var$SYM,
        $c0c895385715e166$var$TILDE,
        $c0c895385715e166$var$UNDERSCORE
    ]);
    // Types of tokens that can follow a URL and be part of the query string
    // but cannot be the very last characters
    // Characters that cannot appear in the URL at all should be excluded
    const qsNonAccepting = [
        $c0c895385715e166$var$APOSTROPHE,
        $c0c895385715e166$var$COLON,
        $c0c895385715e166$var$COMMA,
        $c0c895385715e166$var$DOT,
        $c0c895385715e166$var$EXCLAMATION,
        $c0c895385715e166$var$QUERY,
        $c0c895385715e166$var$QUOTE,
        $c0c895385715e166$var$SEMI,
        $c0c895385715e166$var$OPENANGLEBRACKET,
        $c0c895385715e166$var$CLOSEANGLEBRACKET,
        $c0c895385715e166$var$OPENBRACE,
        $c0c895385715e166$var$CLOSEBRACE,
        $c0c895385715e166$var$CLOSEBRACKET,
        $c0c895385715e166$var$OPENBRACKET,
        $c0c895385715e166$var$OPENPAREN,
        $c0c895385715e166$var$CLOSEPAREN,
        $c0c895385715e166$var$FULLWIDTHLEFTPAREN,
        $c0c895385715e166$var$FULLWIDTHRIGHTPAREN,
        $c0c895385715e166$var$LEFTCORNERBRACKET,
        $c0c895385715e166$var$RIGHTCORNERBRACKET,
        $c0c895385715e166$var$LEFTWHITECORNERBRACKET,
        $c0c895385715e166$var$RIGHTWHITECORNERBRACKET,
        $c0c895385715e166$var$FULLWIDTHLESSTHAN,
        $c0c895385715e166$var$FULLWIDTHGREATERTHAN
    ];
    // For addresses without the mailto prefix
    // Tokens allowed in the localpart of the email
    const localpartAccepting = [
        $c0c895385715e166$var$AMPERSAND,
        $c0c895385715e166$var$APOSTROPHE,
        $c0c895385715e166$var$ASTERISK,
        $c0c895385715e166$var$BACKSLASH,
        $c0c895385715e166$var$BACKTICK,
        $c0c895385715e166$var$CARET,
        $c0c895385715e166$var$DOLLAR,
        $c0c895385715e166$var$EQUALS,
        $c0c895385715e166$var$HYPHEN,
        $c0c895385715e166$var$OPENBRACE,
        $c0c895385715e166$var$CLOSEBRACE,
        $c0c895385715e166$var$PERCENT,
        $c0c895385715e166$var$PIPE,
        $c0c895385715e166$var$PLUS,
        $c0c895385715e166$var$POUND,
        $c0c895385715e166$var$QUERY,
        $c0c895385715e166$var$SLASH,
        $c0c895385715e166$var$SYM,
        $c0c895385715e166$var$TILDE,
        $c0c895385715e166$var$UNDERSCORE
    ];
    // The universal starting state.
    /**
   * @type State<Token>
   */ const Start = $c0c895385715e166$var$makeState();
    const Localpart = $c0c895385715e166$var$tt(Start, $c0c895385715e166$var$TILDE); // Local part of the email address
    $c0c895385715e166$var$ta(Localpart, localpartAccepting, Localpart);
    $c0c895385715e166$var$ta(Localpart, groups.domain, Localpart);
    const Domain = $c0c895385715e166$var$makeState(), Scheme = $c0c895385715e166$var$makeState(), SlashScheme = $c0c895385715e166$var$makeState();
    $c0c895385715e166$var$ta(Start, groups.domain, Domain); // parsed string ends with a potential domain name (A)
    $c0c895385715e166$var$ta(Start, groups.scheme, Scheme); // e.g., 'mailto'
    $c0c895385715e166$var$ta(Start, groups.slashscheme, SlashScheme); // e.g., 'http'
    $c0c895385715e166$var$ta(Domain, localpartAccepting, Localpart);
    $c0c895385715e166$var$ta(Domain, groups.domain, Domain);
    const LocalpartAt = $c0c895385715e166$var$tt(Domain, $c0c895385715e166$var$AT); // Local part of the email address plus @
    $c0c895385715e166$var$tt(Localpart, $c0c895385715e166$var$AT, LocalpartAt); // close to an email address now
    // Local part of an email address can be e.g. 'http' or 'mailto'
    $c0c895385715e166$var$tt(Scheme, $c0c895385715e166$var$AT, LocalpartAt);
    $c0c895385715e166$var$tt(SlashScheme, $c0c895385715e166$var$AT, LocalpartAt);
    const LocalpartDot = $c0c895385715e166$var$tt(Localpart, $c0c895385715e166$var$DOT); // Local part of the email address plus '.' (localpart cannot end in .)
    $c0c895385715e166$var$ta(LocalpartDot, localpartAccepting, Localpart);
    $c0c895385715e166$var$ta(LocalpartDot, groups.domain, Localpart);
    const EmailDomain = $c0c895385715e166$var$makeState();
    $c0c895385715e166$var$ta(LocalpartAt, groups.domain, EmailDomain); // parsed string starts with local email info + @ with a potential domain name
    $c0c895385715e166$var$ta(EmailDomain, groups.domain, EmailDomain);
    const EmailDomainDot = $c0c895385715e166$var$tt(EmailDomain, $c0c895385715e166$var$DOT); // domain followed by DOT
    $c0c895385715e166$var$ta(EmailDomainDot, groups.domain, EmailDomain);
    const Email$1 = $c0c895385715e166$var$makeState($c0c895385715e166$var$Email); // Possible email address (could have more tlds)
    $c0c895385715e166$var$ta(EmailDomainDot, groups.tld, Email$1);
    $c0c895385715e166$var$ta(EmailDomainDot, groups.utld, Email$1);
    $c0c895385715e166$var$tt(LocalpartAt, $c0c895385715e166$var$LOCALHOST, Email$1);
    // Hyphen can jump back to a domain name
    const EmailDomainHyphen = $c0c895385715e166$var$tt(EmailDomain, $c0c895385715e166$var$HYPHEN); // parsed string starts with local email info + @ with a potential domain name
    $c0c895385715e166$var$ta(EmailDomainHyphen, groups.domain, EmailDomain);
    $c0c895385715e166$var$ta(Email$1, groups.domain, EmailDomain);
    $c0c895385715e166$var$tt(Email$1, $c0c895385715e166$var$DOT, EmailDomainDot);
    $c0c895385715e166$var$tt(Email$1, $c0c895385715e166$var$HYPHEN, EmailDomainHyphen);
    // Final possible email states
    const EmailColon = $c0c895385715e166$var$tt(Email$1, $c0c895385715e166$var$COLON); // URL followed by colon (potential port number here)
    /*const EmailColonPort = */ $c0c895385715e166$var$ta(EmailColon, groups.numeric, $c0c895385715e166$var$Email); // URL followed by colon and port number
    // Account for dots and hyphens. Hyphens are usually parts of domain names
    // (but not TLDs)
    const DomainHyphen = $c0c895385715e166$var$tt(Domain, $c0c895385715e166$var$HYPHEN); // domain followed by hyphen
    const DomainDot = $c0c895385715e166$var$tt(Domain, $c0c895385715e166$var$DOT); // domain followed by DOT
    $c0c895385715e166$var$ta(DomainHyphen, groups.domain, Domain);
    $c0c895385715e166$var$ta(DomainDot, localpartAccepting, Localpart);
    $c0c895385715e166$var$ta(DomainDot, groups.domain, Domain);
    const DomainDotTld = $c0c895385715e166$var$makeState($c0c895385715e166$var$Url); // Simplest possible URL with no query string
    $c0c895385715e166$var$ta(DomainDot, groups.tld, DomainDotTld);
    $c0c895385715e166$var$ta(DomainDot, groups.utld, DomainDotTld);
    $c0c895385715e166$var$ta(DomainDotTld, groups.domain, Domain);
    $c0c895385715e166$var$ta(DomainDotTld, localpartAccepting, Localpart);
    $c0c895385715e166$var$tt(DomainDotTld, $c0c895385715e166$var$DOT, DomainDot);
    $c0c895385715e166$var$tt(DomainDotTld, $c0c895385715e166$var$HYPHEN, DomainHyphen);
    $c0c895385715e166$var$tt(DomainDotTld, $c0c895385715e166$var$AT, LocalpartAt);
    const DomainDotTldColon = $c0c895385715e166$var$tt(DomainDotTld, $c0c895385715e166$var$COLON); // URL followed by colon (potential port number here)
    const DomainDotTldColonPort = $c0c895385715e166$var$makeState($c0c895385715e166$var$Url); // TLD followed by a port number
    $c0c895385715e166$var$ta(DomainDotTldColon, groups.numeric, DomainDotTldColonPort);
    // Long URL with optional port and maybe query string
    const Url$1 = $c0c895385715e166$var$makeState($c0c895385715e166$var$Url);
    // URL with extra symbols at the end, followed by an opening bracket
    const UrlNonaccept = $c0c895385715e166$var$makeState(); // URL followed by some symbols (will not be part of the final URL)
    // Query strings
    $c0c895385715e166$var$ta(Url$1, qsAccepting, Url$1);
    $c0c895385715e166$var$ta(Url$1, qsNonAccepting, UrlNonaccept);
    $c0c895385715e166$var$ta(UrlNonaccept, qsAccepting, Url$1);
    $c0c895385715e166$var$ta(UrlNonaccept, qsNonAccepting, UrlNonaccept);
    // Become real URLs after `SLASH` or `COLON NUM SLASH`
    // Here works with or without scheme:// prefix
    $c0c895385715e166$var$tt(DomainDotTld, $c0c895385715e166$var$SLASH, Url$1);
    $c0c895385715e166$var$tt(DomainDotTldColonPort, $c0c895385715e166$var$SLASH, Url$1);
    // Note that domains that begin with schemes are treated slighly differently
    const SchemeColon = $c0c895385715e166$var$tt(Scheme, $c0c895385715e166$var$COLON); // e.g., 'mailto:'
    const SlashSchemeColon = $c0c895385715e166$var$tt(SlashScheme, $c0c895385715e166$var$COLON); // e.g., 'http:'
    const SlashSchemeColonSlash = $c0c895385715e166$var$tt(SlashSchemeColon, $c0c895385715e166$var$SLASH); // e.g., 'http:/'
    const UriPrefix = $c0c895385715e166$var$tt(SlashSchemeColonSlash, $c0c895385715e166$var$SLASH); // e.g., 'http://'
    // Scheme states can transition to domain states
    $c0c895385715e166$var$ta(Scheme, groups.domain, Domain);
    $c0c895385715e166$var$tt(Scheme, $c0c895385715e166$var$DOT, DomainDot);
    $c0c895385715e166$var$tt(Scheme, $c0c895385715e166$var$HYPHEN, DomainHyphen);
    $c0c895385715e166$var$ta(SlashScheme, groups.domain, Domain);
    $c0c895385715e166$var$tt(SlashScheme, $c0c895385715e166$var$DOT, DomainDot);
    $c0c895385715e166$var$tt(SlashScheme, $c0c895385715e166$var$HYPHEN, DomainHyphen);
    // Force URL with scheme prefix followed by anything sane
    $c0c895385715e166$var$ta(SchemeColon, groups.domain, Url$1);
    $c0c895385715e166$var$tt(SchemeColon, $c0c895385715e166$var$SLASH, Url$1);
    $c0c895385715e166$var$ta(UriPrefix, groups.domain, Url$1);
    $c0c895385715e166$var$ta(UriPrefix, qsAccepting, Url$1);
    $c0c895385715e166$var$tt(UriPrefix, $c0c895385715e166$var$SLASH, Url$1);
    const bracketPairs = [
        [
            $c0c895385715e166$var$OPENBRACE,
            $c0c895385715e166$var$CLOSEBRACE
        ],
        // {}
        [
            $c0c895385715e166$var$OPENBRACKET,
            $c0c895385715e166$var$CLOSEBRACKET
        ],
        // []
        [
            $c0c895385715e166$var$OPENPAREN,
            $c0c895385715e166$var$CLOSEPAREN
        ],
        // ()
        [
            $c0c895385715e166$var$OPENANGLEBRACKET,
            $c0c895385715e166$var$CLOSEANGLEBRACKET
        ],
        // <>
        [
            $c0c895385715e166$var$FULLWIDTHLEFTPAREN,
            $c0c895385715e166$var$FULLWIDTHRIGHTPAREN
        ],
        // （）
        [
            $c0c895385715e166$var$LEFTCORNERBRACKET,
            $c0c895385715e166$var$RIGHTCORNERBRACKET
        ],
        // 「」
        [
            $c0c895385715e166$var$LEFTWHITECORNERBRACKET,
            $c0c895385715e166$var$RIGHTWHITECORNERBRACKET
        ],
        // 『』
        [
            $c0c895385715e166$var$FULLWIDTHLESSTHAN,
            $c0c895385715e166$var$FULLWIDTHGREATERTHAN
        ] // ＜＞
    ];
    for(let i = 0; i < bracketPairs.length; i++){
        const [OPEN, CLOSE] = bracketPairs[i];
        const UrlOpen = $c0c895385715e166$var$tt(Url$1, OPEN); // URL followed by open bracket
        // Continue not accepting for open brackets
        $c0c895385715e166$var$tt(UrlNonaccept, OPEN, UrlOpen);
        // Closing bracket component. This character WILL be included in the URL
        $c0c895385715e166$var$tt(UrlOpen, CLOSE, Url$1);
        // URL that beings with an opening bracket, followed by a symbols.
        // Note that the final state can still be `UrlOpen` (if the URL has a
        // single opening bracket for some reason).
        const UrlOpenQ = $c0c895385715e166$var$makeState($c0c895385715e166$var$Url);
        $c0c895385715e166$var$ta(UrlOpen, qsAccepting, UrlOpenQ);
        const UrlOpenSyms = $c0c895385715e166$var$makeState(); // UrlOpen followed by some symbols it cannot end it
        $c0c895385715e166$var$ta(UrlOpen, qsNonAccepting);
        // URL that begins with an opening bracket, followed by some symbols
        $c0c895385715e166$var$ta(UrlOpenQ, qsAccepting, UrlOpenQ);
        $c0c895385715e166$var$ta(UrlOpenQ, qsNonAccepting, UrlOpenSyms);
        $c0c895385715e166$var$ta(UrlOpenSyms, qsAccepting, UrlOpenQ);
        $c0c895385715e166$var$ta(UrlOpenSyms, qsNonAccepting, UrlOpenSyms);
        // Close brace/bracket to become regular URL
        $c0c895385715e166$var$tt(UrlOpenQ, CLOSE, Url$1);
        $c0c895385715e166$var$tt(UrlOpenSyms, CLOSE, Url$1);
    }
    $c0c895385715e166$var$tt(Start, $c0c895385715e166$var$LOCALHOST, DomainDotTld); // localhost is a valid URL state
    $c0c895385715e166$var$tt(Start, $c0c895385715e166$var$NL$1, $c0c895385715e166$var$Nl); // single new line
    return {
        start: Start,
        tokens: $c0c895385715e166$var$tk
    };
}
/**
 * Run the parser state machine on a list of scanned string-based tokens to
 * create a list of multi tokens, each of which represents a URL, email address,
 * plain text, etc.
 *
 * @param {State<MultiToken>} start parser start state
 * @param {string} input the original input used to generate the given tokens
 * @param {Token[]} tokens list of scanned tokens
 * @returns {MultiToken[]}
 */ function $c0c895385715e166$var$run(start, input, tokens) {
    let len = tokens.length;
    let cursor = 0;
    let multis = [];
    let textTokens = [];
    while(cursor < len){
        let state = start;
        let secondState = null;
        let nextState = null;
        let multiLength = 0;
        let latestAccepting = null;
        let sinceAccepts = -1;
        while(cursor < len && !(secondState = state.go(tokens[cursor].t)))// Starting tokens with nowhere to jump to.
        // Consider these to be just plain text
        textTokens.push(tokens[cursor++]);
        while(cursor < len && (nextState = secondState || state.go(tokens[cursor].t))){
            // Get the next state
            secondState = null;
            state = nextState;
            // Keep track of the latest accepting state
            if (state.accepts()) {
                sinceAccepts = 0;
                latestAccepting = state;
            } else if (sinceAccepts >= 0) sinceAccepts++;
            cursor++;
            multiLength++;
        }
        if (sinceAccepts < 0) {
            // No accepting state was found, part of a regular text token add
            // the first text token to the text tokens array and try again from
            // the next
            cursor -= multiLength;
            if (cursor < len) {
                textTokens.push(tokens[cursor]);
                cursor++;
            }
        } else {
            // Accepting state!
            // First close off the textTokens (if available)
            if (textTokens.length > 0) {
                multis.push($c0c895385715e166$var$initMultiToken($c0c895385715e166$var$Text, input, textTokens));
                textTokens = [];
            }
            // Roll back to the latest accepting state
            cursor -= sinceAccepts;
            multiLength -= sinceAccepts;
            // Create a new multitoken
            const Multi = latestAccepting.t;
            const subtokens = tokens.slice(cursor - multiLength, cursor);
            multis.push($c0c895385715e166$var$initMultiToken(Multi, input, subtokens));
        }
    }
    // Finally close off the textTokens (if available)
    if (textTokens.length > 0) multis.push($c0c895385715e166$var$initMultiToken($c0c895385715e166$var$Text, input, textTokens));
    return multis;
}
/**
 * Utility function for instantiating a new multitoken with all the relevant
 * fields during parsing.
 * @param {new (value: string, tokens: Token[]) => MultiToken} Multi class to instantiate
 * @param {string} input original input string
 * @param {Token[]} tokens consecutive tokens scanned from input string
 * @returns {MultiToken}
 */ function $c0c895385715e166$var$initMultiToken(Multi, input, tokens) {
    const startIdx = tokens[0].s;
    const endIdx = tokens[tokens.length - 1].e;
    const value = input.slice(startIdx, endIdx);
    return new Multi(value, tokens);
}
const $c0c895385715e166$var$warn = typeof console !== "undefined" && console && console.warn || (()=>{});
const $c0c895385715e166$var$warnAdvice = "until manual call of linkify.init(). Register all schemes and plugins before invoking linkify the first time.";
// Side-effect initialization state
const $c0c895385715e166$var$INIT = {
    scanner: null,
    parser: null,
    tokenQueue: [],
    pluginQueue: [],
    customSchemes: [],
    initialized: false
};
/**
 * @typedef {{
 * 	start: State<string>,
 * 	tokens: { groups: Collections<string> } & typeof tk
 * }} ScannerInit
 */ /**
 * @typedef {{
 * 	start: State<MultiToken>,
 * 	tokens: typeof multi
 * }} ParserInit
 */ /**
 * @typedef {(arg: { scanner: ScannerInit }) => void} TokenPlugin
 */ /**
 * @typedef {(arg: { scanner: ScannerInit, parser: ParserInit }) => void} Plugin
 */ /**
 * De-register all plugins and reset the internal state-machine. Used for
 * testing; not required in practice.
 * @private
 */ function $c0c895385715e166$export$aad8462122ac592b() {
    $c0c895385715e166$export$7254cc27399e90bd.groups = {};
    $c0c895385715e166$var$INIT.scanner = null;
    $c0c895385715e166$var$INIT.parser = null;
    $c0c895385715e166$var$INIT.tokenQueue = [];
    $c0c895385715e166$var$INIT.pluginQueue = [];
    $c0c895385715e166$var$INIT.customSchemes = [];
    $c0c895385715e166$var$INIT.initialized = false;
}
/**
 * Register a token plugin to allow the scanner to recognize additional token
 * types before the parser state machine is constructed from the results.
 * @param {string} name of plugin to register
 * @param {TokenPlugin} plugin function that accepts the scanner state machine
 * and available scanner tokens and collections and extends the state machine to
 * recognize additional tokens or groups.
 */ function $c0c895385715e166$export$56d1f1cb1f3c0e96(name, plugin) {
    if (typeof plugin !== "function") throw new Error(`linkifyjs: Invalid token plugin ${plugin} (expects function)`);
    for(let i = 0; i < $c0c895385715e166$var$INIT.tokenQueue.length; i++)if (name === $c0c895385715e166$var$INIT.tokenQueue[i][0]) {
        $c0c895385715e166$var$warn(`linkifyjs: token plugin "${name}" already registered - will be overwritten`);
        $c0c895385715e166$var$INIT.tokenQueue[i] = [
            name,
            plugin
        ];
        return;
    }
    $c0c895385715e166$var$INIT.tokenQueue.push([
        name,
        plugin
    ]);
    if ($c0c895385715e166$var$INIT.initialized) $c0c895385715e166$var$warn(`linkifyjs: already initialized - will not register token plugin "${name}" ${$c0c895385715e166$var$warnAdvice}`);
}
/**
 * Register a linkify plugin
 * @param {string} name of plugin to register
 * @param {Plugin} plugin function that accepts the parser state machine and
 * extends the parser to recognize additional link types
 */ function $c0c895385715e166$export$7612db19fb8beb1e(name, plugin) {
    if (typeof plugin !== "function") throw new Error(`linkifyjs: Invalid plugin ${plugin} (expects function)`);
    for(let i = 0; i < $c0c895385715e166$var$INIT.pluginQueue.length; i++)if (name === $c0c895385715e166$var$INIT.pluginQueue[i][0]) {
        $c0c895385715e166$var$warn(`linkifyjs: plugin "${name}" already registered - will be overwritten`);
        $c0c895385715e166$var$INIT.pluginQueue[i] = [
            name,
            plugin
        ];
        return;
    }
    $c0c895385715e166$var$INIT.pluginQueue.push([
        name,
        plugin
    ]);
    if ($c0c895385715e166$var$INIT.initialized) $c0c895385715e166$var$warn(`linkifyjs: already initialized - will not register plugin "${name}" ${$c0c895385715e166$var$warnAdvice}`);
}
/**
 * Detect URLs with the following additional protocol. Anything with format
 * "protocol://..." will be considered a link. If `optionalSlashSlash` is set to
 * `true`, anything with format "protocol:..." will be considered a link.
 * @param {string} protocol
 * @param {boolean} [optionalSlashSlash]
 */ function $c0c895385715e166$export$821627edc2d26f5f(scheme, optionalSlashSlash) {
    if (optionalSlashSlash === void 0) optionalSlashSlash = false;
    if ($c0c895385715e166$var$INIT.initialized) $c0c895385715e166$var$warn(`linkifyjs: already initialized - will not register custom scheme "${scheme}" ${$c0c895385715e166$var$warnAdvice}`);
    if (!/^[0-9a-z]+(-[0-9a-z]+)*$/.test(scheme)) throw new Error(`linkifyjs: incorrect scheme format.
1. Must only contain digits, lowercase ASCII letters or "-"
2. Cannot start or end with "-"
3. "-" cannot repeat`);
    $c0c895385715e166$var$INIT.customSchemes.push([
        scheme,
        optionalSlashSlash
    ]);
}
/**
 * Initialize the linkify state machine. Called automatically the first time
 * linkify is called on a string, but may be called manually as well.
 */ function $c0c895385715e166$export$2cd8252107eb640b() {
    // Initialize scanner state machine and plugins
    $c0c895385715e166$var$INIT.scanner = $c0c895385715e166$var$init$2($c0c895385715e166$var$INIT.customSchemes);
    for(let i = 0; i < $c0c895385715e166$var$INIT.tokenQueue.length; i++)$c0c895385715e166$var$INIT.tokenQueue[i][1]({
        scanner: $c0c895385715e166$var$INIT.scanner
    });
    // Initialize parser state machine and plugins
    $c0c895385715e166$var$INIT.parser = $c0c895385715e166$var$init$1($c0c895385715e166$var$INIT.scanner.tokens);
    for(let i = 0; i < $c0c895385715e166$var$INIT.pluginQueue.length; i++)$c0c895385715e166$var$INIT.pluginQueue[i][1]({
        scanner: $c0c895385715e166$var$INIT.scanner,
        parser: $c0c895385715e166$var$INIT.parser
    });
    $c0c895385715e166$var$INIT.initialized = true;
}
/**
 * Parse a string into tokens that represent linkable and non-linkable sub-components
 * @param {string} str
 * @return {MultiToken[]} tokens
 */ function $c0c895385715e166$export$660b2ee2d4fb4eff(str) {
    if (!$c0c895385715e166$var$INIT.initialized) $c0c895385715e166$export$2cd8252107eb640b();
    return $c0c895385715e166$var$run($c0c895385715e166$var$INIT.parser.start, str, $c0c895385715e166$var$run$1($c0c895385715e166$var$INIT.scanner.start, str));
}
/**
 * Find a list of linkable items in the given string.
 * @param {string} str string to find links in
 * @param {string | Opts} [type] either formatting options or specific type of
 * links to find, e.g., 'url' or 'email'
 * @param {Opts} [opts] formatting options for final output. Cannot be specified
 * if opts already provided in `type` argument
 */ function $c0c895385715e166$export$71aa6c912b956294(str, type, opts) {
    if (type === void 0) type = null;
    if (opts === void 0) opts = null;
    if (type && typeof type === "object") {
        if (opts) throw Error(`linkifyjs: Invalid link type ${type}; must be a string`);
        opts = type;
        type = null;
    }
    const options = new $c0c895385715e166$export$c019608e5b5bb4cb(opts);
    const tokens = $c0c895385715e166$export$660b2ee2d4fb4eff(str);
    const filtered = [];
    for(let i = 0; i < tokens.length; i++){
        const token = tokens[i];
        if (token.isLink && (!type || token.t === type) && options.check(token)) filtered.push(token.toFormattedObject(options));
    }
    return filtered;
}
/**
 * Is the given string valid linkable text of some sort. Note that this does not
 * trim the text for you.
 *
 * Optionally pass in a second `type` param, which is the type of link to test
 * for.
 *
 * For example,
 *
 *     linkify.test(str, 'email');
 *
 * Returns `true` if str is a valid email.
 * @param {string} str string to test for links
 * @param {string} [type] optional specific link type to look for
 * @returns boolean true/false
 */ function $c0c895385715e166$export$e0969da9b8fb378d(str, type) {
    if (type === void 0) type = null;
    const tokens = $c0c895385715e166$export$660b2ee2d4fb4eff(str);
    return tokens.length === 1 && tokens[0].isLink && (!type || tokens[0].t === type);
}


/**
	Convert strings of text into linkable HTML text
*/ function $238583bf201af313$var$escapeText(text) {
    return text.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
}
function $238583bf201af313$var$escapeAttr(href) {
    return href.replace(/"/g, "&quot;");
}
function $238583bf201af313$var$attributesToString(attributes) {
    const result = [];
    for(const attr in attributes){
        let val = attributes[attr] + "";
        result.push(`${attr}="${$238583bf201af313$var$escapeAttr(val)}"`);
    }
    return result.join(" ");
}
function $238583bf201af313$var$defaultRender(_ref) {
    let { tagName: tagName, attributes: attributes, content: content } = _ref;
    return `<${tagName} ${$238583bf201af313$var$attributesToString(attributes)}>${$238583bf201af313$var$escapeText(content)}</${tagName}>`;
}
/**
 * Convert a plan text string to an HTML string with links. Expects that the
 * given strings does not contain any HTML entities. Use the linkify-html
 * interface if you need to parse HTML entities.
 *
 * @param {string} str string to linkify
 * @param {import('linkifyjs').Opts} [opts] overridable options
 * @returns {string}
 */ function $238583bf201af313$export$2e2bcd8739ae039(str, opts) {
    if (opts === void 0) opts = {};
    opts = new (0, $c0c895385715e166$export$c019608e5b5bb4cb)(opts, $238583bf201af313$var$defaultRender);
    const tokens = (0, $c0c895385715e166$export$660b2ee2d4fb4eff)(str);
    const result = [];
    for(let i = 0; i < tokens.length; i++){
        const token = tokens[i];
        if (token.t === "nl" && opts.get("nl2br")) result.push("<br>\n");
        else if (!token.isLink || !opts.check(token)) result.push($238583bf201af313$var$escapeText(token.toString()));
        else result.push(opts.render(token));
    }
    return result.join("");
}
if (!String.prototype.linkify) Object.defineProperty(String.prototype, "linkify", {
    writable: false,
    value: function linkify(options) {
        return $238583bf201af313$export$2e2bcd8739ae039(this, options);
    }
});


var $8f13b60c0ee5b277$exports = {};
$8f13b60c0ee5b277$exports = JSON.parse('{"name":"toplist","version":"0.0.0","author":"","license":"ISC","description":"","dependencies":{"js-levenshtein":"^1.1.6","linkify-string":"^4.1.3","linkifyjs":"^4.1.3","lit-html":"^3.1.4","qrcode-svg":"^1.1.0","unique-names-generator":"^4.7.1"},"devDependencies":{"@parcel/packager-raw-url":"^2.12.0","@parcel/transformer-webmanifest":"^2.12.0","pre-commit":"^1.2.2"},"scripts":{"test":"echo \\"Error: no test specified\\" && exit 1","fmt-check":"npx prettier -c **.{mjs,html,css,yml}","fmt":"npm run fmt-check -- -w","build":"npx parcel build --public-url /toplist","serve":"npx parcel serve"},"targets":{"default":{"source":["./index.html"]}},"pre-commit":["fmt-check"]}');


var $7be1938ba9eee7d1$exports = {};
/**
 * @fileoverview
 * - modified davidshimjs/qrcodejs library for use in node.js
 * - Using the 'QRCode for Javascript library'
 * - Fixed dataset of 'QRCode for Javascript library' for support full-spec.
 * - this library has no dependencies.
 *
 * @version 0.9.1 (2016-02-12)
 * @author davidshimjs, papnkukn
 * @see <a href="http://www.d-project.com/" target="_blank">http://www.d-project.com/</a>
 * @see <a href="http://jeromeetienne.github.com/jquery-qrcode/" target="_blank">http://jeromeetienne.github.com/jquery-qrcode/</a>
 * @see <a href="https://github.com/davidshimjs/qrcodejs" target="_blank">https://github.com/davidshimjs/qrcodejs</a>
 */ //---------------------------------------------------------------------
// QRCode for JavaScript
//
// Copyright (c) 2009 Kazuhiko Arase
//
// URL: http://www.d-project.com/
//
// Licensed under the MIT license:
//   http://www.opensource.org/licenses/mit-license.php
//
// The word "QR Code" is registered trademark of 
// DENSO WAVE INCORPORATED
//   http://www.denso-wave.com/qrcode/faqpatent-e.html
//
//---------------------------------------------------------------------
function $7be1938ba9eee7d1$var$QR8bitByte(data) {
    this.mode = $7be1938ba9eee7d1$var$QRMode.MODE_8BIT_BYTE;
    this.data = data;
    this.parsedData = [];
    // Added to support UTF-8 Characters
    for(var i = 0, l = this.data.length; i < l; i++){
        var byteArray = [];
        var code = this.data.charCodeAt(i);
        if (code > 0x10000) {
            byteArray[0] = 0xF0 | (code & 0x1C0000) >>> 18;
            byteArray[1] = 0x80 | (code & 0x3F000) >>> 12;
            byteArray[2] = 0x80 | (code & 0xFC0) >>> 6;
            byteArray[3] = 0x80 | code & 0x3F;
        } else if (code > 0x800) {
            byteArray[0] = 0xE0 | (code & 0xF000) >>> 12;
            byteArray[1] = 0x80 | (code & 0xFC0) >>> 6;
            byteArray[2] = 0x80 | code & 0x3F;
        } else if (code > 0x80) {
            byteArray[0] = 0xC0 | (code & 0x7C0) >>> 6;
            byteArray[1] = 0x80 | code & 0x3F;
        } else byteArray[0] = code;
        this.parsedData.push(byteArray);
    }
    this.parsedData = Array.prototype.concat.apply([], this.parsedData);
    if (this.parsedData.length != this.data.length) {
        this.parsedData.unshift(191);
        this.parsedData.unshift(187);
        this.parsedData.unshift(239);
    }
}
$7be1938ba9eee7d1$var$QR8bitByte.prototype = {
    getLength: function(buffer) {
        return this.parsedData.length;
    },
    write: function(buffer) {
        for(var i = 0, l = this.parsedData.length; i < l; i++)buffer.put(this.parsedData[i], 8);
    }
};
function $7be1938ba9eee7d1$var$QRCodeModel(typeNumber, errorCorrectLevel) {
    this.typeNumber = typeNumber;
    this.errorCorrectLevel = errorCorrectLevel;
    this.modules = null;
    this.moduleCount = 0;
    this.dataCache = null;
    this.dataList = [];
}
$7be1938ba9eee7d1$var$QRCodeModel.prototype = {
    addData: function(data) {
        var newData = new $7be1938ba9eee7d1$var$QR8bitByte(data);
        this.dataList.push(newData);
        this.dataCache = null;
    },
    isDark: function(row, col) {
        if (row < 0 || this.moduleCount <= row || col < 0 || this.moduleCount <= col) throw new Error(row + "," + col);
        return this.modules[row][col];
    },
    getModuleCount: function() {
        return this.moduleCount;
    },
    make: function() {
        this.makeImpl(false, this.getBestMaskPattern());
    },
    makeImpl: function(test, maskPattern) {
        this.moduleCount = this.typeNumber * 4 + 17;
        this.modules = new Array(this.moduleCount);
        for(var row = 0; row < this.moduleCount; row++){
            this.modules[row] = new Array(this.moduleCount);
            for(var col = 0; col < this.moduleCount; col++)this.modules[row][col] = null;
        }
        this.setupPositionProbePattern(0, 0);
        this.setupPositionProbePattern(this.moduleCount - 7, 0);
        this.setupPositionProbePattern(0, this.moduleCount - 7);
        this.setupPositionAdjustPattern();
        this.setupTimingPattern();
        this.setupTypeInfo(test, maskPattern);
        if (this.typeNumber >= 7) this.setupTypeNumber(test);
        if (this.dataCache == null) this.dataCache = $7be1938ba9eee7d1$var$QRCodeModel.createData(this.typeNumber, this.errorCorrectLevel, this.dataList);
        this.mapData(this.dataCache, maskPattern);
    },
    setupPositionProbePattern: function(row, col) {
        for(var r = -1; r <= 7; r++){
            if (row + r <= -1 || this.moduleCount <= row + r) continue;
            for(var c = -1; c <= 7; c++){
                if (col + c <= -1 || this.moduleCount <= col + c) continue;
                if (0 <= r && r <= 6 && (c == 0 || c == 6) || 0 <= c && c <= 6 && (r == 0 || r == 6) || 2 <= r && r <= 4 && 2 <= c && c <= 4) this.modules[row + r][col + c] = true;
                else this.modules[row + r][col + c] = false;
            }
        }
    },
    getBestMaskPattern: function() {
        var minLostPoint = 0;
        var pattern = 0;
        for(var i = 0; i < 8; i++){
            this.makeImpl(true, i);
            var lostPoint = $7be1938ba9eee7d1$var$QRUtil.getLostPoint(this);
            if (i == 0 || minLostPoint > lostPoint) {
                minLostPoint = lostPoint;
                pattern = i;
            }
        }
        return pattern;
    },
    createMovieClip: function(target_mc, instance_name, depth) {
        var qr_mc = target_mc.createEmptyMovieClip(instance_name, depth);
        var cs = 1;
        this.make();
        for(var row = 0; row < this.modules.length; row++){
            var y = row * cs;
            for(var col = 0; col < this.modules[row].length; col++){
                var x = col * cs;
                var dark = this.modules[row][col];
                if (dark) {
                    qr_mc.beginFill(0, 100);
                    qr_mc.moveTo(x, y);
                    qr_mc.lineTo(x + cs, y);
                    qr_mc.lineTo(x + cs, y + cs);
                    qr_mc.lineTo(x, y + cs);
                    qr_mc.endFill();
                }
            }
        }
        return qr_mc;
    },
    setupTimingPattern: function() {
        for(var r = 8; r < this.moduleCount - 8; r++){
            if (this.modules[r][6] != null) continue;
            this.modules[r][6] = r % 2 == 0;
        }
        for(var c = 8; c < this.moduleCount - 8; c++){
            if (this.modules[6][c] != null) continue;
            this.modules[6][c] = c % 2 == 0;
        }
    },
    setupPositionAdjustPattern: function() {
        var pos = $7be1938ba9eee7d1$var$QRUtil.getPatternPosition(this.typeNumber);
        for(var i = 0; i < pos.length; i++)for(var j = 0; j < pos.length; j++){
            var row = pos[i];
            var col = pos[j];
            if (this.modules[row][col] != null) continue;
            for(var r = -2; r <= 2; r++){
                for(var c = -2; c <= 2; c++)if (r == -2 || r == 2 || c == -2 || c == 2 || r == 0 && c == 0) this.modules[row + r][col + c] = true;
                else this.modules[row + r][col + c] = false;
            }
        }
    },
    setupTypeNumber: function(test) {
        var bits = $7be1938ba9eee7d1$var$QRUtil.getBCHTypeNumber(this.typeNumber);
        for(var i = 0; i < 18; i++){
            var mod = !test && (bits >> i & 1) == 1;
            this.modules[Math.floor(i / 3)][i % 3 + this.moduleCount - 8 - 3] = mod;
        }
        for(var i = 0; i < 18; i++){
            var mod = !test && (bits >> i & 1) == 1;
            this.modules[i % 3 + this.moduleCount - 8 - 3][Math.floor(i / 3)] = mod;
        }
    },
    setupTypeInfo: function(test, maskPattern) {
        var data = this.errorCorrectLevel << 3 | maskPattern;
        var bits = $7be1938ba9eee7d1$var$QRUtil.getBCHTypeInfo(data);
        for(var i = 0; i < 15; i++){
            var mod = !test && (bits >> i & 1) == 1;
            if (i < 6) this.modules[i][8] = mod;
            else if (i < 8) this.modules[i + 1][8] = mod;
            else this.modules[this.moduleCount - 15 + i][8] = mod;
        }
        for(var i = 0; i < 15; i++){
            var mod = !test && (bits >> i & 1) == 1;
            if (i < 8) this.modules[8][this.moduleCount - i - 1] = mod;
            else if (i < 9) this.modules[8][15 - i - 1 + 1] = mod;
            else this.modules[8][15 - i - 1] = mod;
        }
        this.modules[this.moduleCount - 8][8] = !test;
    },
    mapData: function(data, maskPattern) {
        var inc = -1;
        var row = this.moduleCount - 1;
        var bitIndex = 7;
        var byteIndex = 0;
        for(var col = this.moduleCount - 1; col > 0; col -= 2){
            if (col == 6) col--;
            while(true){
                for(var c = 0; c < 2; c++)if (this.modules[row][col - c] == null) {
                    var dark = false;
                    if (byteIndex < data.length) dark = (data[byteIndex] >>> bitIndex & 1) == 1;
                    var mask = $7be1938ba9eee7d1$var$QRUtil.getMask(maskPattern, row, col - c);
                    if (mask) dark = !dark;
                    this.modules[row][col - c] = dark;
                    bitIndex--;
                    if (bitIndex == -1) {
                        byteIndex++;
                        bitIndex = 7;
                    }
                }
                row += inc;
                if (row < 0 || this.moduleCount <= row) {
                    row -= inc;
                    inc = -inc;
                    break;
                }
            }
        }
    }
};
$7be1938ba9eee7d1$var$QRCodeModel.PAD0 = 0xEC;
$7be1938ba9eee7d1$var$QRCodeModel.PAD1 = 0x11;
$7be1938ba9eee7d1$var$QRCodeModel.createData = function(typeNumber, errorCorrectLevel, dataList) {
    var rsBlocks = $7be1938ba9eee7d1$var$QRRSBlock.getRSBlocks(typeNumber, errorCorrectLevel);
    var buffer = new $7be1938ba9eee7d1$var$QRBitBuffer();
    for(var i = 0; i < dataList.length; i++){
        var data = dataList[i];
        buffer.put(data.mode, 4);
        buffer.put(data.getLength(), $7be1938ba9eee7d1$var$QRUtil.getLengthInBits(data.mode, typeNumber));
        data.write(buffer);
    }
    var totalDataCount = 0;
    for(var i = 0; i < rsBlocks.length; i++)totalDataCount += rsBlocks[i].dataCount;
    if (buffer.getLengthInBits() > totalDataCount * 8) throw new Error("code length overflow. (" + buffer.getLengthInBits() + ">" + totalDataCount * 8 + ")");
    if (buffer.getLengthInBits() + 4 <= totalDataCount * 8) buffer.put(0, 4);
    while(buffer.getLengthInBits() % 8 != 0)buffer.putBit(false);
    while(true){
        if (buffer.getLengthInBits() >= totalDataCount * 8) break;
        buffer.put($7be1938ba9eee7d1$var$QRCodeModel.PAD0, 8);
        if (buffer.getLengthInBits() >= totalDataCount * 8) break;
        buffer.put($7be1938ba9eee7d1$var$QRCodeModel.PAD1, 8);
    }
    return $7be1938ba9eee7d1$var$QRCodeModel.createBytes(buffer, rsBlocks);
};
$7be1938ba9eee7d1$var$QRCodeModel.createBytes = function(buffer, rsBlocks) {
    var offset = 0;
    var maxDcCount = 0;
    var maxEcCount = 0;
    var dcdata = new Array(rsBlocks.length);
    var ecdata = new Array(rsBlocks.length);
    for(var r = 0; r < rsBlocks.length; r++){
        var dcCount = rsBlocks[r].dataCount;
        var ecCount = rsBlocks[r].totalCount - dcCount;
        maxDcCount = Math.max(maxDcCount, dcCount);
        maxEcCount = Math.max(maxEcCount, ecCount);
        dcdata[r] = new Array(dcCount);
        for(var i = 0; i < dcdata[r].length; i++)dcdata[r][i] = 0xff & buffer.buffer[i + offset];
        offset += dcCount;
        var rsPoly = $7be1938ba9eee7d1$var$QRUtil.getErrorCorrectPolynomial(ecCount);
        var rawPoly = new $7be1938ba9eee7d1$var$QRPolynomial(dcdata[r], rsPoly.getLength() - 1);
        var modPoly = rawPoly.mod(rsPoly);
        ecdata[r] = new Array(rsPoly.getLength() - 1);
        for(var i = 0; i < ecdata[r].length; i++){
            var modIndex = i + modPoly.getLength() - ecdata[r].length;
            ecdata[r][i] = modIndex >= 0 ? modPoly.get(modIndex) : 0;
        }
    }
    var totalCodeCount = 0;
    for(var i = 0; i < rsBlocks.length; i++)totalCodeCount += rsBlocks[i].totalCount;
    var data = new Array(totalCodeCount);
    var index = 0;
    for(var i = 0; i < maxDcCount; i++){
        for(var r = 0; r < rsBlocks.length; r++)if (i < dcdata[r].length) data[index++] = dcdata[r][i];
    }
    for(var i = 0; i < maxEcCount; i++){
        for(var r = 0; r < rsBlocks.length; r++)if (i < ecdata[r].length) data[index++] = ecdata[r][i];
    }
    return data;
};
var $7be1938ba9eee7d1$var$QRMode = {
    MODE_NUMBER: 1,
    MODE_ALPHA_NUM: 2,
    MODE_8BIT_BYTE: 4,
    MODE_KANJI: 8
};
var $7be1938ba9eee7d1$var$QRErrorCorrectLevel = {
    L: 1,
    M: 0,
    Q: 3,
    H: 2
};
var $7be1938ba9eee7d1$var$QRMaskPattern = {
    PATTERN000: 0,
    PATTERN001: 1,
    PATTERN010: 2,
    PATTERN011: 3,
    PATTERN100: 4,
    PATTERN101: 5,
    PATTERN110: 6,
    PATTERN111: 7
};
var $7be1938ba9eee7d1$var$QRUtil = {
    PATTERN_POSITION_TABLE: [
        [],
        [
            6,
            18
        ],
        [
            6,
            22
        ],
        [
            6,
            26
        ],
        [
            6,
            30
        ],
        [
            6,
            34
        ],
        [
            6,
            22,
            38
        ],
        [
            6,
            24,
            42
        ],
        [
            6,
            26,
            46
        ],
        [
            6,
            28,
            50
        ],
        [
            6,
            30,
            54
        ],
        [
            6,
            32,
            58
        ],
        [
            6,
            34,
            62
        ],
        [
            6,
            26,
            46,
            66
        ],
        [
            6,
            26,
            48,
            70
        ],
        [
            6,
            26,
            50,
            74
        ],
        [
            6,
            30,
            54,
            78
        ],
        [
            6,
            30,
            56,
            82
        ],
        [
            6,
            30,
            58,
            86
        ],
        [
            6,
            34,
            62,
            90
        ],
        [
            6,
            28,
            50,
            72,
            94
        ],
        [
            6,
            26,
            50,
            74,
            98
        ],
        [
            6,
            30,
            54,
            78,
            102
        ],
        [
            6,
            28,
            54,
            80,
            106
        ],
        [
            6,
            32,
            58,
            84,
            110
        ],
        [
            6,
            30,
            58,
            86,
            114
        ],
        [
            6,
            34,
            62,
            90,
            118
        ],
        [
            6,
            26,
            50,
            74,
            98,
            122
        ],
        [
            6,
            30,
            54,
            78,
            102,
            126
        ],
        [
            6,
            26,
            52,
            78,
            104,
            130
        ],
        [
            6,
            30,
            56,
            82,
            108,
            134
        ],
        [
            6,
            34,
            60,
            86,
            112,
            138
        ],
        [
            6,
            30,
            58,
            86,
            114,
            142
        ],
        [
            6,
            34,
            62,
            90,
            118,
            146
        ],
        [
            6,
            30,
            54,
            78,
            102,
            126,
            150
        ],
        [
            6,
            24,
            50,
            76,
            102,
            128,
            154
        ],
        [
            6,
            28,
            54,
            80,
            106,
            132,
            158
        ],
        [
            6,
            32,
            58,
            84,
            110,
            136,
            162
        ],
        [
            6,
            26,
            54,
            82,
            110,
            138,
            166
        ],
        [
            6,
            30,
            58,
            86,
            114,
            142,
            170
        ]
    ],
    G15: 1335,
    G18: 7973,
    G15_MASK: 21522,
    getBCHTypeInfo: function(data) {
        var d = data << 10;
        while($7be1938ba9eee7d1$var$QRUtil.getBCHDigit(d) - $7be1938ba9eee7d1$var$QRUtil.getBCHDigit($7be1938ba9eee7d1$var$QRUtil.G15) >= 0)d ^= $7be1938ba9eee7d1$var$QRUtil.G15 << $7be1938ba9eee7d1$var$QRUtil.getBCHDigit(d) - $7be1938ba9eee7d1$var$QRUtil.getBCHDigit($7be1938ba9eee7d1$var$QRUtil.G15);
        return (data << 10 | d) ^ $7be1938ba9eee7d1$var$QRUtil.G15_MASK;
    },
    getBCHTypeNumber: function(data) {
        var d = data << 12;
        while($7be1938ba9eee7d1$var$QRUtil.getBCHDigit(d) - $7be1938ba9eee7d1$var$QRUtil.getBCHDigit($7be1938ba9eee7d1$var$QRUtil.G18) >= 0)d ^= $7be1938ba9eee7d1$var$QRUtil.G18 << $7be1938ba9eee7d1$var$QRUtil.getBCHDigit(d) - $7be1938ba9eee7d1$var$QRUtil.getBCHDigit($7be1938ba9eee7d1$var$QRUtil.G18);
        return data << 12 | d;
    },
    getBCHDigit: function(data) {
        var digit = 0;
        while(data != 0){
            digit++;
            data >>>= 1;
        }
        return digit;
    },
    getPatternPosition: function(typeNumber) {
        return $7be1938ba9eee7d1$var$QRUtil.PATTERN_POSITION_TABLE[typeNumber - 1];
    },
    getMask: function(maskPattern, i, j) {
        switch(maskPattern){
            case $7be1938ba9eee7d1$var$QRMaskPattern.PATTERN000:
                return (i + j) % 2 == 0;
            case $7be1938ba9eee7d1$var$QRMaskPattern.PATTERN001:
                return i % 2 == 0;
            case $7be1938ba9eee7d1$var$QRMaskPattern.PATTERN010:
                return j % 3 == 0;
            case $7be1938ba9eee7d1$var$QRMaskPattern.PATTERN011:
                return (i + j) % 3 == 0;
            case $7be1938ba9eee7d1$var$QRMaskPattern.PATTERN100:
                return (Math.floor(i / 2) + Math.floor(j / 3)) % 2 == 0;
            case $7be1938ba9eee7d1$var$QRMaskPattern.PATTERN101:
                return i * j % 2 + i * j % 3 == 0;
            case $7be1938ba9eee7d1$var$QRMaskPattern.PATTERN110:
                return (i * j % 2 + i * j % 3) % 2 == 0;
            case $7be1938ba9eee7d1$var$QRMaskPattern.PATTERN111:
                return (i * j % 3 + (i + j) % 2) % 2 == 0;
            default:
                throw new Error("bad maskPattern:" + maskPattern);
        }
    },
    getErrorCorrectPolynomial: function(errorCorrectLength) {
        var a = new $7be1938ba9eee7d1$var$QRPolynomial([
            1
        ], 0);
        for(var i = 0; i < errorCorrectLength; i++)a = a.multiply(new $7be1938ba9eee7d1$var$QRPolynomial([
            1,
            $7be1938ba9eee7d1$var$QRMath.gexp(i)
        ], 0));
        return a;
    },
    getLengthInBits: function(mode, type) {
        if (1 <= type && type < 10) switch(mode){
            case $7be1938ba9eee7d1$var$QRMode.MODE_NUMBER:
                return 10;
            case $7be1938ba9eee7d1$var$QRMode.MODE_ALPHA_NUM:
                return 9;
            case $7be1938ba9eee7d1$var$QRMode.MODE_8BIT_BYTE:
                return 8;
            case $7be1938ba9eee7d1$var$QRMode.MODE_KANJI:
                return 8;
            default:
                throw new Error("mode:" + mode);
        }
        else if (type < 27) switch(mode){
            case $7be1938ba9eee7d1$var$QRMode.MODE_NUMBER:
                return 12;
            case $7be1938ba9eee7d1$var$QRMode.MODE_ALPHA_NUM:
                return 11;
            case $7be1938ba9eee7d1$var$QRMode.MODE_8BIT_BYTE:
                return 16;
            case $7be1938ba9eee7d1$var$QRMode.MODE_KANJI:
                return 10;
            default:
                throw new Error("mode:" + mode);
        }
        else if (type < 41) switch(mode){
            case $7be1938ba9eee7d1$var$QRMode.MODE_NUMBER:
                return 14;
            case $7be1938ba9eee7d1$var$QRMode.MODE_ALPHA_NUM:
                return 13;
            case $7be1938ba9eee7d1$var$QRMode.MODE_8BIT_BYTE:
                return 16;
            case $7be1938ba9eee7d1$var$QRMode.MODE_KANJI:
                return 12;
            default:
                throw new Error("mode:" + mode);
        }
        else throw new Error("type:" + type);
    },
    getLostPoint: function(qrCode) {
        var moduleCount = qrCode.getModuleCount();
        var lostPoint = 0;
        for(var row = 0; row < moduleCount; row++)for(var col = 0; col < moduleCount; col++){
            var sameCount = 0;
            var dark = qrCode.isDark(row, col);
            for(var r = -1; r <= 1; r++){
                if (row + r < 0 || moduleCount <= row + r) continue;
                for(var c = -1; c <= 1; c++){
                    if (col + c < 0 || moduleCount <= col + c) continue;
                    if (r == 0 && c == 0) continue;
                    if (dark == qrCode.isDark(row + r, col + c)) sameCount++;
                }
            }
            if (sameCount > 5) lostPoint += 3 + sameCount - 5;
        }
        for(var row = 0; row < moduleCount - 1; row++)for(var col = 0; col < moduleCount - 1; col++){
            var count = 0;
            if (qrCode.isDark(row, col)) count++;
            if (qrCode.isDark(row + 1, col)) count++;
            if (qrCode.isDark(row, col + 1)) count++;
            if (qrCode.isDark(row + 1, col + 1)) count++;
            if (count == 0 || count == 4) lostPoint += 3;
        }
        for(var row = 0; row < moduleCount; row++){
            for(var col = 0; col < moduleCount - 6; col++)if (qrCode.isDark(row, col) && !qrCode.isDark(row, col + 1) && qrCode.isDark(row, col + 2) && qrCode.isDark(row, col + 3) && qrCode.isDark(row, col + 4) && !qrCode.isDark(row, col + 5) && qrCode.isDark(row, col + 6)) lostPoint += 40;
        }
        for(var col = 0; col < moduleCount; col++){
            for(var row = 0; row < moduleCount - 6; row++)if (qrCode.isDark(row, col) && !qrCode.isDark(row + 1, col) && qrCode.isDark(row + 2, col) && qrCode.isDark(row + 3, col) && qrCode.isDark(row + 4, col) && !qrCode.isDark(row + 5, col) && qrCode.isDark(row + 6, col)) lostPoint += 40;
        }
        var darkCount = 0;
        for(var col = 0; col < moduleCount; col++){
            for(var row = 0; row < moduleCount; row++)if (qrCode.isDark(row, col)) darkCount++;
        }
        var ratio = Math.abs(100 * darkCount / moduleCount / moduleCount - 50) / 5;
        lostPoint += ratio * 10;
        return lostPoint;
    }
};
var $7be1938ba9eee7d1$var$QRMath = {
    glog: function(n) {
        if (n < 1) throw new Error("glog(" + n + ")");
        return $7be1938ba9eee7d1$var$QRMath.LOG_TABLE[n];
    },
    gexp: function(n) {
        while(n < 0)n += 255;
        while(n >= 256)n -= 255;
        return $7be1938ba9eee7d1$var$QRMath.EXP_TABLE[n];
    },
    EXP_TABLE: new Array(256),
    LOG_TABLE: new Array(256)
};
for(var $7be1938ba9eee7d1$var$i = 0; $7be1938ba9eee7d1$var$i < 8; $7be1938ba9eee7d1$var$i++)$7be1938ba9eee7d1$var$QRMath.EXP_TABLE[$7be1938ba9eee7d1$var$i] = 1 << $7be1938ba9eee7d1$var$i;
for(var $7be1938ba9eee7d1$var$i = 8; $7be1938ba9eee7d1$var$i < 256; $7be1938ba9eee7d1$var$i++)$7be1938ba9eee7d1$var$QRMath.EXP_TABLE[$7be1938ba9eee7d1$var$i] = $7be1938ba9eee7d1$var$QRMath.EXP_TABLE[$7be1938ba9eee7d1$var$i - 4] ^ $7be1938ba9eee7d1$var$QRMath.EXP_TABLE[$7be1938ba9eee7d1$var$i - 5] ^ $7be1938ba9eee7d1$var$QRMath.EXP_TABLE[$7be1938ba9eee7d1$var$i - 6] ^ $7be1938ba9eee7d1$var$QRMath.EXP_TABLE[$7be1938ba9eee7d1$var$i - 8];
for(var $7be1938ba9eee7d1$var$i = 0; $7be1938ba9eee7d1$var$i < 255; $7be1938ba9eee7d1$var$i++)$7be1938ba9eee7d1$var$QRMath.LOG_TABLE[$7be1938ba9eee7d1$var$QRMath.EXP_TABLE[$7be1938ba9eee7d1$var$i]] = $7be1938ba9eee7d1$var$i;
function $7be1938ba9eee7d1$var$QRPolynomial(num, shift) {
    if (num.length == undefined) throw new Error(num.length + "/" + shift);
    var offset = 0;
    while(offset < num.length && num[offset] == 0)offset++;
    this.num = new Array(num.length - offset + shift);
    for(var i = 0; i < num.length - offset; i++)this.num[i] = num[i + offset];
}
$7be1938ba9eee7d1$var$QRPolynomial.prototype = {
    get: function(index) {
        return this.num[index];
    },
    getLength: function() {
        return this.num.length;
    },
    multiply: function(e) {
        var num = new Array(this.getLength() + e.getLength() - 1);
        for(var i = 0; i < this.getLength(); i++)for(var j = 0; j < e.getLength(); j++)num[i + j] ^= $7be1938ba9eee7d1$var$QRMath.gexp($7be1938ba9eee7d1$var$QRMath.glog(this.get(i)) + $7be1938ba9eee7d1$var$QRMath.glog(e.get(j)));
        return new $7be1938ba9eee7d1$var$QRPolynomial(num, 0);
    },
    mod: function(e) {
        if (this.getLength() - e.getLength() < 0) return this;
        var ratio = $7be1938ba9eee7d1$var$QRMath.glog(this.get(0)) - $7be1938ba9eee7d1$var$QRMath.glog(e.get(0));
        var num = new Array(this.getLength());
        for(var i = 0; i < this.getLength(); i++)num[i] = this.get(i);
        for(var i = 0; i < e.getLength(); i++)num[i] ^= $7be1938ba9eee7d1$var$QRMath.gexp($7be1938ba9eee7d1$var$QRMath.glog(e.get(i)) + ratio);
        return new $7be1938ba9eee7d1$var$QRPolynomial(num, 0).mod(e);
    }
};
function $7be1938ba9eee7d1$var$QRRSBlock(totalCount, dataCount) {
    this.totalCount = totalCount;
    this.dataCount = dataCount;
}
$7be1938ba9eee7d1$var$QRRSBlock.RS_BLOCK_TABLE = [
    [
        1,
        26,
        19
    ],
    [
        1,
        26,
        16
    ],
    [
        1,
        26,
        13
    ],
    [
        1,
        26,
        9
    ],
    [
        1,
        44,
        34
    ],
    [
        1,
        44,
        28
    ],
    [
        1,
        44,
        22
    ],
    [
        1,
        44,
        16
    ],
    [
        1,
        70,
        55
    ],
    [
        1,
        70,
        44
    ],
    [
        2,
        35,
        17
    ],
    [
        2,
        35,
        13
    ],
    [
        1,
        100,
        80
    ],
    [
        2,
        50,
        32
    ],
    [
        2,
        50,
        24
    ],
    [
        4,
        25,
        9
    ],
    [
        1,
        134,
        108
    ],
    [
        2,
        67,
        43
    ],
    [
        2,
        33,
        15,
        2,
        34,
        16
    ],
    [
        2,
        33,
        11,
        2,
        34,
        12
    ],
    [
        2,
        86,
        68
    ],
    [
        4,
        43,
        27
    ],
    [
        4,
        43,
        19
    ],
    [
        4,
        43,
        15
    ],
    [
        2,
        98,
        78
    ],
    [
        4,
        49,
        31
    ],
    [
        2,
        32,
        14,
        4,
        33,
        15
    ],
    [
        4,
        39,
        13,
        1,
        40,
        14
    ],
    [
        2,
        121,
        97
    ],
    [
        2,
        60,
        38,
        2,
        61,
        39
    ],
    [
        4,
        40,
        18,
        2,
        41,
        19
    ],
    [
        4,
        40,
        14,
        2,
        41,
        15
    ],
    [
        2,
        146,
        116
    ],
    [
        3,
        58,
        36,
        2,
        59,
        37
    ],
    [
        4,
        36,
        16,
        4,
        37,
        17
    ],
    [
        4,
        36,
        12,
        4,
        37,
        13
    ],
    [
        2,
        86,
        68,
        2,
        87,
        69
    ],
    [
        4,
        69,
        43,
        1,
        70,
        44
    ],
    [
        6,
        43,
        19,
        2,
        44,
        20
    ],
    [
        6,
        43,
        15,
        2,
        44,
        16
    ],
    [
        4,
        101,
        81
    ],
    [
        1,
        80,
        50,
        4,
        81,
        51
    ],
    [
        4,
        50,
        22,
        4,
        51,
        23
    ],
    [
        3,
        36,
        12,
        8,
        37,
        13
    ],
    [
        2,
        116,
        92,
        2,
        117,
        93
    ],
    [
        6,
        58,
        36,
        2,
        59,
        37
    ],
    [
        4,
        46,
        20,
        6,
        47,
        21
    ],
    [
        7,
        42,
        14,
        4,
        43,
        15
    ],
    [
        4,
        133,
        107
    ],
    [
        8,
        59,
        37,
        1,
        60,
        38
    ],
    [
        8,
        44,
        20,
        4,
        45,
        21
    ],
    [
        12,
        33,
        11,
        4,
        34,
        12
    ],
    [
        3,
        145,
        115,
        1,
        146,
        116
    ],
    [
        4,
        64,
        40,
        5,
        65,
        41
    ],
    [
        11,
        36,
        16,
        5,
        37,
        17
    ],
    [
        11,
        36,
        12,
        5,
        37,
        13
    ],
    [
        5,
        109,
        87,
        1,
        110,
        88
    ],
    [
        5,
        65,
        41,
        5,
        66,
        42
    ],
    [
        5,
        54,
        24,
        7,
        55,
        25
    ],
    [
        11,
        36,
        12
    ],
    [
        5,
        122,
        98,
        1,
        123,
        99
    ],
    [
        7,
        73,
        45,
        3,
        74,
        46
    ],
    [
        15,
        43,
        19,
        2,
        44,
        20
    ],
    [
        3,
        45,
        15,
        13,
        46,
        16
    ],
    [
        1,
        135,
        107,
        5,
        136,
        108
    ],
    [
        10,
        74,
        46,
        1,
        75,
        47
    ],
    [
        1,
        50,
        22,
        15,
        51,
        23
    ],
    [
        2,
        42,
        14,
        17,
        43,
        15
    ],
    [
        5,
        150,
        120,
        1,
        151,
        121
    ],
    [
        9,
        69,
        43,
        4,
        70,
        44
    ],
    [
        17,
        50,
        22,
        1,
        51,
        23
    ],
    [
        2,
        42,
        14,
        19,
        43,
        15
    ],
    [
        3,
        141,
        113,
        4,
        142,
        114
    ],
    [
        3,
        70,
        44,
        11,
        71,
        45
    ],
    [
        17,
        47,
        21,
        4,
        48,
        22
    ],
    [
        9,
        39,
        13,
        16,
        40,
        14
    ],
    [
        3,
        135,
        107,
        5,
        136,
        108
    ],
    [
        3,
        67,
        41,
        13,
        68,
        42
    ],
    [
        15,
        54,
        24,
        5,
        55,
        25
    ],
    [
        15,
        43,
        15,
        10,
        44,
        16
    ],
    [
        4,
        144,
        116,
        4,
        145,
        117
    ],
    [
        17,
        68,
        42
    ],
    [
        17,
        50,
        22,
        6,
        51,
        23
    ],
    [
        19,
        46,
        16,
        6,
        47,
        17
    ],
    [
        2,
        139,
        111,
        7,
        140,
        112
    ],
    [
        17,
        74,
        46
    ],
    [
        7,
        54,
        24,
        16,
        55,
        25
    ],
    [
        34,
        37,
        13
    ],
    [
        4,
        151,
        121,
        5,
        152,
        122
    ],
    [
        4,
        75,
        47,
        14,
        76,
        48
    ],
    [
        11,
        54,
        24,
        14,
        55,
        25
    ],
    [
        16,
        45,
        15,
        14,
        46,
        16
    ],
    [
        6,
        147,
        117,
        4,
        148,
        118
    ],
    [
        6,
        73,
        45,
        14,
        74,
        46
    ],
    [
        11,
        54,
        24,
        16,
        55,
        25
    ],
    [
        30,
        46,
        16,
        2,
        47,
        17
    ],
    [
        8,
        132,
        106,
        4,
        133,
        107
    ],
    [
        8,
        75,
        47,
        13,
        76,
        48
    ],
    [
        7,
        54,
        24,
        22,
        55,
        25
    ],
    [
        22,
        45,
        15,
        13,
        46,
        16
    ],
    [
        10,
        142,
        114,
        2,
        143,
        115
    ],
    [
        19,
        74,
        46,
        4,
        75,
        47
    ],
    [
        28,
        50,
        22,
        6,
        51,
        23
    ],
    [
        33,
        46,
        16,
        4,
        47,
        17
    ],
    [
        8,
        152,
        122,
        4,
        153,
        123
    ],
    [
        22,
        73,
        45,
        3,
        74,
        46
    ],
    [
        8,
        53,
        23,
        26,
        54,
        24
    ],
    [
        12,
        45,
        15,
        28,
        46,
        16
    ],
    [
        3,
        147,
        117,
        10,
        148,
        118
    ],
    [
        3,
        73,
        45,
        23,
        74,
        46
    ],
    [
        4,
        54,
        24,
        31,
        55,
        25
    ],
    [
        11,
        45,
        15,
        31,
        46,
        16
    ],
    [
        7,
        146,
        116,
        7,
        147,
        117
    ],
    [
        21,
        73,
        45,
        7,
        74,
        46
    ],
    [
        1,
        53,
        23,
        37,
        54,
        24
    ],
    [
        19,
        45,
        15,
        26,
        46,
        16
    ],
    [
        5,
        145,
        115,
        10,
        146,
        116
    ],
    [
        19,
        75,
        47,
        10,
        76,
        48
    ],
    [
        15,
        54,
        24,
        25,
        55,
        25
    ],
    [
        23,
        45,
        15,
        25,
        46,
        16
    ],
    [
        13,
        145,
        115,
        3,
        146,
        116
    ],
    [
        2,
        74,
        46,
        29,
        75,
        47
    ],
    [
        42,
        54,
        24,
        1,
        55,
        25
    ],
    [
        23,
        45,
        15,
        28,
        46,
        16
    ],
    [
        17,
        145,
        115
    ],
    [
        10,
        74,
        46,
        23,
        75,
        47
    ],
    [
        10,
        54,
        24,
        35,
        55,
        25
    ],
    [
        19,
        45,
        15,
        35,
        46,
        16
    ],
    [
        17,
        145,
        115,
        1,
        146,
        116
    ],
    [
        14,
        74,
        46,
        21,
        75,
        47
    ],
    [
        29,
        54,
        24,
        19,
        55,
        25
    ],
    [
        11,
        45,
        15,
        46,
        46,
        16
    ],
    [
        13,
        145,
        115,
        6,
        146,
        116
    ],
    [
        14,
        74,
        46,
        23,
        75,
        47
    ],
    [
        44,
        54,
        24,
        7,
        55,
        25
    ],
    [
        59,
        46,
        16,
        1,
        47,
        17
    ],
    [
        12,
        151,
        121,
        7,
        152,
        122
    ],
    [
        12,
        75,
        47,
        26,
        76,
        48
    ],
    [
        39,
        54,
        24,
        14,
        55,
        25
    ],
    [
        22,
        45,
        15,
        41,
        46,
        16
    ],
    [
        6,
        151,
        121,
        14,
        152,
        122
    ],
    [
        6,
        75,
        47,
        34,
        76,
        48
    ],
    [
        46,
        54,
        24,
        10,
        55,
        25
    ],
    [
        2,
        45,
        15,
        64,
        46,
        16
    ],
    [
        17,
        152,
        122,
        4,
        153,
        123
    ],
    [
        29,
        74,
        46,
        14,
        75,
        47
    ],
    [
        49,
        54,
        24,
        10,
        55,
        25
    ],
    [
        24,
        45,
        15,
        46,
        46,
        16
    ],
    [
        4,
        152,
        122,
        18,
        153,
        123
    ],
    [
        13,
        74,
        46,
        32,
        75,
        47
    ],
    [
        48,
        54,
        24,
        14,
        55,
        25
    ],
    [
        42,
        45,
        15,
        32,
        46,
        16
    ],
    [
        20,
        147,
        117,
        4,
        148,
        118
    ],
    [
        40,
        75,
        47,
        7,
        76,
        48
    ],
    [
        43,
        54,
        24,
        22,
        55,
        25
    ],
    [
        10,
        45,
        15,
        67,
        46,
        16
    ],
    [
        19,
        148,
        118,
        6,
        149,
        119
    ],
    [
        18,
        75,
        47,
        31,
        76,
        48
    ],
    [
        34,
        54,
        24,
        34,
        55,
        25
    ],
    [
        20,
        45,
        15,
        61,
        46,
        16
    ]
];
$7be1938ba9eee7d1$var$QRRSBlock.getRSBlocks = function(typeNumber, errorCorrectLevel) {
    var rsBlock = $7be1938ba9eee7d1$var$QRRSBlock.getRsBlockTable(typeNumber, errorCorrectLevel);
    if (rsBlock == undefined) throw new Error("bad rs block @ typeNumber:" + typeNumber + "/errorCorrectLevel:" + errorCorrectLevel);
    var length = rsBlock.length / 3;
    var list = [];
    for(var i = 0; i < length; i++){
        var count = rsBlock[i * 3 + 0];
        var totalCount = rsBlock[i * 3 + 1];
        var dataCount = rsBlock[i * 3 + 2];
        for(var j = 0; j < count; j++)list.push(new $7be1938ba9eee7d1$var$QRRSBlock(totalCount, dataCount));
    }
    return list;
};
$7be1938ba9eee7d1$var$QRRSBlock.getRsBlockTable = function(typeNumber, errorCorrectLevel) {
    switch(errorCorrectLevel){
        case $7be1938ba9eee7d1$var$QRErrorCorrectLevel.L:
            return $7be1938ba9eee7d1$var$QRRSBlock.RS_BLOCK_TABLE[(typeNumber - 1) * 4 + 0];
        case $7be1938ba9eee7d1$var$QRErrorCorrectLevel.M:
            return $7be1938ba9eee7d1$var$QRRSBlock.RS_BLOCK_TABLE[(typeNumber - 1) * 4 + 1];
        case $7be1938ba9eee7d1$var$QRErrorCorrectLevel.Q:
            return $7be1938ba9eee7d1$var$QRRSBlock.RS_BLOCK_TABLE[(typeNumber - 1) * 4 + 2];
        case $7be1938ba9eee7d1$var$QRErrorCorrectLevel.H:
            return $7be1938ba9eee7d1$var$QRRSBlock.RS_BLOCK_TABLE[(typeNumber - 1) * 4 + 3];
        default:
            return undefined;
    }
};
function $7be1938ba9eee7d1$var$QRBitBuffer() {
    this.buffer = [];
    this.length = 0;
}
$7be1938ba9eee7d1$var$QRBitBuffer.prototype = {
    get: function(index) {
        var bufIndex = Math.floor(index / 8);
        return (this.buffer[bufIndex] >>> 7 - index % 8 & 1) == 1;
    },
    put: function(num, length) {
        for(var i = 0; i < length; i++)this.putBit((num >>> length - i - 1 & 1) == 1);
    },
    getLengthInBits: function() {
        return this.length;
    },
    putBit: function(bit) {
        var bufIndex = Math.floor(this.length / 8);
        if (this.buffer.length <= bufIndex) this.buffer.push(0);
        if (bit) this.buffer[bufIndex] |= 0x80 >>> this.length % 8;
        this.length++;
    }
};
var $7be1938ba9eee7d1$var$QRCodeLimitLength = [
    [
        17,
        14,
        11,
        7
    ],
    [
        32,
        26,
        20,
        14
    ],
    [
        53,
        42,
        32,
        24
    ],
    [
        78,
        62,
        46,
        34
    ],
    [
        106,
        84,
        60,
        44
    ],
    [
        134,
        106,
        74,
        58
    ],
    [
        154,
        122,
        86,
        64
    ],
    [
        192,
        152,
        108,
        84
    ],
    [
        230,
        180,
        130,
        98
    ],
    [
        271,
        213,
        151,
        119
    ],
    [
        321,
        251,
        177,
        137
    ],
    [
        367,
        287,
        203,
        155
    ],
    [
        425,
        331,
        241,
        177
    ],
    [
        458,
        362,
        258,
        194
    ],
    [
        520,
        412,
        292,
        220
    ],
    [
        586,
        450,
        322,
        250
    ],
    [
        644,
        504,
        364,
        280
    ],
    [
        718,
        560,
        394,
        310
    ],
    [
        792,
        624,
        442,
        338
    ],
    [
        858,
        666,
        482,
        382
    ],
    [
        929,
        711,
        509,
        403
    ],
    [
        1003,
        779,
        565,
        439
    ],
    [
        1091,
        857,
        611,
        461
    ],
    [
        1171,
        911,
        661,
        511
    ],
    [
        1273,
        997,
        715,
        535
    ],
    [
        1367,
        1059,
        751,
        593
    ],
    [
        1465,
        1125,
        805,
        625
    ],
    [
        1528,
        1190,
        868,
        658
    ],
    [
        1628,
        1264,
        908,
        698
    ],
    [
        1732,
        1370,
        982,
        742
    ],
    [
        1840,
        1452,
        1030,
        790
    ],
    [
        1952,
        1538,
        1112,
        842
    ],
    [
        2068,
        1628,
        1168,
        898
    ],
    [
        2188,
        1722,
        1228,
        958
    ],
    [
        2303,
        1809,
        1283,
        983
    ],
    [
        2431,
        1911,
        1351,
        1051
    ],
    [
        2563,
        1989,
        1423,
        1093
    ],
    [
        2699,
        2099,
        1499,
        1139
    ],
    [
        2809,
        2213,
        1579,
        1219
    ],
    [
        2953,
        2331,
        1663,
        1273
    ]
];
/** Constructor */ function $7be1938ba9eee7d1$var$QRCode(options) {
    var instance = this;
    //Default options
    this.options = {
        padding: 4,
        width: 256,
        height: 256,
        typeNumber: 4,
        color: "#000000",
        background: "#ffffff",
        ecl: "M"
    };
    //In case the options is string
    if (typeof options === "string") options = {
        content: options
    };
    //Merge options
    if (options) for(var i in options)this.options[i] = options[i];
    if (typeof this.options.content !== "string") throw new Error("Expected 'content' as string!");
    if (this.options.content.length === 0 /* || this.options.content.length > 7089 */ ) throw new Error("Expected 'content' to be non-empty!");
    if (!(this.options.padding >= 0)) throw new Error("Expected 'padding' value to be non-negative!");
    if (!(this.options.width > 0) || !(this.options.height > 0)) throw new Error("Expected 'width' or 'height' value to be higher than zero!");
    //Gets the error correction level
    function _getErrorCorrectLevel(ecl) {
        switch(ecl){
            case "L":
                return $7be1938ba9eee7d1$var$QRErrorCorrectLevel.L;
            case "M":
                return $7be1938ba9eee7d1$var$QRErrorCorrectLevel.M;
            case "Q":
                return $7be1938ba9eee7d1$var$QRErrorCorrectLevel.Q;
            case "H":
                return $7be1938ba9eee7d1$var$QRErrorCorrectLevel.H;
            default:
                throw new Error("Unknwon error correction level: " + ecl);
        }
    }
    //Get type number
    function _getTypeNumber(content, ecl) {
        var length = _getUTF8Length(content);
        var type = 1;
        var limit = 0;
        for(var i = 0, len = $7be1938ba9eee7d1$var$QRCodeLimitLength.length; i <= len; i++){
            var table = $7be1938ba9eee7d1$var$QRCodeLimitLength[i];
            if (!table) throw new Error("Content too long: expected " + limit + " but got " + length);
            switch(ecl){
                case "L":
                    limit = table[0];
                    break;
                case "M":
                    limit = table[1];
                    break;
                case "Q":
                    limit = table[2];
                    break;
                case "H":
                    limit = table[3];
                    break;
                default:
                    throw new Error("Unknwon error correction level: " + ecl);
            }
            if (length <= limit) break;
            type++;
        }
        if (type > $7be1938ba9eee7d1$var$QRCodeLimitLength.length) throw new Error("Content too long");
        return type;
    }
    //Gets text length
    function _getUTF8Length(content) {
        var result = encodeURI(content).toString().replace(/\%[0-9a-fA-F]{2}/g, "a");
        return result.length + (result.length != content ? 3 : 0);
    }
    //Generate QR Code matrix
    var content = this.options.content;
    var type = _getTypeNumber(content, this.options.ecl);
    var ecl = _getErrorCorrectLevel(this.options.ecl);
    this.qrcode = new $7be1938ba9eee7d1$var$QRCodeModel(type, ecl);
    this.qrcode.addData(content);
    this.qrcode.make();
}
/** Generates QR Code as SVG image */ $7be1938ba9eee7d1$var$QRCode.prototype.svg = function(opt) {
    var options = this.options || {};
    var modules = this.qrcode.modules;
    if (typeof opt == "undefined") opt = {
        container: options.container || "svg"
    };
    //Apply new lines and indents in SVG?
    var pretty = typeof options.pretty != "undefined" ? !!options.pretty : true;
    var indent = pretty ? "  " : "";
    var EOL = pretty ? "\r\n" : "";
    var width = options.width;
    var height = options.height;
    var length = modules.length;
    var xsize = width / (length + 2 * options.padding);
    var ysize = height / (length + 2 * options.padding);
    //Join (union, merge) rectangles into one shape?
    var join = typeof options.join != "undefined" ? !!options.join : false;
    //Swap the X and Y modules, pull request #2
    var swap = typeof options.swap != "undefined" ? !!options.swap : false;
    //Apply <?xml...?> declaration in SVG?
    var xmlDeclaration = typeof options.xmlDeclaration != "undefined" ? !!options.xmlDeclaration : true;
    //Populate with predefined shape instead of "rect" elements, thanks to @kkocdko
    var predefined = typeof options.predefined != "undefined" ? !!options.predefined : false;
    var defs = predefined ? indent + '<defs><path id="qrmodule" d="M0 0 h' + ysize + " v" + xsize + ' H0 z" style="fill:' + options.color + ';shape-rendering:crispEdges;" /></defs>' + EOL : "";
    //Background rectangle
    var bgrect = indent + '<rect x="0" y="0" width="' + width + '" height="' + height + '" style="fill:' + options.background + ';shape-rendering:crispEdges;"/>' + EOL;
    //Rectangles representing modules
    var modrect = "";
    var pathdata = "";
    for(var y = 0; y < length; y++)for(var x = 0; x < length; x++){
        var module1 = modules[x][y];
        if (module1) {
            var px = x * xsize + options.padding * xsize;
            var py = y * ysize + options.padding * ysize;
            //Some users have had issues with the QR Code, thanks to @danioso for the solution
            if (swap) {
                var t = px;
                px = py;
                py = t;
            }
            if (join) {
                //Module as a part of svg path data, thanks to @danioso
                var w = xsize + px;
                var h = ysize + py;
                px = Number.isInteger(px) ? Number(px) : px.toFixed(2);
                py = Number.isInteger(py) ? Number(py) : py.toFixed(2);
                w = Number.isInteger(w) ? Number(w) : w.toFixed(2);
                h = Number.isInteger(h) ? Number(h) : h.toFixed(2);
                pathdata += "M" + px + "," + py + " V" + h + " H" + w + " V" + py + " H" + px + " Z ";
            } else if (predefined) //Module as a predefined shape, thanks to @kkocdko
            modrect += indent + '<use x="' + px.toString() + '" y="' + py.toString() + '" href="#qrmodule" />' + EOL;
            else //Module as rectangle element
            modrect += indent + '<rect x="' + px.toString() + '" y="' + py.toString() + '" width="' + xsize + '" height="' + ysize + '" style="fill:' + options.color + ';shape-rendering:crispEdges;"/>' + EOL;
        }
    }
    if (join) modrect = indent + '<path x="0" y="0" style="fill:' + options.color + ';shape-rendering:crispEdges;" d="' + pathdata + '" />';
    var svg = "";
    switch(opt.container){
        //Wrapped in SVG document
        case "svg":
            if (xmlDeclaration) svg += '<?xml version="1.0" standalone="yes"?>' + EOL;
            svg += '<svg xmlns="http://www.w3.org/2000/svg" version="1.1" width="' + width + '" height="' + height + '">' + EOL;
            svg += defs + bgrect + modrect;
            svg += "</svg>";
            break;
        //Viewbox for responsive use in a browser, thanks to @danioso
        case "svg-viewbox":
            if (xmlDeclaration) svg += '<?xml version="1.0" standalone="yes"?>' + EOL;
            svg += '<svg xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 ' + width + " " + height + '">' + EOL;
            svg += defs + bgrect + modrect;
            svg += "</svg>";
            break;
        //Wrapped in group element    
        case "g":
            svg += '<g width="' + width + '" height="' + height + '">' + EOL;
            svg += defs + bgrect + modrect;
            svg += "</g>";
            break;
        //Without a container
        default:
            svg += (defs + bgrect + modrect).replace(/^\s+/, ""); //Clear indents on each line
            break;
    }
    return svg;
};

/** Writes QR Code image to a file */ $7be1938ba9eee7d1$var$QRCode.prototype.save = function(file, callback) {
    var data = this.svg();
    if (typeof callback != "function") callback = function(error, result) {};
    try {
        //Package 'fs' is available in node.js but not in a web browser
        var fs = (parcelRequire("avKtN"));
        fs.writeFile(file, data, callback);
    } catch (e) {
        //Sorry, 'fs' is not available
        callback(e);
    }
};
$7be1938ba9eee7d1$exports = $7be1938ba9eee7d1$var$QRCode;



var $9oYre = parcelRequire("9oYre");

var $9oYre = parcelRequire("9oYre");
var $accdb25a2f5abdb6$exports = {};
$accdb25a2f5abdb6$exports = JSON.parse('{"names":[{"emoji":":smile:","description":"smiling face with open mouth and smiling eyes","unicode":"\uD83D\uDE04","tags":"happy:joy:pleased:smile"},{"emoji":":smiley:","description":"smiling face with open mouth","unicode":"\uD83D\uDE03","tags":"happy:joy:haha:smiley"},{"emoji":":grinning:","description":"grinning face","unicode":"\uD83D\uDE00","tags":"smile:happy:grinning"},{"emoji":":blush:","description":"smiling face with smiling eyes","unicode":"\uD83D\uDE0A","tags":"proud:blush"},{"emoji":":relaxed:","description":"white smiling face","unicode":"\u263A\uFE0F","tags":"blush:pleased:relaxed"},{"emoji":":wink:","description":"winking face","unicode":"\uD83D\uDE09","tags":"flirt:wink"},{"emoji":":heart_eyes:","description":"smiling face with heart-shaped eyes","unicode":"\uD83D\uDE0D","tags":"love:crush:heart_eyes"},{"emoji":":kissing_heart:","description":"face throwing a kiss","unicode":"\uD83D\uDE18","tags":"flirt:kissing_heart"},{"emoji":":kissing_closed_eyes:","description":"kissing face with closed eyes","unicode":"\uD83D\uDE1A","tags":"kissing_closed_eyes"},{"emoji":":kissing:","description":"kissing face","unicode":"\uD83D\uDE17","tags":"kissing"},{"emoji":":kissing_smiling_eyes:","description":"kissing face with smiling eyes","unicode":"\uD83D\uDE19","tags":"kissing_smiling_eyes"},{"emoji":":stuck_out_tongue_winking_eye:","description":"face with stuck-out tongue and winking eye","unicode":"\uD83D\uDE1C","tags":"prank:silly:stuck_out_tongue_winking_eye"},{"emoji":":stuck_out_tongue_closed_eyes:","description":"face with stuck-out tongue and tightly-closed eyes","unicode":"\uD83D\uDE1D","tags":"prank:stuck_out_tongue_closed_eyes"},{"emoji":":stuck_out_tongue:","description":"face with stuck-out tongue","unicode":"\uD83D\uDE1B","tags":"stuck_out_tongue"},{"emoji":":flushed:","description":"flushed face","unicode":"\uD83D\uDE33","tags":"flushed"},{"emoji":":grin:","description":"grinning face with smiling eyes","unicode":"\uD83D\uDE01","tags":"grin"},{"emoji":":pensive:","description":"pensive face","unicode":"\uD83D\uDE14","tags":"pensive"},{"emoji":":relieved:","description":"relieved face","unicode":"\uD83D\uDE0C","tags":"whew:relieved"},{"emoji":":unamused:","description":"unamused face","unicode":"\uD83D\uDE12","tags":"meh:unamused"},{"emoji":":disappointed:","description":"disappointed face","unicode":"\uD83D\uDE1E","tags":"sad:disappointed"},{"emoji":":persevere:","description":"persevering face","unicode":"\uD83D\uDE23","tags":"struggling:persevere"},{"emoji":":cry:","description":"crying face","unicode":"\uD83D\uDE22","tags":"sad:tear:cry"},{"emoji":":joy:","description":"face with tears of joy","unicode":"\uD83D\uDE02","tags":"tears:joy"},{"emoji":":sob:","description":"loudly crying face","unicode":"\uD83D\uDE2D","tags":"sad:cry:bawling:sob"},{"emoji":":sleepy:","description":"sleepy face","unicode":"\uD83D\uDE2A","tags":"tired:sleepy"},{"emoji":":disappointed_relieved:","description":"disappointed but relieved face","unicode":"\uD83D\uDE25","tags":"phew:sweat:nervous:disappointed_relieved"},{"emoji":":cold_sweat:","description":"face with open mouth and cold sweat","unicode":"\uD83D\uDE30","tags":"nervous:cold_sweat"},{"emoji":":sweat_smile:","description":"smiling face with open mouth and cold sweat","unicode":"\uD83D\uDE05","tags":"hot:sweat_smile"},{"emoji":":sweat:","description":"face with cold sweat","unicode":"\uD83D\uDE13","tags":"sweat"},{"emoji":":weary:","description":"weary face","unicode":"\uD83D\uDE29","tags":"tired:weary"},{"emoji":":tired_face:","description":"tired face","unicode":"\uD83D\uDE2B","tags":"upset:whine:tired_face"},{"emoji":":fearful:","description":"fearful face","unicode":"\uD83D\uDE28","tags":"scared:shocked:oops:fearful"},{"emoji":":scream:","description":"face screaming in fear","unicode":"\uD83D\uDE31","tags":"horror:shocked:scream"},{"emoji":":angry:","description":"angry face","unicode":"\uD83D\uDE20","tags":"mad:annoyed:angry"},{"emoji":":rage:","description":"pouting face","unicode":"\uD83D\uDE21","tags":"angry:rage"},{"emoji":":triumph:","description":"face with look of triumph","unicode":"\uD83D\uDE24","tags":"smug:triumph"},{"emoji":":confounded:","description":"confounded face","unicode":"\uD83D\uDE16","tags":"confounded"},{"emoji":":laughing:","description":"smiling face with open mouth and tightly-closed eyes","unicode":"\uD83D\uDE06","tags":"happy:haha:laughing:satisfied"},{"emoji":":yum:","description":"face savouring delicious food","unicode":"\uD83D\uDE0B","tags":"tongue:lick:yum"},{"emoji":":mask:","description":"face with medical mask","unicode":"\uD83D\uDE37","tags":"sick:ill:mask"},{"emoji":":sunglasses:","description":"smiling face with sunglasses","unicode":"\uD83D\uDE0E","tags":"cool:sunglasses"},{"emoji":":sleeping:","description":"sleeping face","unicode":"\uD83D\uDE34","tags":"zzz:sleeping"},{"emoji":":dizzy_face:","description":"dizzy face","unicode":"\uD83D\uDE35","tags":"dizzy_face"},{"emoji":":astonished:","description":"astonished face","unicode":"\uD83D\uDE32","tags":"amazed:gasp:astonished"},{"emoji":":worried:","description":"worried face","unicode":"\uD83D\uDE1F","tags":"nervous:worried"},{"emoji":":frowning:","description":"frowning face with open mouth","unicode":"\uD83D\uDE26","tags":"frowning"},{"emoji":":anguished:","description":"anguished face","unicode":"\uD83D\uDE27","tags":"stunned:anguished"},{"emoji":":smiling_imp:","description":"smiling face with horns","unicode":"\uD83D\uDE08","tags":"devil:evil:horns:smiling_imp"},{"emoji":":imp:","description":"imp","unicode":"\uD83D\uDC7F","tags":"angry:devil:evil:horns:imp"},{"emoji":":open_mouth:","description":"face with open mouth","unicode":"\uD83D\uDE2E","tags":"surprise:impressed:wow:open_mouth"},{"emoji":":grimacing:","description":"grimacing face","unicode":"\uD83D\uDE2C","tags":"grimacing"},{"emoji":":neutral_face:","description":"neutral face","unicode":"\uD83D\uDE10","tags":"meh:neutral_face"},{"emoji":":confused:","description":"confused face","unicode":"\uD83D\uDE15","tags":"confused"},{"emoji":":hushed:","description":"hushed face","unicode":"\uD83D\uDE2F","tags":"silence:speechless:hushed"},{"emoji":":no_mouth:","description":"face without mouth","unicode":"\uD83D\uDE36","tags":"mute:silence:no_mouth"},{"emoji":":innocent:","description":"smiling face with halo","unicode":"\uD83D\uDE07","tags":"angel:innocent"},{"emoji":":smirk:","description":"smirking face","unicode":"\uD83D\uDE0F","tags":"smug:smirk"},{"emoji":":expressionless:","description":"expressionless face","unicode":"\uD83D\uDE11","tags":"expressionless"},{"emoji":":man_with_gua_pi_mao:","description":"man with gua pi mao","unicode":"\uD83D\uDC72","tags":"man_with_gua_pi_mao"},{"emoji":":man_with_turban:","description":"man with turban","unicode":"\uD83D\uDC73","tags":"man_with_turban"},{"emoji":":cop:","description":"police officer","unicode":"\uD83D\uDC6E","tags":"police:law:cop"},{"emoji":":construction_worker:","description":"construction worker","unicode":"\uD83D\uDC77","tags":"helmet:construction_worker"},{"emoji":":guardsman:","description":"guardsman","unicode":"\uD83D\uDC82","tags":"guardsman"},{"emoji":":baby:","description":"baby","unicode":"\uD83D\uDC76","tags":"child:newborn:baby"},{"emoji":":boy:","description":"boy","unicode":"\uD83D\uDC66","tags":"child:boy"},{"emoji":":girl:","description":"girl","unicode":"\uD83D\uDC67","tags":"child:girl"},{"emoji":":man:","description":"man","unicode":"\uD83D\uDC68","tags":"mustache:father:dad:man"},{"emoji":":woman:","description":"woman","unicode":"\uD83D\uDC69","tags":"girls:woman"},{"emoji":":older_man:","description":"older man","unicode":"\uD83D\uDC74","tags":"older_man"},{"emoji":":older_woman:","description":"older woman","unicode":"\uD83D\uDC75","tags":"older_woman"},{"emoji":":person_with_blond_hair:","description":"person with blond hair","unicode":"\uD83D\uDC71","tags":"boy:person_with_blond_hair"},{"emoji":":angel:","description":"baby angel","unicode":"\uD83D\uDC7C","tags":"angel"},{"emoji":":princess:","description":"princess","unicode":"\uD83D\uDC78","tags":"blonde:crown:royal:princess"},{"emoji":":smiley_cat:","description":"smiling cat face with open mouth","unicode":"\uD83D\uDE3A","tags":"smiley_cat"},{"emoji":":smile_cat:","description":"grinning cat face with smiling eyes","unicode":"\uD83D\uDE38","tags":"smile_cat"},{"emoji":":heart_eyes_cat:","description":"smiling cat face with heart-shaped eyes","unicode":"\uD83D\uDE3B","tags":"heart_eyes_cat"},{"emoji":":kissing_cat:","description":"kissing cat face with closed eyes","unicode":"\uD83D\uDE3D","tags":"kissing_cat"},{"emoji":":smirk_cat:","description":"cat face with wry smile","unicode":"\uD83D\uDE3C","tags":"smirk_cat"},{"emoji":":scream_cat:","description":"weary cat face","unicode":"\uD83D\uDE40","tags":"horror:scream_cat"},{"emoji":":crying_cat_face:","description":"crying cat face","unicode":"\uD83D\uDE3F","tags":"sad:tear:crying_cat_face"},{"emoji":":joy_cat:","description":"cat face with tears of joy","unicode":"\uD83D\uDE39","tags":"joy_cat"},{"emoji":":pouting_cat:","description":"pouting cat face","unicode":"\uD83D\uDE3E","tags":"pouting_cat"},{"emoji":":japanese_ogre:","description":"japanese ogre","unicode":"\uD83D\uDC79","tags":"monster:japanese_ogre"},{"emoji":":japanese_goblin:","description":"japanese goblin","unicode":"\uD83D\uDC7A","tags":"japanese_goblin"},{"emoji":":see_no_evil:","description":"see-no-evil monkey","unicode":"\uD83D\uDE48","tags":"monkey:blind:ignore:see_no_evil"},{"emoji":":hear_no_evil:","description":"hear-no-evil monkey","unicode":"\uD83D\uDE49","tags":"monkey:deaf:hear_no_evil"},{"emoji":":speak_no_evil:","description":"speak-no-evil monkey","unicode":"\uD83D\uDE4A","tags":"monkey:mute:hush:speak_no_evil"},{"emoji":":skull:","description":"skull","unicode":"\uD83D\uDC80","tags":"dead:danger:poison:skull"},{"emoji":":alien:","description":"extraterrestrial alien","unicode":"\uD83D\uDC7D","tags":"ufo:alien"},{"emoji":":hankey:","description":"pile of poo","unicode":"\uD83D\uDCA9","tags":"crap:hankey:poop:shit"},{"emoji":":fire:","description":"fire","unicode":"\uD83D\uDD25","tags":"burn:fire"},{"emoji":":sparkles:","description":"sparkles","unicode":"\u2728","tags":"shiny:sparkles"},{"emoji":":star2:","description":"glowing star","unicode":"\uD83C\uDF1F","tags":"star2"},{"emoji":":dizzy:","description":"dizzy symbol","unicode":"\uD83D\uDCAB","tags":"star:dizzy"},{"emoji":":boom:","description":"collision symbol","unicode":"\uD83D\uDCA5","tags":"explode:boom:collision"},{"emoji":":anger:","description":"anger symbol","unicode":"\uD83D\uDCA2","tags":"angry:anger"},{"emoji":":sweat_drops:","description":"splashing sweat symbol","unicode":"\uD83D\uDCA6","tags":"water:workout:sweat_drops"},{"emoji":":droplet:","description":"droplet","unicode":"\uD83D\uDCA7","tags":"water:droplet"},{"emoji":":zzz:","description":"sleeping symbol","unicode":"\uD83D\uDCA4","tags":"sleeping:zzz"},{"emoji":":dash:","description":"dash symbol","unicode":"\uD83D\uDCA8","tags":"wind:blow:fast:dash"},{"emoji":":ear:","description":"ear","unicode":"\uD83D\uDC42","tags":"hear:sound:listen:ear"},{"emoji":":eyes:","description":"eyes","unicode":"\uD83D\uDC40","tags":"look:see:watch:eyes"},{"emoji":":nose:","description":"nose","unicode":"\uD83D\uDC43","tags":"smell:nose"},{"emoji":":tongue:","description":"tongue","unicode":"\uD83D\uDC45","tags":"taste:tongue"},{"emoji":":lips:","description":"mouth","unicode":"\uD83D\uDC44","tags":"kiss:lips"},{"emoji":":+1:","description":"thumbs up sign","unicode":"\uD83D\uDC4D","tags":"approve:ok:+1:thumbsup"},{"emoji":":-1:","description":"thumbs down sign","unicode":"\uD83D\uDC4E","tags":"disapprove:bury:-1:thumbsdown"},{"emoji":":ok_hand:","description":"ok hand sign","unicode":"\uD83D\uDC4C","tags":"ok_hand"},{"emoji":":facepunch:","description":"fisted hand sign","unicode":"\uD83D\uDC4A","tags":"attack:facepunch:punch"},{"emoji":":fist:","description":"raised fist","unicode":"\u270A","tags":"power:fist"},{"emoji":":v:","description":"victory hand","unicode":"\u270C\uFE0F","tags":"victory:peace:v"},{"emoji":":wave:","description":"waving hand sign","unicode":"\uD83D\uDC4B","tags":"goodbye:wave"},{"emoji":":hand:","description":"raised hand","unicode":"\u270B","tags":"highfive:stop:hand:raised_hand"},{"emoji":":open_hands:","description":"open hands sign","unicode":"\uD83D\uDC50","tags":"open_hands"},{"emoji":":point_up_2:","description":"white up pointing backhand index","unicode":"\uD83D\uDC46","tags":"point_up_2"},{"emoji":":point_down:","description":"white down pointing backhand index","unicode":"\uD83D\uDC47","tags":"point_down"},{"emoji":":point_right:","description":"white right pointing backhand index","unicode":"\uD83D\uDC49","tags":"point_right"},{"emoji":":point_left:","description":"white left pointing backhand index","unicode":"\uD83D\uDC48","tags":"point_left"},{"emoji":":raised_hands:","description":"person raising both hands in celebration","unicode":"\uD83D\uDE4C","tags":"hooray:raised_hands"},{"emoji":":pray:","description":"person with folded hands","unicode":"\uD83D\uDE4F","tags":"please:hope:wish:pray"},{"emoji":":point_up:","description":"white up pointing index","unicode":"\u261D\uFE0F","tags":"point_up"},{"emoji":":clap:","description":"clapping hands sign","unicode":"\uD83D\uDC4F","tags":"praise:applause:clap"},{"emoji":":muscle:","description":"flexed biceps","unicode":"\uD83D\uDCAA","tags":"flex:bicep:strong:workout:muscle"},{"emoji":":walking:","description":"pedestrian","unicode":"\uD83D\uDEB6","tags":"walking"},{"emoji":":runner:","description":"runner","unicode":"\uD83C\uDFC3","tags":"exercise:workout:marathon:runner:running"},{"emoji":":dancer:","description":"dancer","unicode":"\uD83D\uDC83","tags":"dress:dancer"},{"emoji":":couple:","description":"man and woman holding hands","unicode":"\uD83D\uDC6B","tags":"date:couple"},{"emoji":":family:","description":"family","unicode":"\uD83D\uDC6A","tags":"home:parents:child:family"},{"emoji":":two_men_holding_hands:","description":"two men holding hands","unicode":"\uD83D\uDC6C","tags":"couple:date:two_men_holding_hands"},{"emoji":":two_women_holding_hands:","description":"two women holding hands","unicode":"\uD83D\uDC6D","tags":"couple:date:two_women_holding_hands"},{"emoji":":couplekiss:","description":"kiss","unicode":"\uD83D\uDC8F","tags":"couplekiss"},{"emoji":":couple_with_heart:","description":"couple with heart","unicode":"\uD83D\uDC91","tags":"couple_with_heart"},{"emoji":":dancers:","description":"woman with bunny ears","unicode":"\uD83D\uDC6F","tags":"bunny:dancers"},{"emoji":":ok_woman:","description":"face with ok gesture","unicode":"\uD83D\uDE46","tags":"ok_woman"},{"emoji":":no_good:","description":"face with no good gesture","unicode":"\uD83D\uDE45","tags":"stop:halt:no_good"},{"emoji":":information_desk_person:","description":"information desk person","unicode":"\uD83D\uDC81","tags":"information_desk_person"},{"emoji":":raising_hand:","description":"happy person raising one hand","unicode":"\uD83D\uDE4B","tags":"raising_hand"},{"emoji":":massage:","description":"face massage","unicode":"\uD83D\uDC86","tags":"spa:massage"},{"emoji":":haircut:","description":"haircut","unicode":"\uD83D\uDC87","tags":"beauty:haircut"},{"emoji":":nail_care:","description":"nail polish","unicode":"\uD83D\uDC85","tags":"beauty:manicure:nail_care"},{"emoji":":bride_with_veil:","description":"bride with veil","unicode":"\uD83D\uDC70","tags":"marriage:wedding:bride_with_veil"},{"emoji":":person_with_pouting_face:","description":"person with pouting face","unicode":"\uD83D\uDE4E","tags":"person_with_pouting_face"},{"emoji":":person_frowning:","description":"person frowning","unicode":"\uD83D\uDE4D","tags":"sad:person_frowning"},{"emoji":":bow:","description":"person bowing deeply","unicode":"\uD83D\uDE47","tags":"respect:thanks:bow"},{"emoji":":tophat:","description":"top hat","unicode":"\uD83C\uDFA9","tags":"hat:classy:tophat"},{"emoji":":crown:","description":"crown","unicode":"\uD83D\uDC51","tags":"king:queen:royal:crown"},{"emoji":":womans_hat:","description":"womans hat","unicode":"\uD83D\uDC52","tags":"womans_hat"},{"emoji":":athletic_shoe:","description":"athletic shoe","unicode":"\uD83D\uDC5F","tags":"sneaker:sport:running:athletic_shoe"},{"emoji":":mans_shoe:","description":"mans shoe","unicode":"\uD83D\uDC5E","tags":"mans_shoe:shoe"},{"emoji":":sandal:","description":"womans sandal","unicode":"\uD83D\uDC61","tags":"shoe:sandal"},{"emoji":":high_heel:","description":"high-heeled shoe","unicode":"\uD83D\uDC60","tags":"shoe:high_heel"},{"emoji":":boot:","description":"womans boots","unicode":"\uD83D\uDC62","tags":"boot"},{"emoji":":shirt:","description":"t-shirt","unicode":"\uD83D\uDC55","tags":"shirt:tshirt"},{"emoji":":necktie:","description":"necktie","unicode":"\uD83D\uDC54","tags":"shirt:formal:necktie"},{"emoji":":womans_clothes:","description":"womans clothes","unicode":"\uD83D\uDC5A","tags":"womans_clothes"},{"emoji":":dress:","description":"dress","unicode":"\uD83D\uDC57","tags":"dress"},{"emoji":":running_shirt_with_sash:","description":"running shirt with sash","unicode":"\uD83C\uDFBD","tags":"marathon:running_shirt_with_sash"},{"emoji":":jeans:","description":"jeans","unicode":"\uD83D\uDC56","tags":"pants:jeans"},{"emoji":":kimono:","description":"kimono","unicode":"\uD83D\uDC58","tags":"kimono"},{"emoji":":bikini:","description":"bikini","unicode":"\uD83D\uDC59","tags":"beach:bikini"},{"emoji":":briefcase:","description":"briefcase","unicode":"\uD83D\uDCBC","tags":"business:briefcase"},{"emoji":":handbag:","description":"handbag","unicode":"\uD83D\uDC5C","tags":"bag:handbag"},{"emoji":":pouch:","description":"pouch","unicode":"\uD83D\uDC5D","tags":"bag:pouch"},{"emoji":":purse:","description":"purse","unicode":"\uD83D\uDC5B","tags":"purse"},{"emoji":":eyeglasses:","description":"eyeglasses","unicode":"\uD83D\uDC53","tags":"glasses:eyeglasses"},{"emoji":":ribbon:","description":"ribbon","unicode":"\uD83C\uDF80","tags":"ribbon"},{"emoji":":closed_umbrella:","description":"closed umbrella","unicode":"\uD83C\uDF02","tags":"weather:rain:closed_umbrella"},{"emoji":":lipstick:","description":"lipstick","unicode":"\uD83D\uDC84","tags":"makeup:lipstick"},{"emoji":":yellow_heart:","description":"yellow heart","unicode":"\uD83D\uDC9B","tags":"yellow_heart"},{"emoji":":blue_heart:","description":"blue heart","unicode":"\uD83D\uDC99","tags":"blue_heart"},{"emoji":":purple_heart:","description":"purple heart","unicode":"\uD83D\uDC9C","tags":"purple_heart"},{"emoji":":green_heart:","description":"green heart","unicode":"\uD83D\uDC9A","tags":"green_heart"},{"emoji":":heart:","description":"heavy black heart","unicode":"\u2764\uFE0F","tags":"love:heart"},{"emoji":":broken_heart:","description":"broken heart","unicode":"\uD83D\uDC94","tags":"broken_heart"},{"emoji":":heartpulse:","description":"growing heart","unicode":"\uD83D\uDC97","tags":"heartpulse"},{"emoji":":heartbeat:","description":"beating heart","unicode":"\uD83D\uDC93","tags":"heartbeat"},{"emoji":":two_hearts:","description":"two hearts","unicode":"\uD83D\uDC95","tags":"two_hearts"},{"emoji":":sparkling_heart:","description":"sparkling heart","unicode":"\uD83D\uDC96","tags":"sparkling_heart"},{"emoji":":revolving_hearts:","description":"revolving hearts","unicode":"\uD83D\uDC9E","tags":"revolving_hearts"},{"emoji":":cupid:","description":"heart with arrow","unicode":"\uD83D\uDC98","tags":"love:heart:cupid"},{"emoji":":love_letter:","description":"love letter","unicode":"\uD83D\uDC8C","tags":"email:envelope:love_letter"},{"emoji":":kiss:","description":"kiss mark","unicode":"\uD83D\uDC8B","tags":"lipstick:kiss"},{"emoji":":ring:","description":"ring","unicode":"\uD83D\uDC8D","tags":"wedding:marriage:engaged:ring"},{"emoji":":gem:","description":"gem stone","unicode":"\uD83D\uDC8E","tags":"diamond:gem"},{"emoji":":bust_in_silhouette:","description":"bust in silhouette","unicode":"\uD83D\uDC64","tags":"user:bust_in_silhouette"},{"emoji":":busts_in_silhouette:","description":"busts in silhouette","unicode":"\uD83D\uDC65","tags":"users:group:team:busts_in_silhouette"},{"emoji":":speech_balloon:","description":"speech balloon","unicode":"\uD83D\uDCAC","tags":"comment:speech_balloon"},{"emoji":":footprints:","description":"footprints","unicode":"\uD83D\uDC63","tags":"feet:tracks:footprints"},{"emoji":":thought_balloon:","description":"thought balloon","unicode":"\uD83D\uDCAD","tags":"thinking:thought_balloon"},{"emoji":":dog:","description":"dog face","unicode":"\uD83D\uDC36","tags":"pet:dog"},{"emoji":":wolf:","description":"wolf face","unicode":"\uD83D\uDC3A","tags":"wolf"},{"emoji":":cat:","description":"cat face","unicode":"\uD83D\uDC31","tags":"pet:cat"},{"emoji":":mouse:","description":"mouse face","unicode":"\uD83D\uDC2D","tags":"mouse"},{"emoji":":hamster:","description":"hamster face","unicode":"\uD83D\uDC39","tags":"pet:hamster"},{"emoji":":rabbit:","description":"rabbit face","unicode":"\uD83D\uDC30","tags":"bunny:rabbit"},{"emoji":":frog:","description":"frog face","unicode":"\uD83D\uDC38","tags":"frog"},{"emoji":":tiger:","description":"tiger face","unicode":"\uD83D\uDC2F","tags":"tiger"},{"emoji":":koala:","description":"koala","unicode":"\uD83D\uDC28","tags":"koala"},{"emoji":":bear:","description":"bear face","unicode":"\uD83D\uDC3B","tags":"bear"},{"emoji":":pig:","description":"pig face","unicode":"\uD83D\uDC37","tags":"pig"},{"emoji":":pig_nose:","description":"pig nose","unicode":"\uD83D\uDC3D","tags":"pig_nose"},{"emoji":":cow:","description":"cow face","unicode":"\uD83D\uDC2E","tags":"cow"},{"emoji":":boar:","description":"boar","unicode":"\uD83D\uDC17","tags":"boar"},{"emoji":":monkey_face:","description":"monkey face","unicode":"\uD83D\uDC35","tags":"monkey_face"},{"emoji":":monkey:","description":"monkey","unicode":"\uD83D\uDC12","tags":"monkey"},{"emoji":":horse:","description":"horse face","unicode":"\uD83D\uDC34","tags":"horse"},{"emoji":":sheep:","description":"sheep","unicode":"\uD83D\uDC11","tags":"sheep"},{"emoji":":elephant:","description":"elephant","unicode":"\uD83D\uDC18","tags":"elephant"},{"emoji":":panda_face:","description":"panda face","unicode":"\uD83D\uDC3C","tags":"panda_face"},{"emoji":":penguin:","description":"penguin","unicode":"\uD83D\uDC27","tags":"penguin"},{"emoji":":bird:","description":"bird","unicode":"\uD83D\uDC26","tags":"bird"},{"emoji":":baby_chick:","description":"baby chick","unicode":"\uD83D\uDC24","tags":"baby_chick"},{"emoji":":hatched_chick:","description":"front-facing baby chick","unicode":"\uD83D\uDC25","tags":"hatched_chick"},{"emoji":":hatching_chick:","description":"hatching chick","unicode":"\uD83D\uDC23","tags":"hatching_chick"},{"emoji":":chicken:","description":"chicken","unicode":"\uD83D\uDC14","tags":"chicken"},{"emoji":":snake:","description":"snake","unicode":"\uD83D\uDC0D","tags":"snake"},{"emoji":":turtle:","description":"turtle","unicode":"\uD83D\uDC22","tags":"slow:turtle"},{"emoji":":bug:","description":"bug","unicode":"\uD83D\uDC1B","tags":"bug"},{"emoji":":bee:","description":"honeybee","unicode":"\uD83D\uDC1D","tags":"bee:honeybee"},{"emoji":":ant:","description":"ant","unicode":"\uD83D\uDC1C","tags":"ant"},{"emoji":":beetle:","description":"lady beetle","unicode":"\uD83D\uDC1E","tags":"bug:beetle"},{"emoji":":snail:","description":"snail","unicode":"\uD83D\uDC0C","tags":"slow:snail"},{"emoji":":octopus:","description":"octopus","unicode":"\uD83D\uDC19","tags":"octopus"},{"emoji":":shell:","description":"spiral shell","unicode":"\uD83D\uDC1A","tags":"sea:beach:shell"},{"emoji":":tropical_fish:","description":"tropical fish","unicode":"\uD83D\uDC20","tags":"tropical_fish"},{"emoji":":fish:","description":"fish","unicode":"\uD83D\uDC1F","tags":"fish"},{"emoji":":dolphin:","description":"dolphin","unicode":"\uD83D\uDC2C","tags":"dolphin:flipper"},{"emoji":":whale:","description":"spouting whale","unicode":"\uD83D\uDC33","tags":"sea:whale"},{"emoji":":whale2:","description":"whale","unicode":"\uD83D\uDC0B","tags":"whale2"},{"emoji":":cow2:","description":"cow","unicode":"\uD83D\uDC04","tags":"cow2"},{"emoji":":ram:","description":"ram","unicode":"\uD83D\uDC0F","tags":"ram"},{"emoji":":rat:","description":"rat","unicode":"\uD83D\uDC00","tags":"rat"},{"emoji":":water_buffalo:","description":"water buffalo","unicode":"\uD83D\uDC03","tags":"water_buffalo"},{"emoji":":tiger2:","description":"tiger","unicode":"\uD83D\uDC05","tags":"tiger2"},{"emoji":":rabbit2:","description":"rabbit","unicode":"\uD83D\uDC07","tags":"rabbit2"},{"emoji":":dragon:","description":"dragon","unicode":"\uD83D\uDC09","tags":"dragon"},{"emoji":":racehorse:","description":"horse","unicode":"\uD83D\uDC0E","tags":"speed:racehorse"},{"emoji":":goat:","description":"goat","unicode":"\uD83D\uDC10","tags":"goat"},{"emoji":":rooster:","description":"rooster","unicode":"\uD83D\uDC13","tags":"rooster"},{"emoji":":dog2:","description":"dog","unicode":"\uD83D\uDC15","tags":"dog2"},{"emoji":":pig2:","description":"pig","unicode":"\uD83D\uDC16","tags":"pig2"},{"emoji":":mouse2:","description":"mouse","unicode":"\uD83D\uDC01","tags":"mouse2"},{"emoji":":ox:","description":"ox","unicode":"\uD83D\uDC02","tags":"ox"},{"emoji":":dragon_face:","description":"dragon face","unicode":"\uD83D\uDC32","tags":"dragon_face"},{"emoji":":blowfish:","description":"blowfish","unicode":"\uD83D\uDC21","tags":"blowfish"},{"emoji":":crocodile:","description":"crocodile","unicode":"\uD83D\uDC0A","tags":"crocodile"},{"emoji":":camel:","description":"bactrian camel","unicode":"\uD83D\uDC2B","tags":"camel"},{"emoji":":dromedary_camel:","description":"dromedary camel","unicode":"\uD83D\uDC2A","tags":"desert:dromedary_camel"},{"emoji":":leopard:","description":"leopard","unicode":"\uD83D\uDC06","tags":"leopard"},{"emoji":":cat2:","description":"cat","unicode":"\uD83D\uDC08","tags":"cat2"},{"emoji":":poodle:","description":"poodle","unicode":"\uD83D\uDC29","tags":"dog:poodle"},{"emoji":":feet:","description":"paw prints","unicode":"\uD83D\uDC3E","tags":"feet:paw_prints"},{"emoji":":bouquet:","description":"bouquet","unicode":"\uD83D\uDC90","tags":"flowers:bouquet"},{"emoji":":cherry_blossom:","description":"cherry blossom","unicode":"\uD83C\uDF38","tags":"flower:spring:cherry_blossom"},{"emoji":":tulip:","description":"tulip","unicode":"\uD83C\uDF37","tags":"flower:tulip"},{"emoji":":four_leaf_clover:","description":"four leaf clover","unicode":"\uD83C\uDF40","tags":"luck:four_leaf_clover"},{"emoji":":rose:","description":"rose","unicode":"\uD83C\uDF39","tags":"flower:rose"},{"emoji":":sunflower:","description":"sunflower","unicode":"\uD83C\uDF3B","tags":"sunflower"},{"emoji":":hibiscus:","description":"hibiscus","unicode":"\uD83C\uDF3A","tags":"hibiscus"},{"emoji":":maple_leaf:","description":"maple leaf","unicode":"\uD83C\uDF41","tags":"canada:maple_leaf"},{"emoji":":leaves:","description":"leaf fluttering in wind","unicode":"\uD83C\uDF43","tags":"leaf:leaves"},{"emoji":":fallen_leaf:","description":"fallen leaf","unicode":"\uD83C\uDF42","tags":"autumn:fallen_leaf"},{"emoji":":herb:","description":"herb","unicode":"\uD83C\uDF3F","tags":"herb"},{"emoji":":ear_of_rice:","description":"ear of rice","unicode":"\uD83C\uDF3E","tags":"ear_of_rice"},{"emoji":":mushroom:","description":"mushroom","unicode":"\uD83C\uDF44","tags":"mushroom"},{"emoji":":cactus:","description":"cactus","unicode":"\uD83C\uDF35","tags":"cactus"},{"emoji":":palm_tree:","description":"palm tree","unicode":"\uD83C\uDF34","tags":"palm_tree"},{"emoji":":evergreen_tree:","description":"evergreen tree","unicode":"\uD83C\uDF32","tags":"wood:evergreen_tree"},{"emoji":":deciduous_tree:","description":"deciduous tree","unicode":"\uD83C\uDF33","tags":"wood:deciduous_tree"},{"emoji":":chestnut:","description":"chestnut","unicode":"\uD83C\uDF30","tags":"chestnut"},{"emoji":":seedling:","description":"seedling","unicode":"\uD83C\uDF31","tags":"plant:seedling"},{"emoji":":blossom:","description":"blossom","unicode":"\uD83C\uDF3C","tags":"blossom"},{"emoji":":globe_with_meridians:","description":"globe with meridians","unicode":"\uD83C\uDF10","tags":"world:global:international:globe_with_meridians"},{"emoji":":sun_with_face:","description":"sun with face","unicode":"\uD83C\uDF1E","tags":"summer:sun_with_face"},{"emoji":":full_moon_with_face:","description":"full moon with face","unicode":"\uD83C\uDF1D","tags":"full_moon_with_face"},{"emoji":":new_moon_with_face:","description":"new moon with face","unicode":"\uD83C\uDF1A","tags":"new_moon_with_face"},{"emoji":":new_moon:","description":"new moon symbol","unicode":"\uD83C\uDF11","tags":"new_moon"},{"emoji":":waxing_crescent_moon:","description":"waxing crescent moon symbol","unicode":"\uD83C\uDF12","tags":"waxing_crescent_moon"},{"emoji":":first_quarter_moon:","description":"first quarter moon symbol","unicode":"\uD83C\uDF13","tags":"first_quarter_moon"},{"emoji":":moon:","description":"waxing gibbous moon symbol","unicode":"\uD83C\uDF14","tags":"moon:waxing_gibbous_moon"},{"emoji":":full_moon:","description":"full moon symbol","unicode":"\uD83C\uDF15","tags":"full_moon"},{"emoji":":waning_gibbous_moon:","description":"waning gibbous moon symbol","unicode":"\uD83C\uDF16","tags":"waning_gibbous_moon"},{"emoji":":last_quarter_moon:","description":"last quarter moon symbol","unicode":"\uD83C\uDF17","tags":"last_quarter_moon"},{"emoji":":waning_crescent_moon:","description":"waning crescent moon symbol","unicode":"\uD83C\uDF18","tags":"waning_crescent_moon"},{"emoji":":last_quarter_moon_with_face:","description":"last quarter moon with face","unicode":"\uD83C\uDF1C","tags":"last_quarter_moon_with_face"},{"emoji":":first_quarter_moon_with_face:","description":"first quarter moon with face","unicode":"\uD83C\uDF1B","tags":"first_quarter_moon_with_face"},{"emoji":":crescent_moon:","description":"crescent moon","unicode":"\uD83C\uDF19","tags":"night:crescent_moon"},{"emoji":":earth_africa:","description":"earth globe europe-africa","unicode":"\uD83C\uDF0D","tags":"globe:world:international:earth_africa"},{"emoji":":earth_americas:","description":"earth globe americas","unicode":"\uD83C\uDF0E","tags":"globe:world:international:earth_americas"},{"emoji":":earth_asia:","description":"earth globe asia-australia","unicode":"\uD83C\uDF0F","tags":"globe:world:international:earth_asia"},{"emoji":":volcano:","description":"volcano","unicode":"\uD83C\uDF0B","tags":"volcano"},{"emoji":":milky_way:","description":"milky way","unicode":"\uD83C\uDF0C","tags":"milky_way"},{"emoji":":stars:","description":"shooting star","unicode":"\uD83C\uDF20","tags":"stars"},{"emoji":":star:","description":"white medium star","unicode":"\u2B50","tags":"star"},{"emoji":":sunny:","description":"black sun with rays","unicode":"\u2600\uFE0F","tags":"weather:sunny"},{"emoji":":partly_sunny:","description":"sun behind cloud","unicode":"\u26C5","tags":"weather:cloud:partly_sunny"},{"emoji":":cloud:","description":"cloud","unicode":"\u2601\uFE0F","tags":"cloud"},{"emoji":":zap:","description":"high voltage sign","unicode":"\u26A1","tags":"lightning:thunder:zap"},{"emoji":":umbrella:","description":"umbrella with rain drops","unicode":"\u2614","tags":"rain:weather:umbrella"},{"emoji":":snowflake:","description":"snowflake","unicode":"\u2744\uFE0F","tags":"winter:cold:weather:snowflake"},{"emoji":":snowman:","description":"snowman without snow","unicode":"\u26C4","tags":"winter:christmas:snowman"},{"emoji":":cyclone:","description":"cyclone","unicode":"\uD83C\uDF00","tags":"swirl:cyclone"},{"emoji":":foggy:","description":"foggy","unicode":"\uD83C\uDF01","tags":"karl:foggy"},{"emoji":":rainbow:","description":"rainbow","unicode":"\uD83C\uDF08","tags":"pride:rainbow"},{"emoji":":ocean:","description":"water wave","unicode":"\uD83C\uDF0A","tags":"sea:ocean"},{"emoji":":bamboo:","description":"pine decoration","unicode":"\uD83C\uDF8D","tags":"bamboo"},{"emoji":":gift_heart:","description":"heart with ribbon","unicode":"\uD83D\uDC9D","tags":"chocolates:gift_heart"},{"emoji":":dolls:","description":"japanese dolls","unicode":"\uD83C\uDF8E","tags":"dolls"},{"emoji":":school_satchel:","description":"school satchel","unicode":"\uD83C\uDF92","tags":"school_satchel"},{"emoji":":mortar_board:","description":"graduation cap","unicode":"\uD83C\uDF93","tags":"education:college:university:graduation:mortar_board"},{"emoji":":flags:","description":"carp streamer","unicode":"\uD83C\uDF8F","tags":"flags"},{"emoji":":fireworks:","description":"fireworks","unicode":"\uD83C\uDF86","tags":"festival:celebration:fireworks"},{"emoji":":sparkler:","description":"firework sparkler","unicode":"\uD83C\uDF87","tags":"sparkler"},{"emoji":":wind_chime:","description":"wind chime","unicode":"\uD83C\uDF90","tags":"wind_chime"},{"emoji":":rice_scene:","description":"moon viewing ceremony","unicode":"\uD83C\uDF91","tags":"rice_scene"},{"emoji":":jack_o_lantern:","description":"jack-o-lantern","unicode":"\uD83C\uDF83","tags":"halloween:jack_o_lantern"},{"emoji":":ghost:","description":"ghost","unicode":"\uD83D\uDC7B","tags":"halloween:ghost"},{"emoji":":santa:","description":"father christmas","unicode":"\uD83C\uDF85","tags":"christmas:santa"},{"emoji":":christmas_tree:","description":"christmas tree","unicode":"\uD83C\uDF84","tags":"christmas_tree"},{"emoji":":gift:","description":"wrapped present","unicode":"\uD83C\uDF81","tags":"present:birthday:christmas:gift"},{"emoji":":tanabata_tree:","description":"tanabata tree","unicode":"\uD83C\uDF8B","tags":"tanabata_tree"},{"emoji":":tada:","description":"party popper","unicode":"\uD83C\uDF89","tags":"party:tada"},{"emoji":":confetti_ball:","description":"confetti ball","unicode":"\uD83C\uDF8A","tags":"confetti_ball"},{"emoji":":balloon:","description":"balloon","unicode":"\uD83C\uDF88","tags":"party:birthday:balloon"},{"emoji":":crossed_flags:","description":"crossed flags","unicode":"\uD83C\uDF8C","tags":"crossed_flags"},{"emoji":":crystal_ball:","description":"crystal ball","unicode":"\uD83D\uDD2E","tags":"fortune:crystal_ball"},{"emoji":":movie_camera:","description":"movie camera","unicode":"\uD83C\uDFA5","tags":"film:video:movie_camera"},{"emoji":":camera:","description":"camera","unicode":"\uD83D\uDCF7","tags":"photo:camera"},{"emoji":":video_camera:","description":"video camera","unicode":"\uD83D\uDCF9","tags":"video_camera"},{"emoji":":vhs:","description":"videocassette","unicode":"\uD83D\uDCFC","tags":"vhs"},{"emoji":":cd:","description":"optical disc","unicode":"\uD83D\uDCBF","tags":"cd"},{"emoji":":dvd:","description":"dvd","unicode":"\uD83D\uDCC0","tags":"dvd"},{"emoji":":minidisc:","description":"minidisc","unicode":"\uD83D\uDCBD","tags":"minidisc"},{"emoji":":floppy_disk:","description":"floppy disk","unicode":"\uD83D\uDCBE","tags":"save:floppy_disk"},{"emoji":":computer:","description":"personal computer","unicode":"\uD83D\uDCBB","tags":"desktop:screen:computer"},{"emoji":":iphone:","description":"mobile phone","unicode":"\uD83D\uDCF1","tags":"smartphone:mobile:iphone"},{"emoji":":phone:","description":"black telephone","unicode":"\u260E\uFE0F","tags":"phone:telephone"},{"emoji":":telephone_receiver:","description":"telephone receiver","unicode":"\uD83D\uDCDE","tags":"phone:call:telephone_receiver"},{"emoji":":pager:","description":"pager","unicode":"\uD83D\uDCDF","tags":"pager"},{"emoji":":fax:","description":"fax machine","unicode":"\uD83D\uDCE0","tags":"fax"},{"emoji":":satellite:","description":"satellite antenna","unicode":"\uD83D\uDCE1","tags":"signal:satellite"},{"emoji":":tv:","description":"television","unicode":"\uD83D\uDCFA","tags":"tv"},{"emoji":":radio:","description":"radio","unicode":"\uD83D\uDCFB","tags":"podcast:radio"},{"emoji":":loud_sound:","description":"speaker with three sound waves","unicode":"\uD83D\uDD0A","tags":"volume:loud_sound"},{"emoji":":sound:","description":"speaker with one sound wave","unicode":"\uD83D\uDD09","tags":"volume:sound"},{"emoji":":speaker:","description":"speaker","unicode":"\uD83D\uDD08","tags":"speaker"},{"emoji":":mute:","description":"speaker with cancellation stroke","unicode":"\uD83D\uDD07","tags":"sound:volume:mute"},{"emoji":":bell:","description":"bell","unicode":"\uD83D\uDD14","tags":"sound:notification:bell"},{"emoji":":no_bell:","description":"bell with cancellation stroke","unicode":"\uD83D\uDD15","tags":"volume:off:no_bell"},{"emoji":":loudspeaker:","description":"public address loudspeaker","unicode":"\uD83D\uDCE2","tags":"announcement:loudspeaker"},{"emoji":":mega:","description":"cheering megaphone","unicode":"\uD83D\uDCE3","tags":"mega"},{"emoji":":hourglass_flowing_sand:","description":"hourglass with flowing sand","unicode":"\u23F3","tags":"time:hourglass_flowing_sand"},{"emoji":":hourglass:","description":"hourglass","unicode":"\u231B","tags":"time:hourglass"},{"emoji":":alarm_clock:","description":"alarm clock","unicode":"\u23F0","tags":"morning:alarm_clock"},{"emoji":":watch:","description":"watch","unicode":"\u231A","tags":"time:watch"},{"emoji":":unlock:","description":"open lock","unicode":"\uD83D\uDD13","tags":"security:unlock"},{"emoji":":lock:","description":"lock","unicode":"\uD83D\uDD12","tags":"security:private:lock"},{"emoji":":lock_with_ink_pen:","description":"lock with ink pen","unicode":"\uD83D\uDD0F","tags":"lock_with_ink_pen"},{"emoji":":closed_lock_with_key:","description":"closed lock with key","unicode":"\uD83D\uDD10","tags":"security:closed_lock_with_key"},{"emoji":":key:","description":"key","unicode":"\uD83D\uDD11","tags":"lock:password:key"},{"emoji":":mag_right:","description":"right-pointing magnifying glass","unicode":"\uD83D\uDD0E","tags":"mag_right"},{"emoji":":bulb:","description":"electric light bulb","unicode":"\uD83D\uDCA1","tags":"idea:light:bulb"},{"emoji":":flashlight:","description":"electric torch","unicode":"\uD83D\uDD26","tags":"flashlight"},{"emoji":":high_brightness:","description":"high brightness symbol","unicode":"\uD83D\uDD06","tags":"high_brightness"},{"emoji":":low_brightness:","description":"low brightness symbol","unicode":"\uD83D\uDD05","tags":"low_brightness"},{"emoji":":electric_plug:","description":"electric plug","unicode":"\uD83D\uDD0C","tags":"electric_plug"},{"emoji":":battery:","description":"battery","unicode":"\uD83D\uDD0B","tags":"power:battery"},{"emoji":":mag:","description":"left-pointing magnifying glass","unicode":"\uD83D\uDD0D","tags":"search:zoom:mag"},{"emoji":":bathtub:","description":"bathtub","unicode":"\uD83D\uDEC1","tags":"bathtub"},{"emoji":":bath:","description":"bath","unicode":"\uD83D\uDEC0","tags":"shower:bath"},{"emoji":":shower:","description":"shower","unicode":"\uD83D\uDEBF","tags":"bath:shower"},{"emoji":":toilet:","description":"toilet","unicode":"\uD83D\uDEBD","tags":"wc:toilet"},{"emoji":":wrench:","description":"wrench","unicode":"\uD83D\uDD27","tags":"tool:wrench"},{"emoji":":nut_and_bolt:","description":"nut and bolt","unicode":"\uD83D\uDD29","tags":"nut_and_bolt"},{"emoji":":hammer:","description":"hammer","unicode":"\uD83D\uDD28","tags":"tool:hammer"},{"emoji":":door:","description":"door","unicode":"\uD83D\uDEAA","tags":"door"},{"emoji":":smoking:","description":"smoking symbol","unicode":"\uD83D\uDEAC","tags":"cigarette:smoking"},{"emoji":":bomb:","description":"bomb","unicode":"\uD83D\uDCA3","tags":"boom:bomb"},{"emoji":":gun:","description":"pistol","unicode":"\uD83D\uDD2B","tags":"shoot:weapon:gun"},{"emoji":":hocho:","description":"hocho","unicode":"\uD83D\uDD2A","tags":"cut:chop:hocho:knife"},{"emoji":":pill:","description":"pill","unicode":"\uD83D\uDC8A","tags":"health:medicine:pill"},{"emoji":":syringe:","description":"syringe","unicode":"\uD83D\uDC89","tags":"health:hospital:needle:syringe"},{"emoji":":moneybag:","description":"money bag","unicode":"\uD83D\uDCB0","tags":"dollar:cream:moneybag"},{"emoji":":yen:","description":"banknote with yen sign","unicode":"\uD83D\uDCB4","tags":"yen"},{"emoji":":dollar:","description":"banknote with dollar sign","unicode":"\uD83D\uDCB5","tags":"money:dollar"},{"emoji":":pound:","description":"banknote with pound sign","unicode":"\uD83D\uDCB7","tags":"pound"},{"emoji":":euro:","description":"banknote with euro sign","unicode":"\uD83D\uDCB6","tags":"euro"},{"emoji":":credit_card:","description":"credit card","unicode":"\uD83D\uDCB3","tags":"subscription:credit_card"},{"emoji":":money_with_wings:","description":"money with wings","unicode":"\uD83D\uDCB8","tags":"dollar:money_with_wings"},{"emoji":":calling:","description":"mobile phone with rightwards arrow at left","unicode":"\uD83D\uDCF2","tags":"call:incoming:calling"},{"emoji":":e-mail:","description":"e-mail symbol","unicode":"\uD83D\uDCE7","tags":"e-mail"},{"emoji":":inbox_tray:","description":"inbox tray","unicode":"\uD83D\uDCE5","tags":"inbox_tray"},{"emoji":":outbox_tray:","description":"outbox tray","unicode":"\uD83D\uDCE4","tags":"outbox_tray"},{"emoji":":email:","description":"envelope","unicode":"\u2709\uFE0F","tags":"letter:email:envelope"},{"emoji":":envelope_with_arrow:","description":"envelope with downwards arrow above","unicode":"\uD83D\uDCE9","tags":"envelope_with_arrow"},{"emoji":":incoming_envelope:","description":"incoming envelope","unicode":"\uD83D\uDCE8","tags":"incoming_envelope"},{"emoji":":postal_horn:","description":"postal horn","unicode":"\uD83D\uDCEF","tags":"postal_horn"},{"emoji":":mailbox:","description":"closed mailbox with raised flag","unicode":"\uD83D\uDCEB","tags":"mailbox"},{"emoji":":mailbox_closed:","description":"closed mailbox with lowered flag","unicode":"\uD83D\uDCEA","tags":"mailbox_closed"},{"emoji":":mailbox_with_mail:","description":"open mailbox with raised flag","unicode":"\uD83D\uDCEC","tags":"mailbox_with_mail"},{"emoji":":mailbox_with_no_mail:","description":"open mailbox with lowered flag","unicode":"\uD83D\uDCED","tags":"mailbox_with_no_mail"},{"emoji":":postbox:","description":"postbox","unicode":"\uD83D\uDCEE","tags":"postbox"},{"emoji":":package:","description":"package","unicode":"\uD83D\uDCE6","tags":"shipping:package"},{"emoji":":memo:","description":"memo","unicode":"\uD83D\uDCDD","tags":"document:note:memo:pencil"},{"emoji":":page_facing_up:","description":"page facing up","unicode":"\uD83D\uDCC4","tags":"document:page_facing_up"},{"emoji":":page_with_curl:","description":"page with curl","unicode":"\uD83D\uDCC3","tags":"page_with_curl"},{"emoji":":bookmark_tabs:","description":"bookmark tabs","unicode":"\uD83D\uDCD1","tags":"bookmark_tabs"},{"emoji":":bar_chart:","description":"bar chart","unicode":"\uD83D\uDCCA","tags":"stats:metrics:bar_chart"},{"emoji":":chart_with_upwards_trend:","description":"chart with upwards trend","unicode":"\uD83D\uDCC8","tags":"graph:metrics:chart_with_upwards_trend"},{"emoji":":chart_with_downwards_trend:","description":"chart with downwards trend","unicode":"\uD83D\uDCC9","tags":"graph:metrics:chart_with_downwards_trend"},{"emoji":":scroll:","description":"scroll","unicode":"\uD83D\uDCDC","tags":"document:scroll"},{"emoji":":clipboard:","description":"clipboard","unicode":"\uD83D\uDCCB","tags":"clipboard"},{"emoji":":date:","description":"calendar","unicode":"\uD83D\uDCC5","tags":"calendar:schedule:date"},{"emoji":":calendar:","description":"tear-off calendar","unicode":"\uD83D\uDCC6","tags":"schedule:calendar"},{"emoji":":card_index:","description":"card index","unicode":"\uD83D\uDCC7","tags":"card_index"},{"emoji":":file_folder:","description":"file folder","unicode":"\uD83D\uDCC1","tags":"directory:file_folder"},{"emoji":":open_file_folder:","description":"open file folder","unicode":"\uD83D\uDCC2","tags":"open_file_folder"},{"emoji":":scissors:","description":"black scissors","unicode":"\u2702\uFE0F","tags":"cut:scissors"},{"emoji":":pushpin:","description":"pushpin","unicode":"\uD83D\uDCCC","tags":"location:pushpin"},{"emoji":":paperclip:","description":"paperclip","unicode":"\uD83D\uDCCE","tags":"paperclip"},{"emoji":":black_nib:","description":"black nib","unicode":"\u2712\uFE0F","tags":"black_nib"},{"emoji":":pencil2:","description":"pencil","unicode":"\u270F\uFE0F","tags":"pencil2"},{"emoji":":straight_ruler:","description":"straight ruler","unicode":"\uD83D\uDCCF","tags":"straight_ruler"},{"emoji":":triangular_ruler:","description":"triangular ruler","unicode":"\uD83D\uDCD0","tags":"triangular_ruler"},{"emoji":":closed_book:","description":"closed book","unicode":"\uD83D\uDCD5","tags":"closed_book"},{"emoji":":green_book:","description":"green book","unicode":"\uD83D\uDCD7","tags":"green_book"},{"emoji":":blue_book:","description":"blue book","unicode":"\uD83D\uDCD8","tags":"blue_book"},{"emoji":":orange_book:","description":"orange book","unicode":"\uD83D\uDCD9","tags":"orange_book"},{"emoji":":notebook:","description":"notebook","unicode":"\uD83D\uDCD3","tags":"notebook"},{"emoji":":notebook_with_decorative_cover:","description":"notebook with decorative cover","unicode":"\uD83D\uDCD4","tags":"notebook_with_decorative_cover"},{"emoji":":ledger:","description":"ledger","unicode":"\uD83D\uDCD2","tags":"ledger"},{"emoji":":books:","description":"books","unicode":"\uD83D\uDCDA","tags":"library:books"},{"emoji":":book:","description":"open book","unicode":"\uD83D\uDCD6","tags":"book:open_book"},{"emoji":":bookmark:","description":"bookmark","unicode":"\uD83D\uDD16","tags":"bookmark"},{"emoji":":name_badge:","description":"name badge","unicode":"\uD83D\uDCDB","tags":"name_badge"},{"emoji":":microscope:","description":"microscope","unicode":"\uD83D\uDD2C","tags":"science:laboratory:investigate:microscope"},{"emoji":":telescope:","description":"telescope","unicode":"\uD83D\uDD2D","tags":"telescope"},{"emoji":":newspaper:","description":"newspaper","unicode":"\uD83D\uDCF0","tags":"press:newspaper"},{"emoji":":art:","description":"artist palette","unicode":"\uD83C\uDFA8","tags":"design:paint:art"},{"emoji":":clapper:","description":"clapper board","unicode":"\uD83C\uDFAC","tags":"film:clapper"},{"emoji":":microphone:","description":"microphone","unicode":"\uD83C\uDFA4","tags":"sing:microphone"},{"emoji":":headphones:","description":"headphone","unicode":"\uD83C\uDFA7","tags":"music:earphones:headphones"},{"emoji":":musical_score:","description":"musical score","unicode":"\uD83C\uDFBC","tags":"musical_score"},{"emoji":":musical_note:","description":"musical note","unicode":"\uD83C\uDFB5","tags":"musical_note"},{"emoji":":notes:","description":"multiple musical notes","unicode":"\uD83C\uDFB6","tags":"music:notes"},{"emoji":":musical_keyboard:","description":"musical keyboard","unicode":"\uD83C\uDFB9","tags":"piano:musical_keyboard"},{"emoji":":violin:","description":"violin","unicode":"\uD83C\uDFBB","tags":"violin"},{"emoji":":trumpet:","description":"trumpet","unicode":"\uD83C\uDFBA","tags":"trumpet"},{"emoji":":saxophone:","description":"saxophone","unicode":"\uD83C\uDFB7","tags":"saxophone"},{"emoji":":guitar:","description":"guitar","unicode":"\uD83C\uDFB8","tags":"rock:guitar"},{"emoji":":space_invader:","description":"alien monster","unicode":"\uD83D\uDC7E","tags":"game:retro:space_invader"},{"emoji":":video_game:","description":"video game","unicode":"\uD83C\uDFAE","tags":"play:controller:console:video_game"},{"emoji":":black_joker:","description":"playing card black joker","unicode":"\uD83C\uDCCF","tags":"black_joker"},{"emoji":":flower_playing_cards:","description":"flower playing cards","unicode":"\uD83C\uDFB4","tags":"flower_playing_cards"},{"emoji":":mahjong:","description":"mahjong tile red dragon","unicode":"\uD83C\uDC04","tags":"mahjong"},{"emoji":":game_die:","description":"game die","unicode":"\uD83C\uDFB2","tags":"dice:gambling:game_die"},{"emoji":":dart:","description":"direct hit","unicode":"\uD83C\uDFAF","tags":"target:dart"},{"emoji":":football:","description":"american football","unicode":"\uD83C\uDFC8","tags":"sports:football"},{"emoji":":basketball:","description":"basketball and hoop","unicode":"\uD83C\uDFC0","tags":"sports:basketball"},{"emoji":":soccer:","description":"soccer ball","unicode":"\u26BD","tags":"sports:soccer"},{"emoji":":baseball:","description":"baseball","unicode":"\u26BE\uFE0F","tags":"sports:baseball"},{"emoji":":tennis:","description":"tennis racquet and ball","unicode":"\uD83C\uDFBE","tags":"sports:tennis"},{"emoji":":8ball:","description":"billiards","unicode":"\uD83C\uDFB1","tags":"pool:billiards:8ball"},{"emoji":":rugby_football:","description":"rugby football","unicode":"\uD83C\uDFC9","tags":"rugby_football"},{"emoji":":bowling:","description":"bowling","unicode":"\uD83C\uDFB3","tags":"bowling"},{"emoji":":golf:","description":"flag in hole","unicode":"\u26F3","tags":"golf"},{"emoji":":mountain_bicyclist:","description":"mountain bicyclist","unicode":"\uD83D\uDEB5","tags":"mountain_bicyclist"},{"emoji":":bicyclist:","description":"bicyclist","unicode":"\uD83D\uDEB4","tags":"bicyclist"},{"emoji":":checkered_flag:","description":"chequered flag","unicode":"\uD83C\uDFC1","tags":"milestone:finish:checkered_flag"},{"emoji":":horse_racing:","description":"horse racing","unicode":"\uD83C\uDFC7","tags":"horse_racing"},{"emoji":":trophy:","description":"trophy","unicode":"\uD83C\uDFC6","tags":"award:contest:winner:trophy"},{"emoji":":ski:","description":"ski and ski boot","unicode":"\uD83C\uDFBF","tags":"ski"},{"emoji":":snowboarder:","description":"snowboarder","unicode":"\uD83C\uDFC2","tags":"snowboarder"},{"emoji":":swimmer:","description":"swimmer","unicode":"\uD83C\uDFCA","tags":"swimmer"},{"emoji":":surfer:","description":"surfer","unicode":"\uD83C\uDFC4","tags":"surfer"},{"emoji":":fishing_pole_and_fish:","description":"fishing pole and fish","unicode":"\uD83C\uDFA3","tags":"fishing_pole_and_fish"},{"emoji":":coffee:","description":"hot beverage","unicode":"\u2615","tags":"cafe:espresso:coffee"},{"emoji":":tea:","description":"teacup without handle","unicode":"\uD83C\uDF75","tags":"green:breakfast:tea"},{"emoji":":sake:","description":"sake bottle and cup","unicode":"\uD83C\uDF76","tags":"sake"},{"emoji":":baby_bottle:","description":"baby bottle","unicode":"\uD83C\uDF7C","tags":"milk:baby_bottle"},{"emoji":":beer:","description":"beer mug","unicode":"\uD83C\uDF7A","tags":"drink:beer"},{"emoji":":beers:","description":"clinking beer mugs","unicode":"\uD83C\uDF7B","tags":"drinks:beers"},{"emoji":":cocktail:","description":"cocktail glass","unicode":"\uD83C\uDF78","tags":"drink:cocktail"},{"emoji":":tropical_drink:","description":"tropical drink","unicode":"\uD83C\uDF79","tags":"summer:vacation:tropical_drink"},{"emoji":":wine_glass:","description":"wine glass","unicode":"\uD83C\uDF77","tags":"wine_glass"},{"emoji":":fork_and_knife:","description":"fork and knife","unicode":"\uD83C\uDF74","tags":"cutlery:fork_and_knife"},{"emoji":":pizza:","description":"slice of pizza","unicode":"\uD83C\uDF55","tags":"pizza"},{"emoji":":hamburger:","description":"hamburger","unicode":"\uD83C\uDF54","tags":"burger:hamburger"},{"emoji":":fries:","description":"french fries","unicode":"\uD83C\uDF5F","tags":"fries"},{"emoji":":poultry_leg:","description":"poultry leg","unicode":"\uD83C\uDF57","tags":"meat:chicken:poultry_leg"},{"emoji":":meat_on_bone:","description":"meat on bone","unicode":"\uD83C\uDF56","tags":"meat_on_bone"},{"emoji":":spaghetti:","description":"spaghetti","unicode":"\uD83C\uDF5D","tags":"pasta:spaghetti"},{"emoji":":curry:","description":"curry and rice","unicode":"\uD83C\uDF5B","tags":"curry"},{"emoji":":fried_shrimp:","description":"fried shrimp","unicode":"\uD83C\uDF64","tags":"tempura:fried_shrimp"},{"emoji":":bento:","description":"bento box","unicode":"\uD83C\uDF71","tags":"bento"},{"emoji":":sushi:","description":"sushi","unicode":"\uD83C\uDF63","tags":"sushi"},{"emoji":":fish_cake:","description":"fish cake with swirl design","unicode":"\uD83C\uDF65","tags":"fish_cake"},{"emoji":":rice_ball:","description":"rice ball","unicode":"\uD83C\uDF59","tags":"rice_ball"},{"emoji":":rice_cracker:","description":"rice cracker","unicode":"\uD83C\uDF58","tags":"rice_cracker"},{"emoji":":rice:","description":"cooked rice","unicode":"\uD83C\uDF5A","tags":"rice"},{"emoji":":ramen:","description":"steaming bowl","unicode":"\uD83C\uDF5C","tags":"noodle:ramen"},{"emoji":":stew:","description":"pot of food","unicode":"\uD83C\uDF72","tags":"stew"},{"emoji":":oden:","description":"oden","unicode":"\uD83C\uDF62","tags":"oden"},{"emoji":":dango:","description":"dango","unicode":"\uD83C\uDF61","tags":"dango"},{"emoji":":egg:","description":"cooking","unicode":"\uD83C\uDF73","tags":"breakfast:egg"},{"emoji":":bread:","description":"bread","unicode":"\uD83C\uDF5E","tags":"toast:bread"},{"emoji":":doughnut:","description":"doughnut","unicode":"\uD83C\uDF69","tags":"doughnut"},{"emoji":":custard:","description":"custard","unicode":"\uD83C\uDF6E","tags":"custard"},{"emoji":":icecream:","description":"soft ice cream","unicode":"\uD83C\uDF66","tags":"icecream"},{"emoji":":ice_cream:","description":"ice cream","unicode":"\uD83C\uDF68","tags":"ice_cream"},{"emoji":":shaved_ice:","description":"shaved ice","unicode":"\uD83C\uDF67","tags":"shaved_ice"},{"emoji":":birthday:","description":"birthday cake","unicode":"\uD83C\uDF82","tags":"party:birthday"},{"emoji":":cake:","description":"shortcake","unicode":"\uD83C\uDF70","tags":"dessert:cake"},{"emoji":":cookie:","description":"cookie","unicode":"\uD83C\uDF6A","tags":"cookie"},{"emoji":":chocolate_bar:","description":"chocolate bar","unicode":"\uD83C\uDF6B","tags":"chocolate_bar"},{"emoji":":candy:","description":"candy","unicode":"\uD83C\uDF6C","tags":"sweet:candy"},{"emoji":":lollipop:","description":"lollipop","unicode":"\uD83C\uDF6D","tags":"lollipop"},{"emoji":":honey_pot:","description":"honey pot","unicode":"\uD83C\uDF6F","tags":"honey_pot"},{"emoji":":apple:","description":"red apple","unicode":"\uD83C\uDF4E","tags":"apple"},{"emoji":":green_apple:","description":"green apple","unicode":"\uD83C\uDF4F","tags":"fruit:green_apple"},{"emoji":":tangerine:","description":"tangerine","unicode":"\uD83C\uDF4A","tags":"tangerine"},{"emoji":":lemon:","description":"lemon","unicode":"\uD83C\uDF4B","tags":"lemon"},{"emoji":":cherries:","description":"cherries","unicode":"\uD83C\uDF52","tags":"fruit:cherries"},{"emoji":":grapes:","description":"grapes","unicode":"\uD83C\uDF47","tags":"grapes"},{"emoji":":watermelon:","description":"watermelon","unicode":"\uD83C\uDF49","tags":"watermelon"},{"emoji":":strawberry:","description":"strawberry","unicode":"\uD83C\uDF53","tags":"fruit:strawberry"},{"emoji":":peach:","description":"peach","unicode":"\uD83C\uDF51","tags":"peach"},{"emoji":":melon:","description":"melon","unicode":"\uD83C\uDF48","tags":"melon"},{"emoji":":banana:","description":"banana","unicode":"\uD83C\uDF4C","tags":"fruit:banana"},{"emoji":":pear:","description":"pear","unicode":"\uD83C\uDF50","tags":"pear"},{"emoji":":pineapple:","description":"pineapple","unicode":"\uD83C\uDF4D","tags":"pineapple"},{"emoji":":sweet_potato:","description":"roasted sweet potato","unicode":"\uD83C\uDF60","tags":"sweet_potato"},{"emoji":":eggplant:","description":"aubergine","unicode":"\uD83C\uDF46","tags":"aubergine:eggplant"},{"emoji":":tomato:","description":"tomato","unicode":"\uD83C\uDF45","tags":"tomato"},{"emoji":":corn:","description":"ear of maize","unicode":"\uD83C\uDF3D","tags":"corn"},{"emoji":":house:","description":"house building","unicode":"\uD83C\uDFE0","tags":"house"},{"emoji":":house_with_garden:","description":"house with garden","unicode":"\uD83C\uDFE1","tags":"house_with_garden"},{"emoji":":school:","description":"school","unicode":"\uD83C\uDFEB","tags":"school"},{"emoji":":office:","description":"office building","unicode":"\uD83C\uDFE2","tags":"office"},{"emoji":":post_office:","description":"japanese post office","unicode":"\uD83C\uDFE3","tags":"post_office"},{"emoji":":hospital:","description":"hospital","unicode":"\uD83C\uDFE5","tags":"hospital"},{"emoji":":bank:","description":"bank","unicode":"\uD83C\uDFE6","tags":"bank"},{"emoji":":convenience_store:","description":"convenience store","unicode":"\uD83C\uDFEA","tags":"convenience_store"},{"emoji":":love_hotel:","description":"love hotel","unicode":"\uD83C\uDFE9","tags":"love_hotel"},{"emoji":":hotel:","description":"hotel","unicode":"\uD83C\uDFE8","tags":"hotel"},{"emoji":":wedding:","description":"wedding","unicode":"\uD83D\uDC92","tags":"marriage:wedding"},{"emoji":":church:","description":"church","unicode":"\u26EA","tags":"church"},{"emoji":":department_store:","description":"department store","unicode":"\uD83C\uDFEC","tags":"department_store"},{"emoji":":european_post_office:","description":"european post office","unicode":"\uD83C\uDFE4","tags":"european_post_office"},{"emoji":":city_sunrise:","description":"sunset over buildings","unicode":"\uD83C\uDF07","tags":"city_sunrise"},{"emoji":":city_sunset:","description":"cityscape at dusk","unicode":"\uD83C\uDF06","tags":"city_sunset"},{"emoji":":japanese_castle:","description":"japanese castle","unicode":"\uD83C\uDFEF","tags":"japanese_castle"},{"emoji":":european_castle:","description":"european castle","unicode":"\uD83C\uDFF0","tags":"european_castle"},{"emoji":":tent:","description":"tent","unicode":"\u26FA","tags":"camping:tent"},{"emoji":":factory:","description":"factory","unicode":"\uD83C\uDFED","tags":"factory"},{"emoji":":tokyo_tower:","description":"tokyo tower","unicode":"\uD83D\uDDFC","tags":"tokyo_tower"},{"emoji":":japan:","description":"silhouette of japan","unicode":"\uD83D\uDDFE","tags":"japan"},{"emoji":":mount_fuji:","description":"mount fuji","unicode":"\uD83D\uDDFB","tags":"mount_fuji"},{"emoji":":sunrise_over_mountains:","description":"sunrise over mountains","unicode":"\uD83C\uDF04","tags":"sunrise_over_mountains"},{"emoji":":sunrise:","description":"sunrise","unicode":"\uD83C\uDF05","tags":"sunrise"},{"emoji":":night_with_stars:","description":"night with stars","unicode":"\uD83C\uDF03","tags":"night_with_stars"},{"emoji":":statue_of_liberty:","description":"statue of liberty","unicode":"\uD83D\uDDFD","tags":"statue_of_liberty"},{"emoji":":bridge_at_night:","description":"bridge at night","unicode":"\uD83C\uDF09","tags":"bridge_at_night"},{"emoji":":carousel_horse:","description":"carousel horse","unicode":"\uD83C\uDFA0","tags":"carousel_horse"},{"emoji":":ferris_wheel:","description":"ferris wheel","unicode":"\uD83C\uDFA1","tags":"ferris_wheel"},{"emoji":":fountain:","description":"fountain","unicode":"\u26F2","tags":"fountain"},{"emoji":":roller_coaster:","description":"roller coaster","unicode":"\uD83C\uDFA2","tags":"roller_coaster"},{"emoji":":ship:","description":"ship","unicode":"\uD83D\uDEA2","tags":"ship"},{"emoji":":boat:","description":"sailboat","unicode":"\u26F5","tags":"boat:sailboat"},{"emoji":":speedboat:","description":"speedboat","unicode":"\uD83D\uDEA4","tags":"ship:speedboat"},{"emoji":":rowboat:","description":"rowboat","unicode":"\uD83D\uDEA3","tags":"rowboat"},{"emoji":":anchor:","description":"anchor","unicode":"\u2693","tags":"ship:anchor"},{"emoji":":rocket:","description":"rocket","unicode":"\uD83D\uDE80","tags":"ship:launch:rocket"},{"emoji":":airplane:","description":"airplane","unicode":"\u2708\uFE0F","tags":"flight:airplane"},{"emoji":":seat:","description":"seat","unicode":"\uD83D\uDCBA","tags":"seat"},{"emoji":":helicopter:","description":"helicopter","unicode":"\uD83D\uDE81","tags":"helicopter"},{"emoji":":steam_locomotive:","description":"steam locomotive","unicode":"\uD83D\uDE82","tags":"train:steam_locomotive"},{"emoji":":tram:","description":"tram","unicode":"\uD83D\uDE8A","tags":"tram"},{"emoji":":station:","description":"station","unicode":"\uD83D\uDE89","tags":"station"},{"emoji":":mountain_railway:","description":"mountain railway","unicode":"\uD83D\uDE9E","tags":"mountain_railway"},{"emoji":":train2:","description":"train","unicode":"\uD83D\uDE86","tags":"train2"},{"emoji":":bullettrain_side:","description":"high-speed train","unicode":"\uD83D\uDE84","tags":"train:bullettrain_side"},{"emoji":":bullettrain_front:","description":"high-speed train with bullet nose","unicode":"\uD83D\uDE85","tags":"train:bullettrain_front"},{"emoji":":light_rail:","description":"light rail","unicode":"\uD83D\uDE88","tags":"light_rail"},{"emoji":":metro:","description":"metro","unicode":"\uD83D\uDE87","tags":"metro"},{"emoji":":monorail:","description":"monorail","unicode":"\uD83D\uDE9D","tags":"monorail"},{"emoji":":train:","description":"tram car","unicode":"\uD83D\uDE8B","tags":"train"},{"emoji":":railway_car:","description":"railway car","unicode":"\uD83D\uDE83","tags":"railway_car"},{"emoji":":trolleybus:","description":"trolleybus","unicode":"\uD83D\uDE8E","tags":"trolleybus"},{"emoji":":bus:","description":"bus","unicode":"\uD83D\uDE8C","tags":"bus"},{"emoji":":oncoming_bus:","description":"oncoming bus","unicode":"\uD83D\uDE8D","tags":"oncoming_bus"},{"emoji":":blue_car:","description":"recreational vehicle","unicode":"\uD83D\uDE99","tags":"blue_car"},{"emoji":":oncoming_automobile:","description":"oncoming automobile","unicode":"\uD83D\uDE98","tags":"oncoming_automobile"},{"emoji":":car:","description":"automobile","unicode":"\uD83D\uDE97","tags":"car:red_car"},{"emoji":":taxi:","description":"taxi","unicode":"\uD83D\uDE95","tags":"taxi"},{"emoji":":oncoming_taxi:","description":"oncoming taxi","unicode":"\uD83D\uDE96","tags":"oncoming_taxi"},{"emoji":":articulated_lorry:","description":"articulated lorry","unicode":"\uD83D\uDE9B","tags":"articulated_lorry"},{"emoji":":truck:","description":"delivery truck","unicode":"\uD83D\uDE9A","tags":"truck"},{"emoji":":rotating_light:","description":"police cars revolving light","unicode":"\uD83D\uDEA8","tags":"911:emergency:rotating_light"},{"emoji":":police_car:","description":"police car","unicode":"\uD83D\uDE93","tags":"police_car"},{"emoji":":oncoming_police_car:","description":"oncoming police car","unicode":"\uD83D\uDE94","tags":"oncoming_police_car"},{"emoji":":fire_engine:","description":"fire engine","unicode":"\uD83D\uDE92","tags":"fire_engine"},{"emoji":":ambulance:","description":"ambulance","unicode":"\uD83D\uDE91","tags":"ambulance"},{"emoji":":minibus:","description":"minibus","unicode":"\uD83D\uDE90","tags":"minibus"},{"emoji":":bike:","description":"bicycle","unicode":"\uD83D\uDEB2","tags":"bicycle:bike"},{"emoji":":aerial_tramway:","description":"aerial tramway","unicode":"\uD83D\uDEA1","tags":"aerial_tramway"},{"emoji":":suspension_railway:","description":"suspension railway","unicode":"\uD83D\uDE9F","tags":"suspension_railway"},{"emoji":":mountain_cableway:","description":"mountain cableway","unicode":"\uD83D\uDEA0","tags":"mountain_cableway"},{"emoji":":tractor:","description":"tractor","unicode":"\uD83D\uDE9C","tags":"tractor"},{"emoji":":barber:","description":"barber pole","unicode":"\uD83D\uDC88","tags":"barber"},{"emoji":":busstop:","description":"bus stop","unicode":"\uD83D\uDE8F","tags":"busstop"},{"emoji":":ticket:","description":"ticket","unicode":"\uD83C\uDFAB","tags":"ticket"},{"emoji":":vertical_traffic_light:","description":"vertical traffic light","unicode":"\uD83D\uDEA6","tags":"semaphore:vertical_traffic_light"},{"emoji":":traffic_light:","description":"horizontal traffic light","unicode":"\uD83D\uDEA5","tags":"traffic_light"},{"emoji":":warning:","description":"warning sign","unicode":"\u26A0\uFE0F","tags":"wip:warning"},{"emoji":":construction:","description":"construction sign","unicode":"\uD83D\uDEA7","tags":"wip:construction"},{"emoji":":beginner:","description":"japanese symbol for beginner","unicode":"\uD83D\uDD30","tags":"beginner"},{"emoji":":fuelpump:","description":"fuel pump","unicode":"\u26FD","tags":"fuelpump"},{"emoji":":izakaya_lantern:","description":"izakaya lantern","unicode":"\uD83C\uDFEE","tags":"izakaya_lantern:lantern"},{"emoji":":slot_machine:","description":"slot machine","unicode":"\uD83C\uDFB0","tags":"slot_machine"},{"emoji":":hotsprings:","description":"hot springs","unicode":"\u2668\uFE0F","tags":"hotsprings"},{"emoji":":moyai:","description":"moyai","unicode":"\uD83D\uDDFF","tags":"stone:moyai"},{"emoji":":circus_tent:","description":"circus tent","unicode":"\uD83C\uDFAA","tags":"circus_tent"},{"emoji":":performing_arts:","description":"performing arts","unicode":"\uD83C\uDFAD","tags":"theater:drama:performing_arts"},{"emoji":":round_pushpin:","description":"round pushpin","unicode":"\uD83D\uDCCD","tags":"location:round_pushpin"},{"emoji":":triangular_flag_on_post:","description":"triangular flag on post","unicode":"\uD83D\uDEA9","tags":"triangular_flag_on_post"},{"emoji":":jp:","description":"regional indicator symbol letter j + regional indicator symbol letter p","unicode":"\uD83C\uDDEF\uD83C\uDDF5","tags":"japan:jp"},{"emoji":":kr:","description":"regional indicator symbol letter k + regional indicator symbol letter r","unicode":"\uD83C\uDDF0\uD83C\uDDF7","tags":"korea:kr"},{"emoji":":de:","description":"regional indicator symbol letter d + regional indicator symbol letter e","unicode":"\uD83C\uDDE9\uD83C\uDDEA","tags":"flag:germany:de"},{"emoji":":cn:","description":"regional indicator symbol letter c + regional indicator symbol letter n","unicode":"\uD83C\uDDE8\uD83C\uDDF3","tags":"china:cn"},{"emoji":":us:","description":"regional indicator symbol letter u + regional indicator symbol letter s","unicode":"\uD83C\uDDFA\uD83C\uDDF8","tags":"flag:united:america:us"},{"emoji":":fr:","description":"regional indicator symbol letter f + regional indicator symbol letter r","unicode":"\uD83C\uDDEB\uD83C\uDDF7","tags":"france:french:fr"},{"emoji":":es:","description":"regional indicator symbol letter e + regional indicator symbol letter s","unicode":"\uD83C\uDDEA\uD83C\uDDF8","tags":"spain:es"},{"emoji":":it:","description":"regional indicator symbol letter i + regional indicator symbol letter t","unicode":"\uD83C\uDDEE\uD83C\uDDF9","tags":"italy:it"},{"emoji":":ru:","description":"regional indicator symbol letter r + regional indicator symbol letter u","unicode":"\uD83C\uDDF7\uD83C\uDDFA","tags":"russia:ru"},{"emoji":":gb:","description":"regional indicator symbol letter g + regional indicator symbol letter b","unicode":"\uD83C\uDDEC\uD83C\uDDE7","tags":"flag:british:gb:uk"},{"emoji":":one:","description":"digit one + combining enclosing keycap","unicode":"1\uFE0F\u20E3","tags":"one"},{"emoji":":two:","description":"digit two + combining enclosing keycap","unicode":"2\uFE0F\u20E3","tags":"two"},{"emoji":":three:","description":"digit three + combining enclosing keycap","unicode":"3\uFE0F\u20E3","tags":"three"},{"emoji":":four:","description":"digit four + combining enclosing keycap","unicode":"4\uFE0F\u20E3","tags":"four"},{"emoji":":five:","description":"digit five + combining enclosing keycap","unicode":"5\uFE0F\u20E3","tags":"five"},{"emoji":":six:","description":"digit six + combining enclosing keycap","unicode":"6\uFE0F\u20E3","tags":"six"},{"emoji":":seven:","description":"digit seven + combining enclosing keycap","unicode":"7\uFE0F\u20E3","tags":"seven"},{"emoji":":eight:","description":"digit eight + combining enclosing keycap","unicode":"8\uFE0F\u20E3","tags":"eight"},{"emoji":":nine:","description":"digit nine + combining enclosing keycap","unicode":"9\uFE0F\u20E3","tags":"nine"},{"emoji":":zero:","description":"digit zero + combining enclosing keycap","unicode":"0\uFE0F\u20E3","tags":"zero"},{"emoji":":keycap_ten:","description":"keycap ten","unicode":"\uD83D\uDD1F","tags":"keycap_ten"},{"emoji":":1234:","description":"input symbol for numbers","unicode":"\uD83D\uDD22","tags":"numbers:1234"},{"emoji":":hash:","description":"number sign + combining enclosing keycap","unicode":"#\uFE0F\u20E3","tags":"number:hash"},{"emoji":":symbols:","description":"input symbol for symbols","unicode":"\uD83D\uDD23","tags":"symbols"},{"emoji":":arrow_up:","description":"upwards black arrow","unicode":"\u2B06\uFE0F","tags":"arrow_up"},{"emoji":":arrow_down:","description":"downwards black arrow","unicode":"\u2B07\uFE0F","tags":"arrow_down"},{"emoji":":arrow_left:","description":"leftwards black arrow","unicode":"\u2B05\uFE0F","tags":"arrow_left"},{"emoji":":arrow_right:","description":"black rightwards arrow","unicode":"\u27A1\uFE0F","tags":"arrow_right"},{"emoji":":capital_abcd:","description":"input symbol for latin capital letters","unicode":"\uD83D\uDD20","tags":"letters:capital_abcd"},{"emoji":":abcd:","description":"input symbol for latin small letters","unicode":"\uD83D\uDD21","tags":"abcd"},{"emoji":":abc:","description":"input symbol for latin letters","unicode":"\uD83D\uDD24","tags":"alphabet:abc"},{"emoji":":arrow_upper_right:","description":"north east arrow","unicode":"\u2197\uFE0F","tags":"arrow_upper_right"},{"emoji":":arrow_upper_left:","description":"north west arrow","unicode":"\u2196\uFE0F","tags":"arrow_upper_left"},{"emoji":":arrow_lower_right:","description":"south east arrow","unicode":"\u2198\uFE0F","tags":"arrow_lower_right"},{"emoji":":arrow_lower_left:","description":"south west arrow","unicode":"\u2199\uFE0F","tags":"arrow_lower_left"},{"emoji":":left_right_arrow:","description":"left right arrow","unicode":"\u2194\uFE0F","tags":"left_right_arrow"},{"emoji":":arrow_up_down:","description":"up down arrow","unicode":"\u2195\uFE0F","tags":"arrow_up_down"},{"emoji":":arrows_counterclockwise:","description":"anticlockwise downwards and upwards open circle arrows","unicode":"\uD83D\uDD04","tags":"sync:arrows_counterclockwise"},{"emoji":":arrow_backward:","description":"black left-pointing triangle","unicode":"\u25C0\uFE0F","tags":"arrow_backward"},{"emoji":":arrow_forward:","description":"black right-pointing triangle","unicode":"\u25B6\uFE0F","tags":"arrow_forward"},{"emoji":":arrow_up_small:","description":"up-pointing small red triangle","unicode":"\uD83D\uDD3C","tags":"arrow_up_small"},{"emoji":":arrow_down_small:","description":"down-pointing small red triangle","unicode":"\uD83D\uDD3D","tags":"arrow_down_small"},{"emoji":":leftwards_arrow_with_hook:","description":"leftwards arrow with hook","unicode":"\u21A9\uFE0F","tags":"return:leftwards_arrow_with_hook"},{"emoji":":arrow_right_hook:","description":"rightwards arrow with hook","unicode":"\u21AA\uFE0F","tags":"arrow_right_hook"},{"emoji":":information_source:","description":"information source","unicode":"\u2139\uFE0F","tags":"information_source"},{"emoji":":rewind:","description":"black left-pointing double triangle","unicode":"\u23EA","tags":"rewind"},{"emoji":":fast_forward:","description":"black right-pointing double triangle","unicode":"\u23E9","tags":"fast_forward"},{"emoji":":arrow_double_up:","description":"black up-pointing double triangle","unicode":"\u23EB","tags":"arrow_double_up"},{"emoji":":arrow_double_down:","description":"black down-pointing double triangle","unicode":"\u23EC","tags":"arrow_double_down"},{"emoji":":arrow_heading_down:","description":"arrow pointing rightwards then curving downwards","unicode":"\u2935\uFE0F","tags":"arrow_heading_down"},{"emoji":":arrow_heading_up:","description":"arrow pointing rightwards then curving upwards","unicode":"\u2934\uFE0F","tags":"arrow_heading_up"},{"emoji":":ok:","description":"squared ok","unicode":"\uD83C\uDD97","tags":"yes:ok"},{"emoji":":twisted_rightwards_arrows:","description":"twisted rightwards arrows","unicode":"\uD83D\uDD00","tags":"shuffle:twisted_rightwards_arrows"},{"emoji":":repeat:","description":"clockwise rightwards and leftwards open circle arrows","unicode":"\uD83D\uDD01","tags":"loop:repeat"},{"emoji":":repeat_one:","description":"clockwise rightwards and leftwards open circle arrows with circled one overlay","unicode":"\uD83D\uDD02","tags":"repeat_one"},{"emoji":":new:","description":"squared new","unicode":"\uD83C\uDD95","tags":"fresh:new"},{"emoji":":up:","description":"squared up with exclamation mark","unicode":"\uD83C\uDD99","tags":"up"},{"emoji":":cool:","description":"squared cool","unicode":"\uD83C\uDD92","tags":"cool"},{"emoji":":free:","description":"squared free","unicode":"\uD83C\uDD93","tags":"free"},{"emoji":":ng:","description":"squared ng","unicode":"\uD83C\uDD96","tags":"ng"},{"emoji":":signal_strength:","description":"antenna with bars","unicode":"\uD83D\uDCF6","tags":"wifi:signal_strength"},{"emoji":":cinema:","description":"cinema","unicode":"\uD83C\uDFA6","tags":"film:movie:cinema"},{"emoji":":koko:","description":"squared katakana koko","unicode":"\uD83C\uDE01","tags":"koko"},{"emoji":":u6307:","description":"squared cjk unified ideograph-6307","unicode":"\uD83C\uDE2F","tags":"u6307"},{"emoji":":u7a7a:","description":"squared cjk unified ideograph-7a7a","unicode":"\uD83C\uDE33","tags":"u7a7a"},{"emoji":":u6e80:","description":"squared cjk unified ideograph-6e80","unicode":"\uD83C\uDE35","tags":"u6e80"},{"emoji":":u5408:","description":"squared cjk unified ideograph-5408","unicode":"\uD83C\uDE34","tags":"u5408"},{"emoji":":u7981:","description":"squared cjk unified ideograph-7981","unicode":"\uD83C\uDE32","tags":"u7981"},{"emoji":":ideograph_advantage:","description":"circled ideograph advantage","unicode":"\uD83C\uDE50","tags":"ideograph_advantage"},{"emoji":":u5272:","description":"squared cjk unified ideograph-5272","unicode":"\uD83C\uDE39","tags":"u5272"},{"emoji":":u55b6:","description":"squared cjk unified ideograph-55b6","unicode":"\uD83C\uDE3A","tags":"u55b6"},{"emoji":":u6709:","description":"squared cjk unified ideograph-6709","unicode":"\uD83C\uDE36","tags":"u6709"},{"emoji":":u7121:","description":"squared cjk unified ideograph-7121","unicode":"\uD83C\uDE1A","tags":"u7121"},{"emoji":":restroom:","description":"restroom","unicode":"\uD83D\uDEBB","tags":"toilet:restroom"},{"emoji":":mens:","description":"mens symbol","unicode":"\uD83D\uDEB9","tags":"mens"},{"emoji":":womens:","description":"womens symbol","unicode":"\uD83D\uDEBA","tags":"womens"},{"emoji":":baby_symbol:","description":"baby symbol","unicode":"\uD83D\uDEBC","tags":"baby_symbol"},{"emoji":":wc:","description":"water closet","unicode":"\uD83D\uDEBE","tags":"toilet:restroom:wc"},{"emoji":":potable_water:","description":"potable water symbol","unicode":"\uD83D\uDEB0","tags":"potable_water"},{"emoji":":put_litter_in_its_place:","description":"put litter in its place symbol","unicode":"\uD83D\uDEAE","tags":"put_litter_in_its_place"},{"emoji":":parking:","description":"negative squared latin capital letter p","unicode":"\uD83C\uDD7F\uFE0F","tags":"parking"},{"emoji":":wheelchair:","description":"wheelchair symbol","unicode":"\u267F","tags":"accessibility:wheelchair"},{"emoji":":no_smoking:","description":"no smoking symbol","unicode":"\uD83D\uDEAD","tags":"no_smoking"},{"emoji":":u6708:","description":"squared cjk unified ideograph-6708","unicode":"\uD83C\uDE37\uFE0F","tags":"u6708"},{"emoji":":u7533:","description":"squared cjk unified ideograph-7533","unicode":"\uD83C\uDE38","tags":"u7533"},{"emoji":":sa:","description":"squared katakana sa","unicode":"\uD83C\uDE02\uFE0F","tags":"sa"},{"emoji":":m:","description":"circled latin capital letter m","unicode":"\u24C2\uFE0F","tags":"m"},{"emoji":":passport_control:","description":"passport control","unicode":"\uD83D\uDEC2","tags":"passport_control"},{"emoji":":baggage_claim:","description":"baggage claim","unicode":"\uD83D\uDEC4","tags":"airport:baggage_claim"},{"emoji":":left_luggage:","description":"left luggage","unicode":"\uD83D\uDEC5","tags":"left_luggage"},{"emoji":":customs:","description":"customs","unicode":"\uD83D\uDEC3","tags":"customs"},{"emoji":":accept:","description":"circled ideograph accept","unicode":"\uD83C\uDE51","tags":"accept"},{"emoji":":secret:","description":"circled ideograph secret","unicode":"\u3299\uFE0F","tags":"secret"},{"emoji":":congratulations:","description":"circled ideograph congratulation","unicode":"\u3297\uFE0F","tags":"congratulations"},{"emoji":":cl:","description":"squared cl","unicode":"\uD83C\uDD91","tags":"cl"},{"emoji":":sos:","description":"squared sos","unicode":"\uD83C\uDD98","tags":"help:emergency:sos"},{"emoji":":id:","description":"squared id","unicode":"\uD83C\uDD94","tags":"id"},{"emoji":":no_entry_sign:","description":"no entry sign","unicode":"\uD83D\uDEAB","tags":"block:forbidden:no_entry_sign"},{"emoji":":underage:","description":"no one under eighteen symbol","unicode":"\uD83D\uDD1E","tags":"underage"},{"emoji":":no_mobile_phones:","description":"no mobile phones","unicode":"\uD83D\uDCF5","tags":"no_mobile_phones"},{"emoji":":do_not_litter:","description":"do not litter symbol","unicode":"\uD83D\uDEAF","tags":"do_not_litter"},{"emoji":":non-potable_water:","description":"non-potable water symbol","unicode":"\uD83D\uDEB1","tags":"non-potable_water"},{"emoji":":no_bicycles:","description":"no bicycles","unicode":"\uD83D\uDEB3","tags":"no_bicycles"},{"emoji":":no_pedestrians:","description":"no pedestrians","unicode":"\uD83D\uDEB7","tags":"no_pedestrians"},{"emoji":":children_crossing:","description":"children crossing","unicode":"\uD83D\uDEB8","tags":"children_crossing"},{"emoji":":no_entry:","description":"no entry","unicode":"\u26D4","tags":"limit:no_entry"},{"emoji":":eight_spoked_asterisk:","description":"eight spoked asterisk","unicode":"\u2733\uFE0F","tags":"eight_spoked_asterisk"},{"emoji":":sparkle:","description":"sparkle","unicode":"\u2747\uFE0F","tags":"sparkle"},{"emoji":":negative_squared_cross_mark:","description":"negative squared cross mark","unicode":"\u274E","tags":"negative_squared_cross_mark"},{"emoji":":white_check_mark:","description":"white heavy check mark","unicode":"\u2705","tags":"white_check_mark"},{"emoji":":eight_pointed_black_star:","description":"eight pointed black star","unicode":"\u2734\uFE0F","tags":"eight_pointed_black_star"},{"emoji":":heart_decoration:","description":"heart decoration","unicode":"\uD83D\uDC9F","tags":"heart_decoration"},{"emoji":":vs:","description":"squared vs","unicode":"\uD83C\uDD9A","tags":"vs"},{"emoji":":vibration_mode:","description":"vibration mode","unicode":"\uD83D\uDCF3","tags":"vibration_mode"},{"emoji":":mobile_phone_off:","description":"mobile phone off","unicode":"\uD83D\uDCF4","tags":"mute:off:mobile_phone_off"},{"emoji":":o2:","description":"negative squared latin capital letter o","unicode":"\uD83C\uDD7E\uFE0F","tags":"o2"},{"emoji":":diamond_shape_with_a_dot_inside:","description":"diamond shape with a dot inside","unicode":"\uD83D\uDCA0","tags":"diamond_shape_with_a_dot_inside"},{"emoji":":loop:","description":"double curly loop","unicode":"\u27BF","tags":"loop"},{"emoji":":recycle:","description":"black universal recycling symbol","unicode":"\u267B\uFE0F","tags":"environment:green:recycle"},{"emoji":":aries:","description":"aries","unicode":"\u2648","tags":"aries"},{"emoji":":taurus:","description":"taurus","unicode":"\u2649","tags":"taurus"},{"emoji":":gemini:","description":"gemini","unicode":"\u264A","tags":"gemini"},{"emoji":":cancer:","description":"cancer","unicode":"\u264B","tags":"cancer"},{"emoji":":leo:","description":"leo","unicode":"\u264C","tags":"leo"},{"emoji":":virgo:","description":"virgo","unicode":"\u264D","tags":"virgo"},{"emoji":":libra:","description":"libra","unicode":"\u264E","tags":"libra"},{"emoji":":scorpius:","description":"scorpius","unicode":"\u264F","tags":"scorpius"},{"emoji":":sagittarius:","description":"sagittarius","unicode":"\u2650","tags":"sagittarius"},{"emoji":":capricorn:","description":"capricorn","unicode":"\u2651","tags":"capricorn"},{"emoji":":aquarius:","description":"aquarius","unicode":"\u2652","tags":"aquarius"},{"emoji":":pisces:","description":"pisces","unicode":"\u2653","tags":"pisces"},{"emoji":":ophiuchus:","description":"ophiuchus","unicode":"\u26CE","tags":"ophiuchus"},{"emoji":":six_pointed_star:","description":"six pointed star with middle dot","unicode":"\uD83D\uDD2F","tags":"six_pointed_star"},{"emoji":":atm:","description":"automated teller machine","unicode":"\uD83C\uDFE7","tags":"atm"},{"emoji":":chart:","description":"chart with upwards trend and yen sign","unicode":"\uD83D\uDCB9","tags":"chart"},{"emoji":":heavy_dollar_sign:","description":"heavy dollar sign","unicode":"\uD83D\uDCB2","tags":"heavy_dollar_sign"},{"emoji":":currency_exchange:","description":"currency exchange","unicode":"\uD83D\uDCB1","tags":"currency_exchange"},{"emoji":":copyright:","description":"copyright sign","unicode":"\xa9\uFE0F","tags":"copyright"},{"emoji":":registered:","description":"registered sign","unicode":"\xae\uFE0F","tags":"registered"},{"emoji":":tm:","description":"trade mark sign","unicode":"\u2122\uFE0F","tags":"trademark:tm"},{"emoji":":x:","description":"cross mark","unicode":"\u274C","tags":"x"},{"emoji":":bangbang:","description":"double exclamation mark","unicode":"\u203C\uFE0F","tags":"bangbang"},{"emoji":":interrobang:","description":"exclamation question mark","unicode":"\u2049\uFE0F","tags":"interrobang"},{"emoji":":exclamation:","description":"heavy exclamation mark symbol","unicode":"\u2757","tags":"bang:exclamation:heavy_exclamation_mark"},{"emoji":":question:","description":"black question mark ornament","unicode":"\u2753","tags":"confused:question"},{"emoji":":grey_exclamation:","description":"white exclamation mark ornament","unicode":"\u2755","tags":"grey_exclamation"},{"emoji":":grey_question:","description":"white question mark ornament","unicode":"\u2754","tags":"grey_question"},{"emoji":":o:","description":"heavy large circle","unicode":"\u2B55","tags":"o"},{"emoji":":top:","description":"top with upwards arrow above","unicode":"\uD83D\uDD1D","tags":"top"},{"emoji":":end:","description":"end with leftwards arrow above","unicode":"\uD83D\uDD1A","tags":"end"},{"emoji":":back:","description":"back with leftwards arrow above","unicode":"\uD83D\uDD19","tags":"back"},{"emoji":":on:","description":"on with exclamation mark with left right arrow above","unicode":"\uD83D\uDD1B","tags":"on"},{"emoji":":soon:","description":"soon with rightwards arrow above","unicode":"\uD83D\uDD1C","tags":"soon"},{"emoji":":arrows_clockwise:","description":"clockwise downwards and upwards open circle arrows","unicode":"\uD83D\uDD03","tags":"arrows_clockwise"},{"emoji":":clock12:","description":"clock face twelve oclock","unicode":"\uD83D\uDD5B","tags":"clock12"},{"emoji":":clock1230:","description":"clock face twelve-thirty","unicode":"\uD83D\uDD67","tags":"clock1230"},{"emoji":":clock1:","description":"clock face one oclock","unicode":"\uD83D\uDD50","tags":"clock1"},{"emoji":":clock130:","description":"clock face one-thirty","unicode":"\uD83D\uDD5C","tags":"clock130"},{"emoji":":clock2:","description":"clock face two oclock","unicode":"\uD83D\uDD51","tags":"clock2"},{"emoji":":clock230:","description":"clock face two-thirty","unicode":"\uD83D\uDD5D","tags":"clock230"},{"emoji":":clock3:","description":"clock face three oclock","unicode":"\uD83D\uDD52","tags":"clock3"},{"emoji":":clock330:","description":"clock face three-thirty","unicode":"\uD83D\uDD5E","tags":"clock330"},{"emoji":":clock4:","description":"clock face four oclock","unicode":"\uD83D\uDD53","tags":"clock4"},{"emoji":":clock430:","description":"clock face four-thirty","unicode":"\uD83D\uDD5F","tags":"clock430"},{"emoji":":clock5:","description":"clock face five oclock","unicode":"\uD83D\uDD54","tags":"clock5"},{"emoji":":clock530:","description":"clock face five-thirty","unicode":"\uD83D\uDD60","tags":"clock530"},{"emoji":":clock6:","description":"clock face six oclock","unicode":"\uD83D\uDD55","tags":"clock6"},{"emoji":":clock7:","description":"clock face seven oclock","unicode":"\uD83D\uDD56","tags":"clock7"},{"emoji":":clock8:","description":"clock face eight oclock","unicode":"\uD83D\uDD57","tags":"clock8"},{"emoji":":clock9:","description":"clock face nine oclock","unicode":"\uD83D\uDD58","tags":"clock9"},{"emoji":":clock10:","description":"clock face ten oclock","unicode":"\uD83D\uDD59","tags":"clock10"},{"emoji":":clock11:","description":"clock face eleven oclock","unicode":"\uD83D\uDD5A","tags":"clock11"},{"emoji":":clock630:","description":"clock face six-thirty","unicode":"\uD83D\uDD61","tags":"clock630"},{"emoji":":clock730:","description":"clock face seven-thirty","unicode":"\uD83D\uDD62","tags":"clock730"},{"emoji":":clock830:","description":"clock face eight-thirty","unicode":"\uD83D\uDD63","tags":"clock830"},{"emoji":":clock930:","description":"clock face nine-thirty","unicode":"\uD83D\uDD64","tags":"clock930"},{"emoji":":clock1030:","description":"clock face ten-thirty","unicode":"\uD83D\uDD65","tags":"clock1030"},{"emoji":":clock1130:","description":"clock face eleven-thirty","unicode":"\uD83D\uDD66","tags":"clock1130"},{"emoji":":heavy_multiplication_x:","description":"heavy multiplication x","unicode":"\u2716\uFE0F","tags":"heavy_multiplication_x"},{"emoji":":heavy_plus_sign:","description":"heavy plus sign","unicode":"\u2795","tags":"heavy_plus_sign"},{"emoji":":heavy_minus_sign:","description":"heavy minus sign","unicode":"\u2796","tags":"heavy_minus_sign"},{"emoji":":heavy_division_sign:","description":"heavy division sign","unicode":"\u2797","tags":"heavy_division_sign"},{"emoji":":spades:","description":"black spade suit","unicode":"\u2660\uFE0F","tags":"spades"},{"emoji":":hearts:","description":"black heart suit","unicode":"\u2665\uFE0F","tags":"hearts"},{"emoji":":clubs:","description":"black club suit","unicode":"\u2663\uFE0F","tags":"clubs"},{"emoji":":diamonds:","description":"black diamond suit","unicode":"\u2666\uFE0F","tags":"diamonds"},{"emoji":":white_flower:","description":"white flower","unicode":"\uD83D\uDCAE","tags":"white_flower"},{"emoji":":100:","description":"hundred points symbol","unicode":"\uD83D\uDCAF","tags":"score:perfect:100"},{"emoji":":heavy_check_mark:","description":"heavy check mark","unicode":"\u2714\uFE0F","tags":"heavy_check_mark"},{"emoji":":ballot_box_with_check:","description":"ballot box with check","unicode":"\u2611\uFE0F","tags":"ballot_box_with_check"},{"emoji":":radio_button:","description":"radio button","unicode":"\uD83D\uDD18","tags":"radio_button"},{"emoji":":link:","description":"link symbol","unicode":"\uD83D\uDD17","tags":"link"},{"emoji":":curly_loop:","description":"curly loop","unicode":"\u27B0","tags":"curly_loop"},{"emoji":":wavy_dash:","description":"wavy dash","unicode":"\u3030\uFE0F","tags":"wavy_dash"},{"emoji":":part_alternation_mark:","description":"part alternation mark","unicode":"\u303D\uFE0F","tags":"part_alternation_mark"},{"emoji":":trident:","description":"trident emblem","unicode":"\uD83D\uDD31","tags":"trident"},{"emoji":":black_medium_square:","description":"black medium square","unicode":"\u25FC\uFE0F","tags":"black_medium_square"},{"emoji":":white_medium_square:","description":"white medium square","unicode":"\u25FB\uFE0F","tags":"white_medium_square"},{"emoji":":black_medium_small_square:","description":"black medium small square","unicode":"\u25FE","tags":"black_medium_small_square"},{"emoji":":white_medium_small_square:","description":"white medium small square","unicode":"\u25FD","tags":"white_medium_small_square"},{"emoji":":black_small_square:","description":"black small square","unicode":"\u25AA\uFE0F","tags":"black_small_square"},{"emoji":":white_small_square:","description":"white small square","unicode":"\u25AB\uFE0F","tags":"white_small_square"},{"emoji":":small_red_triangle:","description":"up-pointing red triangle","unicode":"\uD83D\uDD3A","tags":"small_red_triangle"},{"emoji":":black_square_button:","description":"black square button","unicode":"\uD83D\uDD32","tags":"black_square_button"},{"emoji":":white_square_button:","description":"white square button","unicode":"\uD83D\uDD33","tags":"white_square_button"},{"emoji":":black_circle:","description":"medium black circle","unicode":"\u26AB","tags":"black_circle"},{"emoji":":white_circle:","description":"medium white circle","unicode":"\u26AA","tags":"white_circle"},{"emoji":":red_circle:","description":"large red circle","unicode":"\uD83D\uDD34","tags":"red_circle"},{"emoji":":large_blue_circle:","description":"large blue circle","unicode":"\uD83D\uDD35","tags":"large_blue_circle"},{"emoji":":small_red_triangle_down:","description":"down-pointing red triangle","unicode":"\uD83D\uDD3B","tags":"small_red_triangle_down"},{"emoji":":white_large_square:","description":"white large square","unicode":"\u2B1C","tags":"white_large_square"},{"emoji":":black_large_square:","description":"black large square","unicode":"\u2B1B","tags":"black_large_square"},{"emoji":":large_orange_diamond:","description":"large orange diamond","unicode":"\uD83D\uDD36","tags":"large_orange_diamond"},{"emoji":":large_blue_diamond:","description":"large blue diamond","unicode":"\uD83D\uDD37","tags":"large_blue_diamond"},{"emoji":":small_orange_diamond:","description":"small orange diamond","unicode":"\uD83D\uDD38","tags":"small_orange_diamond"},{"emoji":":small_blue_diamond:","description":"small blue diamond","unicode":"\uD83D\uDD39","tags":"small_blue_diamond"},{"emoji":":basecamp:","description":"","unicode":"","tags":"basecamp"},{"emoji":":basecampy:","description":"","unicode":"","tags":"basecampy"},{"emoji":":bowtie:","description":"","unicode":"","tags":"bowtie"},{"emoji":":feelsgood:","description":"","unicode":"","tags":"feelsgood"},{"emoji":":finnadie:","description":"","unicode":"","tags":"finnadie"},{"emoji":":fu:","description":"","unicode":"","tags":"fu"},{"emoji":":goberserk:","description":"","unicode":"","tags":"goberserk"},{"emoji":":godmode:","description":"","unicode":"","tags":"godmode"},{"emoji":":hurtrealbad:","description":"","unicode":"","tags":"hurtrealbad"},{"emoji":":metal:","description":"","unicode":"","tags":"metal"},{"emoji":":neckbeard:","description":"","unicode":"","tags":"neckbeard"},{"emoji":":octocat:","description":"","unicode":"","tags":"octocat"},{"emoji":":rage1:","description":"","unicode":"","tags":"rage1"},{"emoji":":rage2:","description":"","unicode":"","tags":"rage2"},{"emoji":":rage3:","description":"","unicode":"","tags":"rage3"},{"emoji":":rage4:","description":"","unicode":"","tags":"rage4"},{"emoji":":shipit:","description":"","unicode":"","tags":"shipit:squirrel"},{"emoji":":suspect:","description":"","unicode":"","tags":"suspect"},{"emoji":":taco:","description":"","unicode":"","tags":"taco"},{"emoji":":trollface:","description":"","unicode":"","tags":"trollface"}]}');



var $15e68953533d80b1$exports = {};
"use strict";
$15e68953533d80b1$exports = function() {
    function _min(d0, d1, d2, bx, ay) {
        return d0 < d1 || d2 < d1 ? d0 > d2 ? d2 + 1 : d0 + 1 : bx === ay ? d1 : d1 + 1;
    }
    return function(a, b) {
        if (a === b) return 0;
        if (a.length > b.length) {
            var tmp = a;
            a = b;
            b = tmp;
        }
        var la = a.length;
        var lb = b.length;
        while(la > 0 && a.charCodeAt(la - 1) === b.charCodeAt(lb - 1)){
            la--;
            lb--;
        }
        var offset = 0;
        while(offset < la && a.charCodeAt(offset) === b.charCodeAt(offset))offset++;
        la -= offset;
        lb -= offset;
        if (la === 0 || lb < 3) return lb;
        var x = 0;
        var y;
        var d0;
        var d1;
        var d2;
        var d3;
        var dd;
        var dy;
        var ay;
        var bx0;
        var bx1;
        var bx2;
        var bx3;
        var vector = [];
        for(y = 0; y < la; y++){
            vector.push(y + 1);
            vector.push(a.charCodeAt(offset + y));
        }
        var len = vector.length - 1;
        for(; x < lb - 3;){
            bx0 = b.charCodeAt(offset + (d0 = x));
            bx1 = b.charCodeAt(offset + (d1 = x + 1));
            bx2 = b.charCodeAt(offset + (d2 = x + 2));
            bx3 = b.charCodeAt(offset + (d3 = x + 3));
            dd = x += 4;
            for(y = 0; y < len; y += 2){
                dy = vector[y];
                ay = vector[y + 1];
                d0 = _min(dy, d0, d1, bx0, ay);
                d1 = _min(d0, d1, d2, bx1, ay);
                d2 = _min(d1, d2, d3, bx2, ay);
                dd = _min(d2, d3, dd, bx3, ay);
                vector[y] = dd;
                d3 = d2;
                d2 = d1;
                d1 = d0;
                d0 = dy;
            }
        }
        for(; x < lb;){
            bx0 = b.charCodeAt(offset + (d0 = x));
            dd = ++x;
            for(y = 0; y < len; y += 2){
                dy = vector[y];
                vector[y] = dd = _min(dy, d0, dd, bx0, vector[y + 1]);
                d0 = dy;
            }
        }
        return dd;
    };
}();



/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $3baabda811939da5$export$9ba3b3f20a85bfa = {
    ATTRIBUTE: 1,
    CHILD: 2,
    PROPERTY: 3,
    BOOLEAN_ATTRIBUTE: 4,
    EVENT: 5,
    ELEMENT: 6
}, $3baabda811939da5$export$99b43ad1ed32e735 = (t)=>(...e)=>({
            _$litDirective$: t,
            values: e
        });
class $3baabda811939da5$export$befdefbdce210f91 {
    constructor(t){}
    get _$AU() {
        return this._$AM._$AU;
    }
    _$AT(t, e, i) {
        this._$Ct = t, this._$AM = e, this._$Ci = i;
    }
    _$AS(t, e) {
        return this.update(t, e);
    }
    update(t, e) {
        return this.render(...e);
    }
}


/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ class $0c76f114343011b1$export$3bebd1f0e3943985 extends (0, $3baabda811939da5$export$befdefbdce210f91) {
    constructor(i){
        if (super(i), this.it = (0, $e5ed8027d647799b$export$45b790e32b2810ee), i.type !== (0, $3baabda811939da5$export$9ba3b3f20a85bfa).CHILD) throw Error(this.constructor.directiveName + "() can only be used in child bindings");
    }
    render(r) {
        if (r === (0, $e5ed8027d647799b$export$45b790e32b2810ee) || null == r) return this._t = void 0, this.it = r;
        if (r === (0, $e5ed8027d647799b$export$9c068ae9cc5db4e8)) return r;
        if ("string" != typeof r) throw Error(this.constructor.directiveName + "() called with a non-string value");
        if (r === this.it) return this._t;
        this.it = r;
        const s = [
            r
        ];
        return s.raw = s, this._t = {
            _$litType$: this.constructor.resultType,
            strings: s,
            values: []
        };
    }
}
$0c76f114343011b1$export$3bebd1f0e3943985.directiveName = "unsafeHTML", $0c76f114343011b1$export$3bebd1f0e3943985.resultType = 1;
const $0c76f114343011b1$export$b6e69390c23686fb = (0, $3baabda811939da5$export$99b43ad1ed32e735)($0c76f114343011b1$export$3bebd1f0e3943985);


/**
 * @license
 * Copyright 2021 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ function $5478b4ac633a513e$export$a55877ca9db47377(n, r, t) {
    return n ? r(n) : t?.(n);
}



const $de064369f8323ce1$var$largestWord = (str)=>{
    return str.split(" ").reduce((largest, currentWord)=>{
        return currentWord.length > largest.length ? currentWord : largest;
    }, "");
};
// Example usage:
console.log($de064369f8323ce1$var$largestWord("The quick brown fox jumps over the lazy dog")); // Output: "jumps"
const $de064369f8323ce1$export$7ed1367e7fa1ad68 = {
    flame: (0, $e5ed8027d647799b$export$c0bb0b647f701bb5)`<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512">
    <!--!Font Awesome Free 6.5.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2024 Fonticons, Inc.-->
    <path
      d="M159.3 5.4c7.8-7.3 19.9-7.2 27.7 .1c27.6 25.9 53.5 53.8 77.7 84c11-14.4 23.5-30.1 37-42.9c7.9-7.4 20.1-7.4 28 .1c34.6 33 63.9 76.6 84.5 118c20.3 40.8 33.8 82.5 33.8 111.9C448 404.2 348.2 512 224 512C98.4 512 0 404.1 0 276.5c0-38.4 17.8-85.3 45.4-131.7C73.3 97.7 112.7 48.6 159.3 5.4zM225.7 416c25.3 0 47.7-7 68.8-21c42.1-29.4 53.4-88.2 28.1-134.4c-4.5-9-16-9.6-22.5-2l-25.2 29.3c-6.6 7.6-18.5 7.4-24.7-.5c-16.5-21-46-58.5-62.8-79.8c-6.3-8-18.3-8.1-24.7-.1c-33.8 42.5-50.8 69.3-50.8 99.4C112 375.4 162.6 416 225.7 416z"
    />
  </svg>`,
    refresh: (0, $e5ed8027d647799b$export$c0bb0b647f701bb5)`<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
    <!--!Font Awesome Free 6.5.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2024 Fonticons, Inc.-->
    <path
      d="M142.9 142.9c62.2-62.2 162.7-62.5 225.3-1L327 183c-6.9 6.9-8.9 17.2-5.2 26.2s12.5 14.8 22.2 14.8H463.5c0 0 0 0 0 0H472c13.3 0 24-10.7 24-24V72c0-9.7-5.8-18.5-14.8-22.2s-19.3-1.7-26.2 5.2L413.4 96.6c-87.6-86.5-228.7-86.2-315.8 1C73.2 122 55.6 150.7 44.8 181.4c-5.9 16.7 2.9 34.9 19.5 40.8s34.9-2.9 40.8-19.5c7.7-21.8 20.2-42.3 37.8-59.8zM16 312v7.6 .7V440c0 9.7 5.8 18.5 14.8 22.2s19.3 1.7 26.2-5.2l41.6-41.6c87.6 86.5 228.7 86.2 315.8-1c24.4-24.4 42.1-53.1 52.9-83.7c5.9-16.7-2.9-34.9-19.5-40.8s-34.9 2.9-40.8 19.5c-7.7 21.8-20.2 42.3-37.8 59.8c-62.2 62.2-162.7 62.5-225.3 1L185 329c6.9-6.9 8.9-17.2 5.2-26.2s-12.5-14.8-22.2-14.8H48.4h-.7H40c-13.3 0-24 10.7-24 24z"
    />
  </svg>`,
    qr: (0, $e5ed8027d647799b$export$c0bb0b647f701bb5)`<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512">
    <!--!Font Awesome Free 6.5.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2024 Fonticons, Inc.-->
    <path
      d="M0 80C0 53.5 21.5 32 48 32h96c26.5 0 48 21.5 48 48v96c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V80zM64 96v64h64V96H64zM0 336c0-26.5 21.5-48 48-48h96c26.5 0 48 21.5 48 48v96c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V336zm64 16v64h64V352H64zM304 32h96c26.5 0 48 21.5 48 48v96c0 26.5-21.5 48-48 48H304c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48zm80 64H320v64h64V96zM256 304c0-8.8 7.2-16 16-16h64c8.8 0 16 7.2 16 16s7.2 16 16 16h32c8.8 0 16-7.2 16-16s7.2-16 16-16s16 7.2 16 16v96c0 8.8-7.2 16-16 16H368c-8.8 0-16-7.2-16-16s-7.2-16-16-16s-16 7.2-16 16v64c0 8.8-7.2 16-16 16H272c-8.8 0-16-7.2-16-16V304zM368 480a16 16 0 1 1 0-32 16 16 0 1 1 0 32zm64 0a16 16 0 1 1 0-32 16 16 0 1 1 0 32z"
    />
  </svg>`,
    merge: (0, $e5ed8027d647799b$export$c0bb0b647f701bb5)`<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512">
    <!--!Font Awesome Free 6.5.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2024 Fonticons, Inc.-->
    <path
      d="M80 56a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm32.4 97.2c28-12.4 47.6-40.5 47.6-73.2c0-44.2-35.8-80-80-80S0 35.8 0 80c0 32.8 19.7 61 48 73.3V358.7C19.7 371 0 399.2 0 432c0 44.2 35.8 80 80 80s80-35.8 80-80c0-32.8-19.7-61-48-73.3V272c26.7 20.1 60 32 96 32h86.7c12.3 28.3 40.5 48 73.3 48c44.2 0 80-35.8 80-80s-35.8-80-80-80c-32.8 0-61 19.7-73.3 48H208c-49.9 0-91-38.1-95.6-86.8zM80 408a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM344 272a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z"
    />
  </svg>`,
    share: (0, $e5ed8027d647799b$export$c0bb0b647f701bb5)`<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
    <!--!Font Awesome Free 6.5.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2024 Fonticons, Inc.-->
    <path
      d="M307 34.8c-11.5 5.1-19 16.6-19 29.2v64H176C78.8 128 0 206.8 0 304C0 417.3 81.5 467.9 100.2 478.1c2.5 1.4 5.3 1.9 8.1 1.9c10.9 0 19.7-8.9 19.7-19.7c0-7.5-4.3-14.4-9.8-19.5C108.8 431.9 96 414.4 96 384c0-53 43-96 96-96h96v64c0 12.6 7.4 24.1 19 29.2s25 3 34.4-5.4l160-144c6.7-6.1 10.6-14.7 10.6-23.8s-3.8-17.7-10.6-23.8l-160-144c-9.4-8.5-22.9-10.6-34.4-5.4z"
    />
  </svg>`,
    plus: (0, $e5ed8027d647799b$export$c0bb0b647f701bb5)`<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512">
    <!--!Font Awesome Free 6.5.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2024 Fonticons, Inc.-->
    <path
      d="M256 80c0-17.7-14.3-32-32-32s-32 14.3-32 32V224H48c-17.7 0-32 14.3-32 32s14.3 32 32 32H192V432c0 17.7 14.3 32 32 32s32-14.3 32-32V288H400c17.7 0 32-14.3 32-32s-14.3-32-32-32H256V80z"
    />
  </svg>`,
    minus: (0, $e5ed8027d647799b$export$c0bb0b647f701bb5)`<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512">
    <!--!Font Awesome Free 6.5.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2024 Fonticons, Inc.-->
    <path
      d="M432 256c0 17.7-14.3 32-32 32L48 288c-17.7 0-32-14.3-32-32s14.3-32 32-32l352 0c17.7 0 32 14.3 32 32z"
    />
  </svg>`,
    gear: (0, $e5ed8027d647799b$export$c0bb0b647f701bb5)`<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
    <!--!Font Awesome Free 6.5.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2024 Fonticons, Inc.-->
    <path
      d="M495.9 166.6c3.2 8.7 .5 18.4-6.4 24.6l-43.3 39.4c1.1 8.3 1.7 16.8 1.7 25.4s-.6 17.1-1.7 25.4l43.3 39.4c6.9 6.2 9.6 15.9 6.4 24.6c-4.4 11.9-9.7 23.3-15.8 34.3l-4.7 8.1c-6.6 11-14 21.4-22.1 31.2c-5.9 7.2-15.7 9.6-24.5 6.8l-55.7-17.7c-13.4 10.3-28.2 18.9-44 25.4l-12.5 57.1c-2 9.1-9 16.3-18.2 17.8c-13.8 2.3-28 3.5-42.5 3.5s-28.7-1.2-42.5-3.5c-9.2-1.5-16.2-8.7-18.2-17.8l-12.5-57.1c-15.8-6.5-30.6-15.1-44-25.4L83.1 425.9c-8.8 2.8-18.6 .3-24.5-6.8c-8.1-9.8-15.5-20.2-22.1-31.2l-4.7-8.1c-6.1-11-11.4-22.4-15.8-34.3c-3.2-8.7-.5-18.4 6.4-24.6l43.3-39.4C64.6 273.1 64 264.6 64 256s.6-17.1 1.7-25.4L22.4 191.2c-6.9-6.2-9.6-15.9-6.4-24.6c4.4-11.9 9.7-23.3 15.8-34.3l4.7-8.1c6.6-11 14-21.4 22.1-31.2c5.9-7.2 15.7-9.6 24.5-6.8l55.7 17.7c13.4-10.3 28.2-18.9 44-25.4l12.5-57.1c2-9.1 9-16.3 18.2-17.8C227.3 1.2 241.5 0 256 0s28.7 1.2 42.5 3.5c9.2 1.5 16.2 8.7 18.2 17.8l12.5 57.1c15.8 6.5 30.6 15.1 44 25.4l55.7-17.7c8.8-2.8 18.6-.3 24.5 6.8c8.1 9.8 15.5 20.2 22.1 31.2l4.7 8.1c6.1 11 11.4 22.4 15.8 34.3zM256 336a80 80 0 1 0 0-160 80 80 0 1 0 0 160z"
    />
  </svg>`,
    up: (0, $e5ed8027d647799b$export$c0bb0b647f701bb5)`<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512">
    <!--!Font Awesome Free 6.5.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2024 Fonticons, Inc.-->
    <path
      d="M318 177.5c3.8-8.8 2-19-4.6-26l-136-144C172.9 2.7 166.6 0 160 0s-12.9 2.7-17.4 7.5l-136 144c-6.6 7-8.4 17.2-4.6 26S14.4 192 24 192H96l0 288c0 17.7 14.3 32 32 32h64c17.7 0 32-14.3 32-32l0-288h72c9.6 0 18.2-5.7 22-14.5z"
    />
  </svg>`,
    down: (0, $e5ed8027d647799b$export$c0bb0b647f701bb5)`<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512">
    <!--!Font Awesome Free 6.5.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2024 Fonticons, Inc.-->
    <path
      d="M2 334.5c-3.8 8.8-2 19 4.6 26l136 144c4.5 4.8 10.8 7.5 17.4 7.5s12.9-2.7 17.4-7.5l136-144c6.6-7 8.4-17.2 4.6-26s-12.5-14.5-22-14.5l-72 0 0-288c0-17.7-14.3-32-32-32L128 0C110.3 0 96 14.3 96 32l0 288-72 0c-9.6 0-18.2 5.7-22 14.5z"
    />
  </svg>`,
    rotate: (0, $e5ed8027d647799b$export$c0bb0b647f701bb5)`<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
    <!--!Font Awesome Free 6.5.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2024 Fonticons, Inc.-->
    <path
      d="M142.9 142.9c62.2-62.2 162.7-62.5 225.3-1L327 183c-6.9 6.9-8.9 17.2-5.2 26.2s12.5 14.8 22.2 14.8H463.5c0 0 0 0 0 0H472c13.3 0 24-10.7 24-24V72c0-9.7-5.8-18.5-14.8-22.2s-19.3-1.7-26.2 5.2L413.4 96.6c-87.6-86.5-228.7-86.2-315.8 1C73.2 122 55.6 150.7 44.8 181.4c-5.9 16.7 2.9 34.9 19.5 40.8s34.9-2.9 40.8-19.5c7.7-21.8 20.2-42.3 37.8-59.8zM16 312v7.6 .7V440c0 9.7 5.8 18.5 14.8 22.2s19.3 1.7 26.2-5.2l41.6-41.6c87.6 86.5 228.7 86.2 315.8-1c24.4-24.4 42.1-53.1 52.9-83.7c5.9-16.7-2.9-34.9-19.5-40.8s-34.9 2.9-40.8 19.5c-7.7 21.8-20.2 42.3-37.8 59.8c-62.2 62.2-162.7 62.5-225.3 1L185 329c6.9-6.9 8.9-17.2 5.2-26.2s-12.5-14.8-22.2-14.8H48.4h-.7H40c-13.3 0-24 10.7-24 24z"
    />
  </svg>`,
    clipboard: (0, $e5ed8027d647799b$export$c0bb0b647f701bb5)`<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512">
    <!--!Font Awesome Free 6.5.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2024 Fonticons, Inc.-->
    <path
      d="M280 64h40c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V128C0 92.7 28.7 64 64 64h40 9.6C121 27.5 153.3 0 192 0s71 27.5 78.4 64H280zM64 112c-8.8 0-16 7.2-16 16V448c0 8.8 7.2 16 16 16H320c8.8 0 16-7.2 16-16V128c0-8.8-7.2-16-16-16H304v24c0 13.3-10.7 24-24 24H192 104c-13.3 0-24-10.7-24-24V112H64zm128-8a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"
    />
  </svg>`
};
const $de064369f8323ce1$var$shareUrl = (items)=>{
    const url = new URL(window.location.pathname, window.location.origin);
    url.hash = JSON.stringify(items);
    return url.toString();
};
const $de064369f8323ce1$var$trs = {
    merge: "Merge",
    appTitle: "Top List \uD83C\uDF52",
    newItem: "New Item",
    addItem: "Add Item",
    listActions: "List",
    Settings: "Settings",
    updateApp: "Update",
    clearLists: "Clear",
    remove: "Remove",
    newList: "New List",
    shareList: "Share",
    qrShareList: "QR Share",
    add: "Add",
    raise: "Swap"
};
const $de064369f8323ce1$var$emojiByTag = (0, (/*@__PURE__*/$parcel$interopDefault($accdb25a2f5abdb6$exports))).names.reduce((acc, name)=>{
    name.tags.split(":").forEach((tag)=>{
        acc.push([
            tag,
            name
        ]);
    });
    return acc;
}, []);
const $de064369f8323ce1$var$someEmoji = (0, $9oYre.memoize)((value)=>{
    if (!value) return null;
    return (0, $9oYre.findMax)(([tag])=>{
        return -(0, (/*@__PURE__*/$parcel$interopDefault($15e68953533d80b1$exports)))(tag, $de064369f8323ce1$var$largestWord(value));
    }, $de064369f8323ce1$var$emojiByTag)[1].unicode;
});
const $de064369f8323ce1$var$must = (x, elseFn)=>(0, $9oYre.isNil)(x) ? elseFn() : x;
const $de064369f8323ce1$var$tr = (key)=>$de064369f8323ce1$var$must($de064369f8323ce1$var$trs[key], ()=>{
        throw new Error(`Translation for "${key}" does not exist`);
    });
const $de064369f8323ce1$var$nameSymbol = Symbol("name");
const $de064369f8323ce1$var$emitAction = (name, detail = {})=>(event)=>{
        // Replacing with the user action thing.
        event.preventDefault();
        event.stopPropagation();
        const customEvent = new CustomEvent("action", {
            bubbles: true,
            detail: detail
        });
        // TODO: use Symbol to prevent overwriting name property.
        customEvent[$de064369f8323ce1$var$nameSymbol] = name;
        event.target.dispatchEvent(customEvent);
    };
const $de064369f8323ce1$export$722ebe4eb96a2bb = (actions)=>function(event) {
        this.querySelectorAll("details").forEach((details)=>{
            details.open = false;
        });
        // Dispatch based on name
        const name = event[$de064369f8323ce1$var$nameSymbol];
        if ((0, $9oYre.isNil)(actions[name])) throw new Error(`No handler defined for event "${name}".`);
        actions[name](event);
    };
const $de064369f8323ce1$export$fd03bb7ef77feb72 = {
    app: (vm, actions)=>(0, $e5ed8027d647799b$export$c0bb0b647f701bb5)`
    <div @action=${$de064369f8323ce1$export$722ebe4eb96a2bb(actions)}>
      <details>
        <summary>${$de064369f8323ce1$var$tr("Settings")}</summary>

        ${$de064369f8323ce1$export$fd03bb7ef77feb72.action(vm, "updateApp", $de064369f8323ce1$export$7ed1367e7fa1ad68.refresh)}
        ${$de064369f8323ce1$export$fd03bb7ef77feb72.action(vm, "clearLists", $de064369f8323ce1$export$7ed1367e7fa1ad68.flame)}
      </details>
      ${$de064369f8323ce1$export$fd03bb7ef77feb72.lists(vm)}
    </div>
  `,
    action: (vm, name, svg = null)=>(0, $e5ed8027d647799b$export$c0bb0b647f701bb5)`<button class="action" @click=${$de064369f8323ce1$var$emitAction(`${name}Action`, vm)}>
      ${svg} ${$de064369f8323ce1$var$tr(name)}
    </button>`,
    anchor: (vm, name, svg = null)=>(0, $e5ed8027d647799b$export$c0bb0b647f701bb5)` <a
      href="${$de064369f8323ce1$var$shareUrl(vm.items)}"
      class="button action"
      @click="${$de064369f8323ce1$var$emitAction(`${name}Action`, vm)}"
    >
      ${svg} ${$de064369f8323ce1$var$tr(name)}
    </a>`,
    actionsCommon: (vm)=>null,
    actionsToplist: (vm)=>$de064369f8323ce1$export$fd03bb7ef77feb72.action(vm, "remove", $de064369f8323ce1$export$7ed1367e7fa1ad68.minus),
    actionsNotToplist: (vm)=>$de064369f8323ce1$export$fd03bb7ef77feb72.action(vm, "add", $de064369f8323ce1$export$7ed1367e7fa1ad68.plus),
    actions: (vm)=>[
            $de064369f8323ce1$export$fd03bb7ef77feb72.actionsCommon(vm),
            vm.isTopList ? $de064369f8323ce1$export$fd03bb7ef77feb72.actionsToplist(vm) : $de064369f8323ce1$export$fd03bb7ef77feb72.actionsNotToplist(vm)
        ],
    item: (vm)=>(item, itemIndex)=>{
            vm = {
                ...vm,
                itemIndex: itemIndex,
                item: item
            };
            return (0, $e5ed8027d647799b$export$c0bb0b647f701bb5)`<li class="list-item">
      <details>
        <summary>
          ${(0, $0c76f114343011b1$export$b6e69390c23686fb)((0, $238583bf201af313$export$2e2bcd8739ae039)(item, {
                target: "_blank"
            }))}
          ${$de064369f8323ce1$var$someEmoji(item)}
        </summary>
        ${$de064369f8323ce1$export$fd03bb7ef77feb72.actions(vm)}
      </details>
    </li>`;
        },
    items: (vm)=>vm.items.map($de064369f8323ce1$export$fd03bb7ef77feb72.item(vm)),
    list: (vm)=>(list, listIndex)=>{
            vm = {
                ...vm,
                ...list,
                isTopList: (0, $9oYre.isNil)(listIndex) ? vm.isTopList : listIndex === 0,
                listIndex: listIndex
            };
            return (0, $e5ed8027d647799b$export$c0bb0b647f701bb5)`<article class="list">
      ${(0, $5478b4ac633a513e$export$a55877ca9db47377)(vm.isTopList, ()=>(0, $e5ed8027d647799b$export$c0bb0b647f701bb5)` <h1 id="toplist">${$de064369f8323ce1$var$tr("appTitle")}</h1>
            <form @submit="${$de064369f8323ce1$var$emitAction("addItem", vm)}">
              <label>${$de064369f8323ce1$var$tr("newItem")}</label>
              <input required id="addItemInput" />
              <input type="submit" value="${$de064369f8323ce1$var$tr("addItem")}" />
            </form>`)}

      <ul>
        ${$de064369f8323ce1$export$fd03bb7ef77feb72.items(vm)}
      </ul>
      <details>
        <summary>${$de064369f8323ce1$var$tr("listActions")}</summary>

        <div class="actions">
          ${(0, $5478b4ac633a513e$export$a55877ca9db47377)(vm.isTopList, ()=>$de064369f8323ce1$export$fd03bb7ef77feb72.action(vm, "newList", $de064369f8323ce1$export$7ed1367e7fa1ad68.plus))}
          ${(0, $5478b4ac633a513e$export$a55877ca9db47377)(!vm.isTopList, ()=>[
                    $de064369f8323ce1$export$fd03bb7ef77feb72.action(vm, "merge", $de064369f8323ce1$export$7ed1367e7fa1ad68.merge),
                    $de064369f8323ce1$export$fd03bb7ef77feb72.action(vm, "raise", $de064369f8323ce1$export$7ed1367e7fa1ad68.up)
                ])}
          ${$de064369f8323ce1$export$fd03bb7ef77feb72.anchor(vm, "shareList", $de064369f8323ce1$export$7ed1367e7fa1ad68.share)}
          ${$de064369f8323ce1$export$fd03bb7ef77feb72.anchor(vm, "qrShareList", $de064369f8323ce1$export$7ed1367e7fa1ad68.qr)}
        </div>
      </details>
    </article> `;
        },
    lists: (vm)=>vm.lists.map($de064369f8323ce1$export$fd03bb7ef77feb72.list(vm))
};


const $06aa54ee98585222$var$openQRCode = (event)=>{
    const url = event.target.href;
    const qrcode = new (0, (/*@__PURE__*/$parcel$interopDefault($7be1938ba9eee7d1$exports)))({
        content: url,
        container: "svg-viewbox",
        join: true
    });
    const svg = qrcode.svg();
    document.getElementById("qr-code").innerHTML = svg;
    window.qrCodeDialog.showModal();
};
// RENDER ERRORS
const $06aa54ee98585222$var$rendered = Symbol("rendered");
function $06aa54ee98585222$var$renderError(error) {
    (0, $e5ed8027d647799b$export$b3890eb0ae9dca99)((0, $e5ed8027d647799b$export$c0bb0b647f701bb5)`
      <p class="notice notice--assertive">
        ${error?.message ?? "An unknown error occurred."}
        <button @click=${$06aa54ee98585222$var$clearCache}>Hard Refresh App</button>
      </p>
    `, window.error);
}
window.addEventListener("unhandledrejection", function(event) {
    $06aa54ee98585222$var$renderError(event);
    console.error(event);
});
window.addEventListener("error", (event)=>{
    if (event[$06aa54ee98585222$var$rendered]) return;
    event[$06aa54ee98585222$var$rendered] = true;
    $06aa54ee98585222$var$renderError(event);
    throw event;
}, true);


// RENDER ERRORS
(async function initialize() {
    if (window.localStorage.version !== (0, $8f13b60c0ee5b277$exports.version)) {
        const { migrate: migrate } = await (parcelRequire("fhlbu"));
        const { migrations: migrations } = await (parcelRequire("6xxtQ"));
        await migrate(migrations(), window.localStorage.version, (0, $8f13b60c0ee5b277$exports.version));
    }
})();
let $06aa54ee98585222$var$data;
const $06aa54ee98585222$var$raiseArchived = (index)=>{
    $06aa54ee98585222$var$data.lists = (0, $9oYre.moveItemToTop)($06aa54ee98585222$var$data.lists, index);
    window.toplist.scrollIntoView();
    $06aa54ee98585222$var$rerender();
};
try {
    if (!localStorage.data) throw new Error("Not in localStorage.data");
    $06aa54ee98585222$var$data = JSON.parse(localStorage.data);
} catch (error) {
    localStorage.removeItem("data");
    $06aa54ee98585222$var$data = {
        lists: []
    };
}
const $06aa54ee98585222$var$newList = ()=>({
        created: new Date().toISOString(),
        items: []
    });
$06aa54ee98585222$var$data.lists[0] = $06aa54ee98585222$var$data.lists[0] ?? $06aa54ee98585222$var$newList();
const $06aa54ee98585222$var$mergeItems = (items)=>()=>{
        window.dialog?.close();
        $06aa54ee98585222$var$data.lists[0].items.push(...items);
        $06aa54ee98585222$var$rerender();
    };
const $06aa54ee98585222$var$onListItemClick = ({ target: target, detail: { itemIndex: index, isTopList: isTopList } })=>{
    // Should remove when in the top list.
    if (isTopList) $06aa54ee98585222$var$data.lists[0].items.splice(index, 1);
    else $06aa54ee98585222$var$data.lists[0].items.unshift(target.value);
    $06aa54ee98585222$var$rerender();
};
const $06aa54ee98585222$var$listItems = (isTopList)=>(items)=>items.map(listItem(isTopList));
const $06aa54ee98585222$var$createList = (event)=>{
    if ($06aa54ee98585222$var$data.lists[0].items.length === 0) {
        window.toplist.scrollIntoView();
        window.addItemInput.focus();
        return;
    }
    $06aa54ee98585222$var$data.lists.unshift($06aa54ee98585222$var$newList());
    window.toplist.scrollIntoView();
    $06aa54ee98585222$var$rerender();
};
const $06aa54ee98585222$var$addItem = (event)=>{
    event.preventDefault();
    const input = event.target.querySelector("input");
    $06aa54ee98585222$var$data.lists[0].items.unshift(input.value);
    input.value = "";
    $06aa54ee98585222$var$rerender();
};
const $06aa54ee98585222$var$clipboard = async (text)=>{
    if (navigator.clipboard && navigator.clipboard.writeText) try {
        await navigator.clipboard.writeText(text);
        console.log("Text successfully copied to clipboard");
    } catch (err) {
        console.error("Failed to copy text using Clipboard API: ", err);
        $06aa54ee98585222$var$fallbackCopyTextToClipboard(text);
    }
    else {
        console.warn("Clipboard API not supported. Falling back to prompt.");
        $06aa54ee98585222$var$fallbackCopyTextToClipboard(text);
    }
};
const $06aa54ee98585222$var$fallbackCopyTextToClipboard = (text)=>{
    try {
        // Prompt the user to copy the text manually
        prompt("Copy the text below:", text);
        console.log("Text successfully copied to clipboard via prompt");
    } catch (err) {
        console.error("Failed to copy text via prompt: ", err);
    }
};
const $06aa54ee98585222$var$download = (items)=>()=>{
        alert("download");
    };
const $06aa54ee98585222$var$copy = (items)=>()=>{
        alert("copy");
    };
const $06aa54ee98585222$var$clearCache = async ()=>{
    if ("serviceWorker" in navigator && navigator.serviceWorker.controller) {
        const registration = await navigator.serviceWorker.ready;
        const serviceWorker = registration.active;
        serviceWorker.postMessage({
            action: "clearCache"
        });
    }
    setTimeout(()=>location.reload(), 200);
};
const $06aa54ee98585222$var$share = (event)=>{
    $06aa54ee98585222$var$clipboard(event.target.href);
};
const $06aa54ee98585222$var$lists = (isTopList)=>(lists)=>lists.filter(({ items: items })=>isTopList || (0, $9oYre.isNotEmpty)(items)).map(list(isTopList));
const $06aa54ee98585222$var$actions = {
    addItem: $06aa54ee98585222$var$addItem,
    mergeAction: (event)=>$06aa54ee98585222$var$mergeItems(event.detail.items),
    addAction (event) {
        $06aa54ee98585222$var$data.lists[0].items.unshift(event.detail.item);
        $06aa54ee98585222$var$rerender();
    },
    removeAction: (event)=>$06aa54ee98585222$var$onListItemClick(event),
    shareListAction: $06aa54ee98585222$var$share,
    newListAction: $06aa54ee98585222$var$createList,
    updateAppAction: $06aa54ee98585222$var$clearCache,
    raiseAction: (event)=>{
        $06aa54ee98585222$var$raiseArchived(event.detail.listIndex);
    },
    qrShareListAction: $06aa54ee98585222$var$openQRCode,
    clearListsAction () {
        if (confirm("Are you sure you want to delete all lists?")) {
            localStorage.clear();
            location.reload();
        }
    }
};
function $06aa54ee98585222$var$rerender() {
    // Filter out empty lists besides the toplist.
    $06aa54ee98585222$var$data.lists = $06aa54ee98585222$var$data.lists.filter((list1, index)=>index === 0 || (0, $9oYre.isNotEmpty)(list1.items));
    localStorage.data = JSON.stringify($06aa54ee98585222$var$data);
    (0, $e5ed8027d647799b$export$b3890eb0ae9dca99)((0, $de064369f8323ce1$export$fd03bb7ef77feb72).app($06aa54ee98585222$var$data, $06aa54ee98585222$var$actions), window.app);
}
$06aa54ee98585222$var$rerender();
var $eeb0a45253db3d34$exports = {};
$eeb0a45253db3d34$exports = new URL("service-worker.js", import.meta.url).toString();


(0, $9oYre.tryReject)(async function() {
    if ("serviceWorker" in navigator) try {
        const registration = await navigator.serviceWorker.register($eeb0a45253db3d34$exports);
        console.log("Service Worker registered with scope:", registration.scope);
    } catch (error) {
        console.error("Service Worker registration failed:", error);
    }
    const url = new URL(window.location.href);
    const append = url.searchParams.get("append");
    const items = (0, $9oYre.tryCatch)(()=>{
        return append ? JSON.parse(append) : JSON.parse(decodeURIComponent(window.location.hash).substring(1));
    }, (error)=>{
        console.error(error);
    });
    if (items) {
        (0, $e5ed8027d647799b$export$b3890eb0ae9dca99)((0, $e5ed8027d647799b$export$c0bb0b647f701bb5)`<div @action="${(0, $de064369f8323ce1$export$722ebe4eb96a2bb)($06aa54ee98585222$var$actions)}">
        ${(0, $de064369f8323ce1$export$fd03bb7ef77feb72).list({
            isTopList: false
        })({
            items: items
        })}
      </div>`, window.preview);
        const { dialog: dialog } = window;
        dialog.showModal();
        dialog.addEventListener("close", ()=>{
            url.searchParams.delete("append");
            url.hash = "";
            window.history.replaceState(null, document.title, url.toString());
        }, {
            once: true
        });
        function onClick(event) {
            if (event.target === dialog) dialog.close();
        }
        dialog.addEventListener("click", (event)=>{
            if (event.target == dialog) dialog.close();
        }, {
            once: true
        });
        dialog.showModal();
    }
});


//# sourceMappingURL=index.74996553.js.map
